/*! jQuery v2.2.4 | (c) jQuery Foundation | jquery.org/license */
!function(a,b){"object"==typeof module&&"object"==typeof module.exports?module.exports=a.document?b(a,!0):function(a){if(!a.document)throw new Error("jQuery requires a window with a document");return b(a)}:b(a)}("undefined"!=typeof window?window:this,function(a,b){var c=[],d=a.document,e=c.slice,f=c.concat,g=c.push,h=c.indexOf,i={},j=i.toString,k=i.hasOwnProperty,l={},m="2.2.4",n=function(a,b){return new n.fn.init(a,b)},o=/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,p=/^-ms-/,q=/-([\da-z])/gi,r=function(a,b){return b.toUpperCase()};n.fn=n.prototype={jquery:m,constructor:n,selector:"",length:0,toArray:function(){return e.call(this)},get:function(a){return null!=a?0>a?this[a+this.length]:this[a]:e.call(this)},pushStack:function(a){var b=n.merge(this.constructor(),a);return b.prevObject=this,b.context=this.context,b},each:function(a){return n.each(this,a)},map:function(a){return this.pushStack(n.map(this,function(b,c){return a.call(b,c,b)}))},slice:function(){return this.pushStack(e.apply(this,arguments))},first:function(){return this.eq(0)},last:function(){return this.eq(-1)},eq:function(a){var b=this.length,c=+a+(0>a?b:0);return this.pushStack(c>=0&&b>c?[this[c]]:[])},end:function(){return this.prevObject||this.constructor()},push:g,sort:c.sort,splice:c.splice},n.extend=n.fn.extend=function(){var a,b,c,d,e,f,g=arguments[0]||{},h=1,i=arguments.length,j=!1;for("boolean"==typeof g&&(j=g,g=arguments[h]||{},h++),"object"==typeof g||n.isFunction(g)||(g={}),h===i&&(g=this,h--);i>h;h++)if(null!=(a=arguments[h]))for(b in a)c=g[b],d=a[b],g!==d&&(j&&d&&(n.isPlainObject(d)||(e=n.isArray(d)))?(e?(e=!1,f=c&&n.isArray(c)?c:[]):f=c&&n.isPlainObject(c)?c:{},g[b]=n.extend(j,f,d)):void 0!==d&&(g[b]=d));return g},n.extend({expando:"jQuery"+(m+Math.random()).replace(/\D/g,""),isReady:!0,error:function(a){throw new Error(a)},noop:function(){},isFunction:function(a){return"function"===n.type(a)},isArray:Array.isArray,isWindow:function(a){return null!=a&&a===a.window},isNumeric:function(a){var b=a&&a.toString();return!n.isArray(a)&&b-parseFloat(b)+1>=0},isPlainObject:function(a){var b;if("object"!==n.type(a)||a.nodeType||n.isWindow(a))return!1;if(a.constructor&&!k.call(a,"constructor")&&!k.call(a.constructor.prototype||{},"isPrototypeOf"))return!1;for(b in a);return void 0===b||k.call(a,b)},isEmptyObject:function(a){var b;for(b in a)return!1;return!0},type:function(a){return null==a?a+"":"object"==typeof a||"function"==typeof a?i[j.call(a)]||"object":typeof a},globalEval:function(a){var b,c=eval;a=n.trim(a),a&&(1===a.indexOf("use strict")?(b=d.createElement("script"),b.text=a,d.head.appendChild(b).parentNode.removeChild(b)):c(a))},camelCase:function(a){return a.replace(p,"ms-").replace(q,r)},nodeName:function(a,b){return a.nodeName&&a.nodeName.toLowerCase()===b.toLowerCase()},each:function(a,b){var c,d=0;if(s(a)){for(c=a.length;c>d;d++)if(b.call(a[d],d,a[d])===!1)break}else for(d in a)if(b.call(a[d],d,a[d])===!1)break;return a},trim:function(a){return null==a?"":(a+"").replace(o,"")},makeArray:function(a,b){var c=b||[];return null!=a&&(s(Object(a))?n.merge(c,"string"==typeof a?[a]:a):g.call(c,a)),c},inArray:function(a,b,c){return null==b?-1:h.call(b,a,c)},merge:function(a,b){for(var c=+b.length,d=0,e=a.length;c>d;d++)a[e++]=b[d];return a.length=e,a},grep:function(a,b,c){for(var d,e=[],f=0,g=a.length,h=!c;g>f;f++)d=!b(a[f],f),d!==h&&e.push(a[f]);return e},map:function(a,b,c){var d,e,g=0,h=[];if(s(a))for(d=a.length;d>g;g++)e=b(a[g],g,c),null!=e&&h.push(e);else for(g in a)e=b(a[g],g,c),null!=e&&h.push(e);return f.apply([],h)},guid:1,proxy:function(a,b){var c,d,f;return"string"==typeof b&&(c=a[b],b=a,a=c),n.isFunction(a)?(d=e.call(arguments,2),f=function(){return a.apply(b||this,d.concat(e.call(arguments)))},f.guid=a.guid=a.guid||n.guid++,f):void 0},now:Date.now,support:l}),"function"==typeof Symbol&&(n.fn[Symbol.iterator]=c[Symbol.iterator]),n.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "),function(a,b){i["[object "+b+"]"]=b.toLowerCase()});function s(a){var b=!!a&&"length"in a&&a.length,c=n.type(a);return"function"===c||n.isWindow(a)?!1:"array"===c||0===b||"number"==typeof b&&b>0&&b-1 in a}var t=function(a){var b,c,d,e,f,g,h,i,j,k,l,m,n,o,p,q,r,s,t,u="sizzle"+1*new Date,v=a.document,w=0,x=0,y=ga(),z=ga(),A=ga(),B=function(a,b){return a===b&&(l=!0),0},C=1<<31,D={}.hasOwnProperty,E=[],F=E.pop,G=E.push,H=E.push,I=E.slice,J=function(a,b){for(var c=0,d=a.length;d>c;c++)if(a[c]===b)return c;return-1},K="checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",L="[\\x20\\t\\r\\n\\f]",M="(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+",N="\\["+L+"*("+M+")(?:"+L+"*([*^$|!~]?=)"+L+"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|("+M+"))|)"+L+"*\\]",O=":("+M+")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|"+N+")*)|.*)\\)|)",P=new RegExp(L+"+","g"),Q=new RegExp("^"+L+"+|((?:^|[^\\\\])(?:\\\\.)*)"+L+"+$","g"),R=new RegExp("^"+L+"*,"+L+"*"),S=new RegExp("^"+L+"*([>+~]|"+L+")"+L+"*"),T=new RegExp("="+L+"*([^\\]'\"]*?)"+L+"*\\]","g"),U=new RegExp(O),V=new RegExp("^"+M+"$"),W={ID:new RegExp("^#("+M+")"),CLASS:new RegExp("^\\.("+M+")"),TAG:new RegExp("^("+M+"|[*])"),ATTR:new RegExp("^"+N),PSEUDO:new RegExp("^"+O),CHILD:new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\("+L+"*(even|odd|(([+-]|)(\\d*)n|)"+L+"*(?:([+-]|)"+L+"*(\\d+)|))"+L+"*\\)|)","i"),bool:new RegExp("^(?:"+K+")$","i"),needsContext:new RegExp("^"+L+"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\("+L+"*((?:-\\d)?\\d*)"+L+"*\\)|)(?=[^-]|$)","i")},X=/^(?:input|select|textarea|button)$/i,Y=/^h\d$/i,Z=/^[^{]+\{\s*\[native \w/,$=/^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,_=/[+~]/,aa=/'|\\/g,ba=new RegExp("\\\\([\\da-f]{1,6}"+L+"?|("+L+")|.)","ig"),ca=function(a,b,c){var d="0x"+b-65536;return d!==d||c?b:0>d?String.fromCharCode(d+65536):String.fromCharCode(d>>10|55296,1023&d|56320)},da=function(){m()};try{H.apply(E=I.call(v.childNodes),v.childNodes),E[v.childNodes.length].nodeType}catch(ea){H={apply:E.length?function(a,b){G.apply(a,I.call(b))}:function(a,b){var c=a.length,d=0;while(a[c++]=b[d++]);a.length=c-1}}}function fa(a,b,d,e){var f,h,j,k,l,o,r,s,w=b&&b.ownerDocument,x=b?b.nodeType:9;if(d=d||[],"string"!=typeof a||!a||1!==x&&9!==x&&11!==x)return d;if(!e&&((b?b.ownerDocument||b:v)!==n&&m(b),b=b||n,p)){if(11!==x&&(o=$.exec(a)))if(f=o[1]){if(9===x){if(!(j=b.getElementById(f)))return d;if(j.id===f)return d.push(j),d}else if(w&&(j=w.getElementById(f))&&t(b,j)&&j.id===f)return d.push(j),d}else{if(o[2])return H.apply(d,b.getElementsByTagName(a)),d;if((f=o[3])&&c.getElementsByClassName&&b.getElementsByClassName)return H.apply(d,b.getElementsByClassName(f)),d}if(c.qsa&&!A[a+" "]&&(!q||!q.test(a))){if(1!==x)w=b,s=a;else if("object"!==b.nodeName.toLowerCase()){(k=b.getAttribute("id"))?k=k.replace(aa,"\\$&"):b.setAttribute("id",k=u),r=g(a),h=r.length,l=V.test(k)?"#"+k:"[id='"+k+"']";while(h--)r[h]=l+" "+qa(r[h]);s=r.join(","),w=_.test(a)&&oa(b.parentNode)||b}if(s)try{return H.apply(d,w.querySelectorAll(s)),d}catch(y){}finally{k===u&&b.removeAttribute("id")}}}return i(a.replace(Q,"$1"),b,d,e)}function ga(){var a=[];function b(c,e){return a.push(c+" ")>d.cacheLength&&delete b[a.shift()],b[c+" "]=e}return b}function ha(a){return a[u]=!0,a}function ia(a){var b=n.createElement("div");try{return!!a(b)}catch(c){return!1}finally{b.parentNode&&b.parentNode.removeChild(b),b=null}}function ja(a,b){var c=a.split("|"),e=c.length;while(e--)d.attrHandle[c[e]]=b}function ka(a,b){var c=b&&a,d=c&&1===a.nodeType&&1===b.nodeType&&(~b.sourceIndex||C)-(~a.sourceIndex||C);if(d)return d;if(c)while(c=c.nextSibling)if(c===b)return-1;return a?1:-1}function la(a){return function(b){var c=b.nodeName.toLowerCase();return"input"===c&&b.type===a}}function ma(a){return function(b){var c=b.nodeName.toLowerCase();return("input"===c||"button"===c)&&b.type===a}}function na(a){return ha(function(b){return b=+b,ha(function(c,d){var e,f=a([],c.length,b),g=f.length;while(g--)c[e=f[g]]&&(c[e]=!(d[e]=c[e]))})})}function oa(a){return a&&"undefined"!=typeof a.getElementsByTagName&&a}c=fa.support={},f=fa.isXML=function(a){var b=a&&(a.ownerDocument||a).documentElement;return b?"HTML"!==b.nodeName:!1},m=fa.setDocument=function(a){var b,e,g=a?a.ownerDocument||a:v;return g!==n&&9===g.nodeType&&g.documentElement?(n=g,o=n.documentElement,p=!f(n),(e=n.defaultView)&&e.top!==e&&(e.addEventListener?e.addEventListener("unload",da,!1):e.attachEvent&&e.attachEvent("onunload",da)),c.attributes=ia(function(a){return a.className="i",!a.getAttribute("className")}),c.getElementsByTagName=ia(function(a){return a.appendChild(n.createComment("")),!a.getElementsByTagName("*").length}),c.getElementsByClassName=Z.test(n.getElementsByClassName),c.getById=ia(function(a){return o.appendChild(a).id=u,!n.getElementsByName||!n.getElementsByName(u).length}),c.getById?(d.find.ID=function(a,b){if("undefined"!=typeof b.getElementById&&p){var c=b.getElementById(a);return c?[c]:[]}},d.filter.ID=function(a){var b=a.replace(ba,ca);return function(a){return a.getAttribute("id")===b}}):(delete d.find.ID,d.filter.ID=function(a){var b=a.replace(ba,ca);return function(a){var c="undefined"!=typeof a.getAttributeNode&&a.getAttributeNode("id");return c&&c.value===b}}),d.find.TAG=c.getElementsByTagName?function(a,b){return"undefined"!=typeof b.getElementsByTagName?b.getElementsByTagName(a):c.qsa?b.querySelectorAll(a):void 0}:function(a,b){var c,d=[],e=0,f=b.getElementsByTagName(a);if("*"===a){while(c=f[e++])1===c.nodeType&&d.push(c);return d}return f},d.find.CLASS=c.getElementsByClassName&&function(a,b){return"undefined"!=typeof b.getElementsByClassName&&p?b.getElementsByClassName(a):void 0},r=[],q=[],(c.qsa=Z.test(n.querySelectorAll))&&(ia(function(a){o.appendChild(a).innerHTML="<a id='"+u+"'></a><select id='"+u+"-\r\\' msallowcapture=''><option selected=''></option></select>",a.querySelectorAll("[msallowcapture^='']").length&&q.push("[*^$]="+L+"*(?:''|\"\")"),a.querySelectorAll("[selected]").length||q.push("\\["+L+"*(?:value|"+K+")"),a.querySelectorAll("[id~="+u+"-]").length||q.push("~="),a.querySelectorAll(":checked").length||q.push(":checked"),a.querySelectorAll("a#"+u+"+*").length||q.push(".#.+[+~]")}),ia(function(a){var b=n.createElement("input");b.setAttribute("type","hidden"),a.appendChild(b).setAttribute("name","D"),a.querySelectorAll("[name=d]").length&&q.push("name"+L+"*[*^$|!~]?="),a.querySelectorAll(":enabled").length||q.push(":enabled",":disabled"),a.querySelectorAll("*,:x"),q.push(",.*:")})),(c.matchesSelector=Z.test(s=o.matches||o.webkitMatchesSelector||o.mozMatchesSelector||o.oMatchesSelector||o.msMatchesSelector))&&ia(function(a){c.disconnectedMatch=s.call(a,"div"),s.call(a,"[s!='']:x"),r.push("!=",O)}),q=q.length&&new RegExp(q.join("|")),r=r.length&&new RegExp(r.join("|")),b=Z.test(o.compareDocumentPosition),t=b||Z.test(o.contains)?function(a,b){var c=9===a.nodeType?a.documentElement:a,d=b&&b.parentNode;return a===d||!(!d||1!==d.nodeType||!(c.contains?c.contains(d):a.compareDocumentPosition&&16&a.compareDocumentPosition(d)))}:function(a,b){if(b)while(b=b.parentNode)if(b===a)return!0;return!1},B=b?function(a,b){if(a===b)return l=!0,0;var d=!a.compareDocumentPosition-!b.compareDocumentPosition;return d?d:(d=(a.ownerDocument||a)===(b.ownerDocument||b)?a.compareDocumentPosition(b):1,1&d||!c.sortDetached&&b.compareDocumentPosition(a)===d?a===n||a.ownerDocument===v&&t(v,a)?-1:b===n||b.ownerDocument===v&&t(v,b)?1:k?J(k,a)-J(k,b):0:4&d?-1:1)}:function(a,b){if(a===b)return l=!0,0;var c,d=0,e=a.parentNode,f=b.parentNode,g=[a],h=[b];if(!e||!f)return a===n?-1:b===n?1:e?-1:f?1:k?J(k,a)-J(k,b):0;if(e===f)return ka(a,b);c=a;while(c=c.parentNode)g.unshift(c);c=b;while(c=c.parentNode)h.unshift(c);while(g[d]===h[d])d++;return d?ka(g[d],h[d]):g[d]===v?-1:h[d]===v?1:0},n):n},fa.matches=function(a,b){return fa(a,null,null,b)},fa.matchesSelector=function(a,b){if((a.ownerDocument||a)!==n&&m(a),b=b.replace(T,"='$1']"),c.matchesSelector&&p&&!A[b+" "]&&(!r||!r.test(b))&&(!q||!q.test(b)))try{var d=s.call(a,b);if(d||c.disconnectedMatch||a.document&&11!==a.document.nodeType)return d}catch(e){}return fa(b,n,null,[a]).length>0},fa.contains=function(a,b){return(a.ownerDocument||a)!==n&&m(a),t(a,b)},fa.attr=function(a,b){(a.ownerDocument||a)!==n&&m(a);var e=d.attrHandle[b.toLowerCase()],f=e&&D.call(d.attrHandle,b.toLowerCase())?e(a,b,!p):void 0;return void 0!==f?f:c.attributes||!p?a.getAttribute(b):(f=a.getAttributeNode(b))&&f.specified?f.value:null},fa.error=function(a){throw new Error("Syntax error, unrecognized expression: "+a)},fa.uniqueSort=function(a){var b,d=[],e=0,f=0;if(l=!c.detectDuplicates,k=!c.sortStable&&a.slice(0),a.sort(B),l){while(b=a[f++])b===a[f]&&(e=d.push(f));while(e--)a.splice(d[e],1)}return k=null,a},e=fa.getText=function(a){var b,c="",d=0,f=a.nodeType;if(f){if(1===f||9===f||11===f){if("string"==typeof a.textContent)return a.textContent;for(a=a.firstChild;a;a=a.nextSibling)c+=e(a)}else if(3===f||4===f)return a.nodeValue}else while(b=a[d++])c+=e(b);return c},d=fa.selectors={cacheLength:50,createPseudo:ha,match:W,attrHandle:{},find:{},relative:{">":{dir:"parentNode",first:!0}," ":{dir:"parentNode"},"+":{dir:"previousSibling",first:!0},"~":{dir:"previousSibling"}},preFilter:{ATTR:function(a){return a[1]=a[1].replace(ba,ca),a[3]=(a[3]||a[4]||a[5]||"").replace(ba,ca),"~="===a[2]&&(a[3]=" "+a[3]+" "),a.slice(0,4)},CHILD:function(a){return a[1]=a[1].toLowerCase(),"nth"===a[1].slice(0,3)?(a[3]||fa.error(a[0]),a[4]=+(a[4]?a[5]+(a[6]||1):2*("even"===a[3]||"odd"===a[3])),a[5]=+(a[7]+a[8]||"odd"===a[3])):a[3]&&fa.error(a[0]),a},PSEUDO:function(a){var b,c=!a[6]&&a[2];return W.CHILD.test(a[0])?null:(a[3]?a[2]=a[4]||a[5]||"":c&&U.test(c)&&(b=g(c,!0))&&(b=c.indexOf(")",c.length-b)-c.length)&&(a[0]=a[0].slice(0,b),a[2]=c.slice(0,b)),a.slice(0,3))}},filter:{TAG:function(a){var b=a.replace(ba,ca).toLowerCase();return"*"===a?function(){return!0}:function(a){return a.nodeName&&a.nodeName.toLowerCase()===b}},CLASS:function(a){var b=y[a+" "];return b||(b=new RegExp("(^|"+L+")"+a+"("+L+"|$)"))&&y(a,function(a){return b.test("string"==typeof a.className&&a.className||"undefined"!=typeof a.getAttribute&&a.getAttribute("class")||"")})},ATTR:function(a,b,c){return function(d){var e=fa.attr(d,a);return null==e?"!="===b:b?(e+="","="===b?e===c:"!="===b?e!==c:"^="===b?c&&0===e.indexOf(c):"*="===b?c&&e.indexOf(c)>-1:"$="===b?c&&e.slice(-c.length)===c:"~="===b?(" "+e.replace(P," ")+" ").indexOf(c)>-1:"|="===b?e===c||e.slice(0,c.length+1)===c+"-":!1):!0}},CHILD:function(a,b,c,d,e){var f="nth"!==a.slice(0,3),g="last"!==a.slice(-4),h="of-type"===b;return 1===d&&0===e?function(a){return!!a.parentNode}:function(b,c,i){var j,k,l,m,n,o,p=f!==g?"nextSibling":"previousSibling",q=b.parentNode,r=h&&b.nodeName.toLowerCase(),s=!i&&!h,t=!1;if(q){if(f){while(p){m=b;while(m=m[p])if(h?m.nodeName.toLowerCase()===r:1===m.nodeType)return!1;o=p="only"===a&&!o&&"nextSibling"}return!0}if(o=[g?q.firstChild:q.lastChild],g&&s){m=q,l=m[u]||(m[u]={}),k=l[m.uniqueID]||(l[m.uniqueID]={}),j=k[a]||[],n=j[0]===w&&j[1],t=n&&j[2],m=n&&q.childNodes[n];while(m=++n&&m&&m[p]||(t=n=0)||o.pop())if(1===m.nodeType&&++t&&m===b){k[a]=[w,n,t];break}}else if(s&&(m=b,l=m[u]||(m[u]={}),k=l[m.uniqueID]||(l[m.uniqueID]={}),j=k[a]||[],n=j[0]===w&&j[1],t=n),t===!1)while(m=++n&&m&&m[p]||(t=n=0)||o.pop())if((h?m.nodeName.toLowerCase()===r:1===m.nodeType)&&++t&&(s&&(l=m[u]||(m[u]={}),k=l[m.uniqueID]||(l[m.uniqueID]={}),k[a]=[w,t]),m===b))break;return t-=e,t===d||t%d===0&&t/d>=0}}},PSEUDO:function(a,b){var c,e=d.pseudos[a]||d.setFilters[a.toLowerCase()]||fa.error("unsupported pseudo: "+a);return e[u]?e(b):e.length>1?(c=[a,a,"",b],d.setFilters.hasOwnProperty(a.toLowerCase())?ha(function(a,c){var d,f=e(a,b),g=f.length;while(g--)d=J(a,f[g]),a[d]=!(c[d]=f[g])}):function(a){return e(a,0,c)}):e}},pseudos:{not:ha(function(a){var b=[],c=[],d=h(a.replace(Q,"$1"));return d[u]?ha(function(a,b,c,e){var f,g=d(a,null,e,[]),h=a.length;while(h--)(f=g[h])&&(a[h]=!(b[h]=f))}):function(a,e,f){return b[0]=a,d(b,null,f,c),b[0]=null,!c.pop()}}),has:ha(function(a){return function(b){return fa(a,b).length>0}}),contains:ha(function(a){return a=a.replace(ba,ca),function(b){return(b.textContent||b.innerText||e(b)).indexOf(a)>-1}}),lang:ha(function(a){return V.test(a||"")||fa.error("unsupported lang: "+a),a=a.replace(ba,ca).toLowerCase(),function(b){var c;do if(c=p?b.lang:b.getAttribute("xml:lang")||b.getAttribute("lang"))return c=c.toLowerCase(),c===a||0===c.indexOf(a+"-");while((b=b.parentNode)&&1===b.nodeType);return!1}}),target:function(b){var c=a.location&&a.location.hash;return c&&c.slice(1)===b.id},root:function(a){return a===o},focus:function(a){return a===n.activeElement&&(!n.hasFocus||n.hasFocus())&&!!(a.type||a.href||~a.tabIndex)},enabled:function(a){return a.disabled===!1},disabled:function(a){return a.disabled===!0},checked:function(a){var b=a.nodeName.toLowerCase();return"input"===b&&!!a.checked||"option"===b&&!!a.selected},selected:function(a){return a.parentNode&&a.parentNode.selectedIndex,a.selected===!0},empty:function(a){for(a=a.firstChild;a;a=a.nextSibling)if(a.nodeType<6)return!1;return!0},parent:function(a){return!d.pseudos.empty(a)},header:function(a){return Y.test(a.nodeName)},input:function(a){return X.test(a.nodeName)},button:function(a){var b=a.nodeName.toLowerCase();return"input"===b&&"button"===a.type||"button"===b},text:function(a){var b;return"input"===a.nodeName.toLowerCase()&&"text"===a.type&&(null==(b=a.getAttribute("type"))||"text"===b.toLowerCase())},first:na(function(){return[0]}),last:na(function(a,b){return[b-1]}),eq:na(function(a,b,c){return[0>c?c+b:c]}),even:na(function(a,b){for(var c=0;b>c;c+=2)a.push(c);return a}),odd:na(function(a,b){for(var c=1;b>c;c+=2)a.push(c);return a}),lt:na(function(a,b,c){for(var d=0>c?c+b:c;--d>=0;)a.push(d);return a}),gt:na(function(a,b,c){for(var d=0>c?c+b:c;++d<b;)a.push(d);return a})}},d.pseudos.nth=d.pseudos.eq;for(b in{radio:!0,checkbox:!0,file:!0,password:!0,image:!0})d.pseudos[b]=la(b);for(b in{submit:!0,reset:!0})d.pseudos[b]=ma(b);function pa(){}pa.prototype=d.filters=d.pseudos,d.setFilters=new pa,g=fa.tokenize=function(a,b){var c,e,f,g,h,i,j,k=z[a+" "];if(k)return b?0:k.slice(0);h=a,i=[],j=d.preFilter;while(h){c&&!(e=R.exec(h))||(e&&(h=h.slice(e[0].length)||h),i.push(f=[])),c=!1,(e=S.exec(h))&&(c=e.shift(),f.push({value:c,type:e[0].replace(Q," ")}),h=h.slice(c.length));for(g in d.filter)!(e=W[g].exec(h))||j[g]&&!(e=j[g](e))||(c=e.shift(),f.push({value:c,type:g,matches:e}),h=h.slice(c.length));if(!c)break}return b?h.length:h?fa.error(a):z(a,i).slice(0)};function qa(a){for(var b=0,c=a.length,d="";c>b;b++)d+=a[b].value;return d}function ra(a,b,c){var d=b.dir,e=c&&"parentNode"===d,f=x++;return b.first?function(b,c,f){while(b=b[d])if(1===b.nodeType||e)return a(b,c,f)}:function(b,c,g){var h,i,j,k=[w,f];if(g){while(b=b[d])if((1===b.nodeType||e)&&a(b,c,g))return!0}else while(b=b[d])if(1===b.nodeType||e){if(j=b[u]||(b[u]={}),i=j[b.uniqueID]||(j[b.uniqueID]={}),(h=i[d])&&h[0]===w&&h[1]===f)return k[2]=h[2];if(i[d]=k,k[2]=a(b,c,g))return!0}}}function sa(a){return a.length>1?function(b,c,d){var e=a.length;while(e--)if(!a[e](b,c,d))return!1;return!0}:a[0]}function ta(a,b,c){for(var d=0,e=b.length;e>d;d++)fa(a,b[d],c);return c}function ua(a,b,c,d,e){for(var f,g=[],h=0,i=a.length,j=null!=b;i>h;h++)(f=a[h])&&(c&&!c(f,d,e)||(g.push(f),j&&b.push(h)));return g}function va(a,b,c,d,e,f){return d&&!d[u]&&(d=va(d)),e&&!e[u]&&(e=va(e,f)),ha(function(f,g,h,i){var j,k,l,m=[],n=[],o=g.length,p=f||ta(b||"*",h.nodeType?[h]:h,[]),q=!a||!f&&b?p:ua(p,m,a,h,i),r=c?e||(f?a:o||d)?[]:g:q;if(c&&c(q,r,h,i),d){j=ua(r,n),d(j,[],h,i),k=j.length;while(k--)(l=j[k])&&(r[n[k]]=!(q[n[k]]=l))}if(f){if(e||a){if(e){j=[],k=r.length;while(k--)(l=r[k])&&j.push(q[k]=l);e(null,r=[],j,i)}k=r.length;while(k--)(l=r[k])&&(j=e?J(f,l):m[k])>-1&&(f[j]=!(g[j]=l))}}else r=ua(r===g?r.splice(o,r.length):r),e?e(null,g,r,i):H.apply(g,r)})}function wa(a){for(var b,c,e,f=a.length,g=d.relative[a[0].type],h=g||d.relative[" "],i=g?1:0,k=ra(function(a){return a===b},h,!0),l=ra(function(a){return J(b,a)>-1},h,!0),m=[function(a,c,d){var e=!g&&(d||c!==j)||((b=c).nodeType?k(a,c,d):l(a,c,d));return b=null,e}];f>i;i++)if(c=d.relative[a[i].type])m=[ra(sa(m),c)];else{if(c=d.filter[a[i].type].apply(null,a[i].matches),c[u]){for(e=++i;f>e;e++)if(d.relative[a[e].type])break;return va(i>1&&sa(m),i>1&&qa(a.slice(0,i-1).concat({value:" "===a[i-2].type?"*":""})).replace(Q,"$1"),c,e>i&&wa(a.slice(i,e)),f>e&&wa(a=a.slice(e)),f>e&&qa(a))}m.push(c)}return sa(m)}function xa(a,b){var c=b.length>0,e=a.length>0,f=function(f,g,h,i,k){var l,o,q,r=0,s="0",t=f&&[],u=[],v=j,x=f||e&&d.find.TAG("*",k),y=w+=null==v?1:Math.random()||.1,z=x.length;for(k&&(j=g===n||g||k);s!==z&&null!=(l=x[s]);s++){if(e&&l){o=0,g||l.ownerDocument===n||(m(l),h=!p);while(q=a[o++])if(q(l,g||n,h)){i.push(l);break}k&&(w=y)}c&&((l=!q&&l)&&r--,f&&t.push(l))}if(r+=s,c&&s!==r){o=0;while(q=b[o++])q(t,u,g,h);if(f){if(r>0)while(s--)t[s]||u[s]||(u[s]=F.call(i));u=ua(u)}H.apply(i,u),k&&!f&&u.length>0&&r+b.length>1&&fa.uniqueSort(i)}return k&&(w=y,j=v),t};return c?ha(f):f}return h=fa.compile=function(a,b){var c,d=[],e=[],f=A[a+" "];if(!f){b||(b=g(a)),c=b.length;while(c--)f=wa(b[c]),f[u]?d.push(f):e.push(f);f=A(a,xa(e,d)),f.selector=a}return f},i=fa.select=function(a,b,e,f){var i,j,k,l,m,n="function"==typeof a&&a,o=!f&&g(a=n.selector||a);if(e=e||[],1===o.length){if(j=o[0]=o[0].slice(0),j.length>2&&"ID"===(k=j[0]).type&&c.getById&&9===b.nodeType&&p&&d.relative[j[1].type]){if(b=(d.find.ID(k.matches[0].replace(ba,ca),b)||[])[0],!b)return e;n&&(b=b.parentNode),a=a.slice(j.shift().value.length)}i=W.needsContext.test(a)?0:j.length;while(i--){if(k=j[i],d.relative[l=k.type])break;if((m=d.find[l])&&(f=m(k.matches[0].replace(ba,ca),_.test(j[0].type)&&oa(b.parentNode)||b))){if(j.splice(i,1),a=f.length&&qa(j),!a)return H.apply(e,f),e;break}}}return(n||h(a,o))(f,b,!p,e,!b||_.test(a)&&oa(b.parentNode)||b),e},c.sortStable=u.split("").sort(B).join("")===u,c.detectDuplicates=!!l,m(),c.sortDetached=ia(function(a){return 1&a.compareDocumentPosition(n.createElement("div"))}),ia(function(a){return a.innerHTML="<a href='#'></a>","#"===a.firstChild.getAttribute("href")})||ja("type|href|height|width",function(a,b,c){return c?void 0:a.getAttribute(b,"type"===b.toLowerCase()?1:2)}),c.attributes&&ia(function(a){return a.innerHTML="<input/>",a.firstChild.setAttribute("value",""),""===a.firstChild.getAttribute("value")})||ja("value",function(a,b,c){return c||"input"!==a.nodeName.toLowerCase()?void 0:a.defaultValue}),ia(function(a){return null==a.getAttribute("disabled")})||ja(K,function(a,b,c){var d;return c?void 0:a[b]===!0?b.toLowerCase():(d=a.getAttributeNode(b))&&d.specified?d.value:null}),fa}(a);n.find=t,n.expr=t.selectors,n.expr[":"]=n.expr.pseudos,n.uniqueSort=n.unique=t.uniqueSort,n.text=t.getText,n.isXMLDoc=t.isXML,n.contains=t.contains;var u=function(a,b,c){var d=[],e=void 0!==c;while((a=a[b])&&9!==a.nodeType)if(1===a.nodeType){if(e&&n(a).is(c))break;d.push(a)}return d},v=function(a,b){for(var c=[];a;a=a.nextSibling)1===a.nodeType&&a!==b&&c.push(a);return c},w=n.expr.match.needsContext,x=/^<([\w-]+)\s*\/?>(?:<\/\1>|)$/,y=/^.[^:#\[\.,]*$/;function z(a,b,c){if(n.isFunction(b))return n.grep(a,function(a,d){return!!b.call(a,d,a)!==c});if(b.nodeType)return n.grep(a,function(a){return a===b!==c});if("string"==typeof b){if(y.test(b))return n.filter(b,a,c);b=n.filter(b,a)}return n.grep(a,function(a){return h.call(b,a)>-1!==c})}n.filter=function(a,b,c){var d=b[0];return c&&(a=":not("+a+")"),1===b.length&&1===d.nodeType?n.find.matchesSelector(d,a)?[d]:[]:n.find.matches(a,n.grep(b,function(a){return 1===a.nodeType}))},n.fn.extend({find:function(a){var b,c=this.length,d=[],e=this;if("string"!=typeof a)return this.pushStack(n(a).filter(function(){for(b=0;c>b;b++)if(n.contains(e[b],this))return!0}));for(b=0;c>b;b++)n.find(a,e[b],d);return d=this.pushStack(c>1?n.unique(d):d),d.selector=this.selector?this.selector+" "+a:a,d},filter:function(a){return this.pushStack(z(this,a||[],!1))},not:function(a){return this.pushStack(z(this,a||[],!0))},is:function(a){return!!z(this,"string"==typeof a&&w.test(a)?n(a):a||[],!1).length}});var A,B=/^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]*))$/,C=n.fn.init=function(a,b,c){var e,f;if(!a)return this;if(c=c||A,"string"==typeof a){if(e="<"===a[0]&&">"===a[a.length-1]&&a.length>=3?[null,a,null]:B.exec(a),!e||!e[1]&&b)return!b||b.jquery?(b||c).find(a):this.constructor(b).find(a);if(e[1]){if(b=b instanceof n?b[0]:b,n.merge(this,n.parseHTML(e[1],b&&b.nodeType?b.ownerDocument||b:d,!0)),x.test(e[1])&&n.isPlainObject(b))for(e in b)n.isFunction(this[e])?this[e](b[e]):this.attr(e,b[e]);return this}return f=d.getElementById(e[2]),f&&f.parentNode&&(this.length=1,this[0]=f),this.context=d,this.selector=a,this}return a.nodeType?(this.context=this[0]=a,this.length=1,this):n.isFunction(a)?void 0!==c.ready?c.ready(a):a(n):(void 0!==a.selector&&(this.selector=a.selector,this.context=a.context),n.makeArray(a,this))};C.prototype=n.fn,A=n(d);var D=/^(?:parents|prev(?:Until|All))/,E={children:!0,contents:!0,next:!0,prev:!0};n.fn.extend({has:function(a){var b=n(a,this),c=b.length;return this.filter(function(){for(var a=0;c>a;a++)if(n.contains(this,b[a]))return!0})},closest:function(a,b){for(var c,d=0,e=this.length,f=[],g=w.test(a)||"string"!=typeof a?n(a,b||this.context):0;e>d;d++)for(c=this[d];c&&c!==b;c=c.parentNode)if(c.nodeType<11&&(g?g.index(c)>-1:1===c.nodeType&&n.find.matchesSelector(c,a))){f.push(c);break}return this.pushStack(f.length>1?n.uniqueSort(f):f)},index:function(a){return a?"string"==typeof a?h.call(n(a),this[0]):h.call(this,a.jquery?a[0]:a):this[0]&&this[0].parentNode?this.first().prevAll().length:-1},add:function(a,b){return this.pushStack(n.uniqueSort(n.merge(this.get(),n(a,b))))},addBack:function(a){return this.add(null==a?this.prevObject:this.prevObject.filter(a))}});function F(a,b){while((a=a[b])&&1!==a.nodeType);return a}n.each({parent:function(a){var b=a.parentNode;return b&&11!==b.nodeType?b:null},parents:function(a){return u(a,"parentNode")},parentsUntil:function(a,b,c){return u(a,"parentNode",c)},next:function(a){return F(a,"nextSibling")},prev:function(a){return F(a,"previousSibling")},nextAll:function(a){return u(a,"nextSibling")},prevAll:function(a){return u(a,"previousSibling")},nextUntil:function(a,b,c){return u(a,"nextSibling",c)},prevUntil:function(a,b,c){return u(a,"previousSibling",c)},siblings:function(a){return v((a.parentNode||{}).firstChild,a)},children:function(a){return v(a.firstChild)},contents:function(a){return a.contentDocument||n.merge([],a.childNodes)}},function(a,b){n.fn[a]=function(c,d){var e=n.map(this,b,c);return"Until"!==a.slice(-5)&&(d=c),d&&"string"==typeof d&&(e=n.filter(d,e)),this.length>1&&(E[a]||n.uniqueSort(e),D.test(a)&&e.reverse()),this.pushStack(e)}});var G=/\S+/g;function H(a){var b={};return n.each(a.match(G)||[],function(a,c){b[c]=!0}),b}n.Callbacks=function(a){a="string"==typeof a?H(a):n.extend({},a);var b,c,d,e,f=[],g=[],h=-1,i=function(){for(e=a.once,d=b=!0;g.length;h=-1){c=g.shift();while(++h<f.length)f[h].apply(c[0],c[1])===!1&&a.stopOnFalse&&(h=f.length,c=!1)}a.memory||(c=!1),b=!1,e&&(f=c?[]:"")},j={add:function(){return f&&(c&&!b&&(h=f.length-1,g.push(c)),function d(b){n.each(b,function(b,c){n.isFunction(c)?a.unique&&j.has(c)||f.push(c):c&&c.length&&"string"!==n.type(c)&&d(c)})}(arguments),c&&!b&&i()),this},remove:function(){return n.each(arguments,function(a,b){var c;while((c=n.inArray(b,f,c))>-1)f.splice(c,1),h>=c&&h--}),this},has:function(a){return a?n.inArray(a,f)>-1:f.length>0},empty:function(){return f&&(f=[]),this},disable:function(){return e=g=[],f=c="",this},disabled:function(){return!f},lock:function(){return e=g=[],c||(f=c=""),this},locked:function(){return!!e},fireWith:function(a,c){return e||(c=c||[],c=[a,c.slice?c.slice():c],g.push(c),b||i()),this},fire:function(){return j.fireWith(this,arguments),this},fired:function(){return!!d}};return j},n.extend({Deferred:function(a){var b=[["resolve","done",n.Callbacks("once memory"),"resolved"],["reject","fail",n.Callbacks("once memory"),"rejected"],["notify","progress",n.Callbacks("memory")]],c="pending",d={state:function(){return c},always:function(){return e.done(arguments).fail(arguments),this},then:function(){var a=arguments;return n.Deferred(function(c){n.each(b,function(b,f){var g=n.isFunction(a[b])&&a[b];e[f[1]](function(){var a=g&&g.apply(this,arguments);a&&n.isFunction(a.promise)?a.promise().progress(c.notify).done(c.resolve).fail(c.reject):c[f[0]+"With"](this===d?c.promise():this,g?[a]:arguments)})}),a=null}).promise()},promise:function(a){return null!=a?n.extend(a,d):d}},e={};return d.pipe=d.then,n.each(b,function(a,f){var g=f[2],h=f[3];d[f[1]]=g.add,h&&g.add(function(){c=h},b[1^a][2].disable,b[2][2].lock),e[f[0]]=function(){return e[f[0]+"With"](this===e?d:this,arguments),this},e[f[0]+"With"]=g.fireWith}),d.promise(e),a&&a.call(e,e),e},when:function(a){var b=0,c=e.call(arguments),d=c.length,f=1!==d||a&&n.isFunction(a.promise)?d:0,g=1===f?a:n.Deferred(),h=function(a,b,c){return function(d){b[a]=this,c[a]=arguments.length>1?e.call(arguments):d,c===i?g.notifyWith(b,c):--f||g.resolveWith(b,c)}},i,j,k;if(d>1)for(i=new Array(d),j=new Array(d),k=new Array(d);d>b;b++)c[b]&&n.isFunction(c[b].promise)?c[b].promise().progress(h(b,j,i)).done(h(b,k,c)).fail(g.reject):--f;return f||g.resolveWith(k,c),g.promise()}});var I;n.fn.ready=function(a){return n.ready.promise().done(a),this},n.extend({isReady:!1,readyWait:1,holdReady:function(a){a?n.readyWait++:n.ready(!0)},ready:function(a){(a===!0?--n.readyWait:n.isReady)||(n.isReady=!0,a!==!0&&--n.readyWait>0||(I.resolveWith(d,[n]),n.fn.triggerHandler&&(n(d).triggerHandler("ready"),n(d).off("ready"))))}});function J(){d.removeEventListener("DOMContentLoaded",J),a.removeEventListener("load",J),n.ready()}n.ready.promise=function(b){return I||(I=n.Deferred(),"complete"===d.readyState||"loading"!==d.readyState&&!d.documentElement.doScroll?a.setTimeout(n.ready):(d.addEventListener("DOMContentLoaded",J),a.addEventListener("load",J))),I.promise(b)},n.ready.promise();var K=function(a,b,c,d,e,f,g){var h=0,i=a.length,j=null==c;if("object"===n.type(c)){e=!0;for(h in c)K(a,b,h,c[h],!0,f,g)}else if(void 0!==d&&(e=!0,n.isFunction(d)||(g=!0),j&&(g?(b.call(a,d),b=null):(j=b,b=function(a,b,c){return j.call(n(a),c)})),b))for(;i>h;h++)b(a[h],c,g?d:d.call(a[h],h,b(a[h],c)));return e?a:j?b.call(a):i?b(a[0],c):f},L=function(a){return 1===a.nodeType||9===a.nodeType||!+a.nodeType};function M(){this.expando=n.expando+M.uid++}M.uid=1,M.prototype={register:function(a,b){var c=b||{};return a.nodeType?a[this.expando]=c:Object.defineProperty(a,this.expando,{value:c,writable:!0,configurable:!0}),a[this.expando]},cache:function(a){if(!L(a))return{};var b=a[this.expando];return b||(b={},L(a)&&(a.nodeType?a[this.expando]=b:Object.defineProperty(a,this.expando,{value:b,configurable:!0}))),b},set:function(a,b,c){var d,e=this.cache(a);if("string"==typeof b)e[b]=c;else for(d in b)e[d]=b[d];return e},get:function(a,b){return void 0===b?this.cache(a):a[this.expando]&&a[this.expando][b]},access:function(a,b,c){var d;return void 0===b||b&&"string"==typeof b&&void 0===c?(d=this.get(a,b),void 0!==d?d:this.get(a,n.camelCase(b))):(this.set(a,b,c),void 0!==c?c:b)},remove:function(a,b){var c,d,e,f=a[this.expando];if(void 0!==f){if(void 0===b)this.register(a);else{n.isArray(b)?d=b.concat(b.map(n.camelCase)):(e=n.camelCase(b),b in f?d=[b,e]:(d=e,d=d in f?[d]:d.match(G)||[])),c=d.length;while(c--)delete f[d[c]]}(void 0===b||n.isEmptyObject(f))&&(a.nodeType?a[this.expando]=void 0:delete a[this.expando])}},hasData:function(a){var b=a[this.expando];return void 0!==b&&!n.isEmptyObject(b)}};var N=new M,O=new M,P=/^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,Q=/[A-Z]/g;function R(a,b,c){var d;if(void 0===c&&1===a.nodeType)if(d="data-"+b.replace(Q,"-$&").toLowerCase(),c=a.getAttribute(d),"string"==typeof c){try{c="true"===c?!0:"false"===c?!1:"null"===c?null:+c+""===c?+c:P.test(c)?n.parseJSON(c):c;
}catch(e){}O.set(a,b,c)}else c=void 0;return c}n.extend({hasData:function(a){return O.hasData(a)||N.hasData(a)},data:function(a,b,c){return O.access(a,b,c)},removeData:function(a,b){O.remove(a,b)},_data:function(a,b,c){return N.access(a,b,c)},_removeData:function(a,b){N.remove(a,b)}}),n.fn.extend({data:function(a,b){var c,d,e,f=this[0],g=f&&f.attributes;if(void 0===a){if(this.length&&(e=O.get(f),1===f.nodeType&&!N.get(f,"hasDataAttrs"))){c=g.length;while(c--)g[c]&&(d=g[c].name,0===d.indexOf("data-")&&(d=n.camelCase(d.slice(5)),R(f,d,e[d])));N.set(f,"hasDataAttrs",!0)}return e}return"object"==typeof a?this.each(function(){O.set(this,a)}):K(this,function(b){var c,d;if(f&&void 0===b){if(c=O.get(f,a)||O.get(f,a.replace(Q,"-$&").toLowerCase()),void 0!==c)return c;if(d=n.camelCase(a),c=O.get(f,d),void 0!==c)return c;if(c=R(f,d,void 0),void 0!==c)return c}else d=n.camelCase(a),this.each(function(){var c=O.get(this,d);O.set(this,d,b),a.indexOf("-")>-1&&void 0!==c&&O.set(this,a,b)})},null,b,arguments.length>1,null,!0)},removeData:function(a){return this.each(function(){O.remove(this,a)})}}),n.extend({queue:function(a,b,c){var d;return a?(b=(b||"fx")+"queue",d=N.get(a,b),c&&(!d||n.isArray(c)?d=N.access(a,b,n.makeArray(c)):d.push(c)),d||[]):void 0},dequeue:function(a,b){b=b||"fx";var c=n.queue(a,b),d=c.length,e=c.shift(),f=n._queueHooks(a,b),g=function(){n.dequeue(a,b)};"inprogress"===e&&(e=c.shift(),d--),e&&("fx"===b&&c.unshift("inprogress"),delete f.stop,e.call(a,g,f)),!d&&f&&f.empty.fire()},_queueHooks:function(a,b){var c=b+"queueHooks";return N.get(a,c)||N.access(a,c,{empty:n.Callbacks("once memory").add(function(){N.remove(a,[b+"queue",c])})})}}),n.fn.extend({queue:function(a,b){var c=2;return"string"!=typeof a&&(b=a,a="fx",c--),arguments.length<c?n.queue(this[0],a):void 0===b?this:this.each(function(){var c=n.queue(this,a,b);n._queueHooks(this,a),"fx"===a&&"inprogress"!==c[0]&&n.dequeue(this,a)})},dequeue:function(a){return this.each(function(){n.dequeue(this,a)})},clearQueue:function(a){return this.queue(a||"fx",[])},promise:function(a,b){var c,d=1,e=n.Deferred(),f=this,g=this.length,h=function(){--d||e.resolveWith(f,[f])};"string"!=typeof a&&(b=a,a=void 0),a=a||"fx";while(g--)c=N.get(f[g],a+"queueHooks"),c&&c.empty&&(d++,c.empty.add(h));return h(),e.promise(b)}});var S=/[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,T=new RegExp("^(?:([+-])=|)("+S+")([a-z%]*)$","i"),U=["Top","Right","Bottom","Left"],V=function(a,b){return a=b||a,"none"===n.css(a,"display")||!n.contains(a.ownerDocument,a)};function W(a,b,c,d){var e,f=1,g=20,h=d?function(){return d.cur()}:function(){return n.css(a,b,"")},i=h(),j=c&&c[3]||(n.cssNumber[b]?"":"px"),k=(n.cssNumber[b]||"px"!==j&&+i)&&T.exec(n.css(a,b));if(k&&k[3]!==j){j=j||k[3],c=c||[],k=+i||1;do f=f||".5",k/=f,n.style(a,b,k+j);while(f!==(f=h()/i)&&1!==f&&--g)}return c&&(k=+k||+i||0,e=c[1]?k+(c[1]+1)*c[2]:+c[2],d&&(d.unit=j,d.start=k,d.end=e)),e}var X=/^(?:checkbox|radio)$/i,Y=/<([\w:-]+)/,Z=/^$|\/(?:java|ecma)script/i,$={option:[1,"<select multiple='multiple'>","</select>"],thead:[1,"<table>","</table>"],col:[2,"<table><colgroup>","</colgroup></table>"],tr:[2,"<table><tbody>","</tbody></table>"],td:[3,"<table><tbody><tr>","</tr></tbody></table>"],_default:[0,"",""]};$.optgroup=$.option,$.tbody=$.tfoot=$.colgroup=$.caption=$.thead,$.th=$.td;function _(a,b){var c="undefined"!=typeof a.getElementsByTagName?a.getElementsByTagName(b||"*"):"undefined"!=typeof a.querySelectorAll?a.querySelectorAll(b||"*"):[];return void 0===b||b&&n.nodeName(a,b)?n.merge([a],c):c}function aa(a,b){for(var c=0,d=a.length;d>c;c++)N.set(a[c],"globalEval",!b||N.get(b[c],"globalEval"))}var ba=/<|&#?\w+;/;function ca(a,b,c,d,e){for(var f,g,h,i,j,k,l=b.createDocumentFragment(),m=[],o=0,p=a.length;p>o;o++)if(f=a[o],f||0===f)if("object"===n.type(f))n.merge(m,f.nodeType?[f]:f);else if(ba.test(f)){g=g||l.appendChild(b.createElement("div")),h=(Y.exec(f)||["",""])[1].toLowerCase(),i=$[h]||$._default,g.innerHTML=i[1]+n.htmlPrefilter(f)+i[2],k=i[0];while(k--)g=g.lastChild;n.merge(m,g.childNodes),g=l.firstChild,g.textContent=""}else m.push(b.createTextNode(f));l.textContent="",o=0;while(f=m[o++])if(d&&n.inArray(f,d)>-1)e&&e.push(f);else if(j=n.contains(f.ownerDocument,f),g=_(l.appendChild(f),"script"),j&&aa(g),c){k=0;while(f=g[k++])Z.test(f.type||"")&&c.push(f)}return l}!function(){var a=d.createDocumentFragment(),b=a.appendChild(d.createElement("div")),c=d.createElement("input");c.setAttribute("type","radio"),c.setAttribute("checked","checked"),c.setAttribute("name","t"),b.appendChild(c),l.checkClone=b.cloneNode(!0).cloneNode(!0).lastChild.checked,b.innerHTML="<textarea>x</textarea>",l.noCloneChecked=!!b.cloneNode(!0).lastChild.defaultValue}();var da=/^key/,ea=/^(?:mouse|pointer|contextmenu|drag|drop)|click/,fa=/^([^.]*)(?:\.(.+)|)/;function ga(){return!0}function ha(){return!1}function ia(){try{return d.activeElement}catch(a){}}function ja(a,b,c,d,e,f){var g,h;if("object"==typeof b){"string"!=typeof c&&(d=d||c,c=void 0);for(h in b)ja(a,h,c,d,b[h],f);return a}if(null==d&&null==e?(e=c,d=c=void 0):null==e&&("string"==typeof c?(e=d,d=void 0):(e=d,d=c,c=void 0)),e===!1)e=ha;else if(!e)return a;return 1===f&&(g=e,e=function(a){return n().off(a),g.apply(this,arguments)},e.guid=g.guid||(g.guid=n.guid++)),a.each(function(){n.event.add(this,b,e,d,c)})}n.event={global:{},add:function(a,b,c,d,e){var f,g,h,i,j,k,l,m,o,p,q,r=N.get(a);if(r){c.handler&&(f=c,c=f.handler,e=f.selector),c.guid||(c.guid=n.guid++),(i=r.events)||(i=r.events={}),(g=r.handle)||(g=r.handle=function(b){return"undefined"!=typeof n&&n.event.triggered!==b.type?n.event.dispatch.apply(a,arguments):void 0}),b=(b||"").match(G)||[""],j=b.length;while(j--)h=fa.exec(b[j])||[],o=q=h[1],p=(h[2]||"").split(".").sort(),o&&(l=n.event.special[o]||{},o=(e?l.delegateType:l.bindType)||o,l=n.event.special[o]||{},k=n.extend({type:o,origType:q,data:d,handler:c,guid:c.guid,selector:e,needsContext:e&&n.expr.match.needsContext.test(e),namespace:p.join(".")},f),(m=i[o])||(m=i[o]=[],m.delegateCount=0,l.setup&&l.setup.call(a,d,p,g)!==!1||a.addEventListener&&a.addEventListener(o,g)),l.add&&(l.add.call(a,k),k.handler.guid||(k.handler.guid=c.guid)),e?m.splice(m.delegateCount++,0,k):m.push(k),n.event.global[o]=!0)}},remove:function(a,b,c,d,e){var f,g,h,i,j,k,l,m,o,p,q,r=N.hasData(a)&&N.get(a);if(r&&(i=r.events)){b=(b||"").match(G)||[""],j=b.length;while(j--)if(h=fa.exec(b[j])||[],o=q=h[1],p=(h[2]||"").split(".").sort(),o){l=n.event.special[o]||{},o=(d?l.delegateType:l.bindType)||o,m=i[o]||[],h=h[2]&&new RegExp("(^|\\.)"+p.join("\\.(?:.*\\.|)")+"(\\.|$)"),g=f=m.length;while(f--)k=m[f],!e&&q!==k.origType||c&&c.guid!==k.guid||h&&!h.test(k.namespace)||d&&d!==k.selector&&("**"!==d||!k.selector)||(m.splice(f,1),k.selector&&m.delegateCount--,l.remove&&l.remove.call(a,k));g&&!m.length&&(l.teardown&&l.teardown.call(a,p,r.handle)!==!1||n.removeEvent(a,o,r.handle),delete i[o])}else for(o in i)n.event.remove(a,o+b[j],c,d,!0);n.isEmptyObject(i)&&N.remove(a,"handle events")}},dispatch:function(a){a=n.event.fix(a);var b,c,d,f,g,h=[],i=e.call(arguments),j=(N.get(this,"events")||{})[a.type]||[],k=n.event.special[a.type]||{};if(i[0]=a,a.delegateTarget=this,!k.preDispatch||k.preDispatch.call(this,a)!==!1){h=n.event.handlers.call(this,a,j),b=0;while((f=h[b++])&&!a.isPropagationStopped()){a.currentTarget=f.elem,c=0;while((g=f.handlers[c++])&&!a.isImmediatePropagationStopped())a.rnamespace&&!a.rnamespace.test(g.namespace)||(a.handleObj=g,a.data=g.data,d=((n.event.special[g.origType]||{}).handle||g.handler).apply(f.elem,i),void 0!==d&&(a.result=d)===!1&&(a.preventDefault(),a.stopPropagation()))}return k.postDispatch&&k.postDispatch.call(this,a),a.result}},handlers:function(a,b){var c,d,e,f,g=[],h=b.delegateCount,i=a.target;if(h&&i.nodeType&&("click"!==a.type||isNaN(a.button)||a.button<1))for(;i!==this;i=i.parentNode||this)if(1===i.nodeType&&(i.disabled!==!0||"click"!==a.type)){for(d=[],c=0;h>c;c++)f=b[c],e=f.selector+" ",void 0===d[e]&&(d[e]=f.needsContext?n(e,this).index(i)>-1:n.find(e,this,null,[i]).length),d[e]&&d.push(f);d.length&&g.push({elem:i,handlers:d})}return h<b.length&&g.push({elem:this,handlers:b.slice(h)}),g},props:"altKey bubbles cancelable ctrlKey currentTarget detail eventPhase metaKey relatedTarget shiftKey target timeStamp view which".split(" "),fixHooks:{},keyHooks:{props:"char charCode key keyCode".split(" "),filter:function(a,b){return null==a.which&&(a.which=null!=b.charCode?b.charCode:b.keyCode),a}},mouseHooks:{props:"button buttons clientX clientY offsetX offsetY pageX pageY screenX screenY toElement".split(" "),filter:function(a,b){var c,e,f,g=b.button;return null==a.pageX&&null!=b.clientX&&(c=a.target.ownerDocument||d,e=c.documentElement,f=c.body,a.pageX=b.clientX+(e&&e.scrollLeft||f&&f.scrollLeft||0)-(e&&e.clientLeft||f&&f.clientLeft||0),a.pageY=b.clientY+(e&&e.scrollTop||f&&f.scrollTop||0)-(e&&e.clientTop||f&&f.clientTop||0)),a.which||void 0===g||(a.which=1&g?1:2&g?3:4&g?2:0),a}},fix:function(a){if(a[n.expando])return a;var b,c,e,f=a.type,g=a,h=this.fixHooks[f];h||(this.fixHooks[f]=h=ea.test(f)?this.mouseHooks:da.test(f)?this.keyHooks:{}),e=h.props?this.props.concat(h.props):this.props,a=new n.Event(g),b=e.length;while(b--)c=e[b],a[c]=g[c];return a.target||(a.target=d),3===a.target.nodeType&&(a.target=a.target.parentNode),h.filter?h.filter(a,g):a},special:{load:{noBubble:!0},focus:{trigger:function(){return this!==ia()&&this.focus?(this.focus(),!1):void 0},delegateType:"focusin"},blur:{trigger:function(){return this===ia()&&this.blur?(this.blur(),!1):void 0},delegateType:"focusout"},click:{trigger:function(){return"checkbox"===this.type&&this.click&&n.nodeName(this,"input")?(this.click(),!1):void 0},_default:function(a){return n.nodeName(a.target,"a")}},beforeunload:{postDispatch:function(a){void 0!==a.result&&a.originalEvent&&(a.originalEvent.returnValue=a.result)}}}},n.removeEvent=function(a,b,c){a.removeEventListener&&a.removeEventListener(b,c)},n.Event=function(a,b){return this instanceof n.Event?(a&&a.type?(this.originalEvent=a,this.type=a.type,this.isDefaultPrevented=a.defaultPrevented||void 0===a.defaultPrevented&&a.returnValue===!1?ga:ha):this.type=a,b&&n.extend(this,b),this.timeStamp=a&&a.timeStamp||n.now(),void(this[n.expando]=!0)):new n.Event(a,b)},n.Event.prototype={constructor:n.Event,isDefaultPrevented:ha,isPropagationStopped:ha,isImmediatePropagationStopped:ha,isSimulated:!1,preventDefault:function(){var a=this.originalEvent;this.isDefaultPrevented=ga,a&&!this.isSimulated&&a.preventDefault()},stopPropagation:function(){var a=this.originalEvent;this.isPropagationStopped=ga,a&&!this.isSimulated&&a.stopPropagation()},stopImmediatePropagation:function(){var a=this.originalEvent;this.isImmediatePropagationStopped=ga,a&&!this.isSimulated&&a.stopImmediatePropagation(),this.stopPropagation()}},n.each({mouseenter:"mouseover",mouseleave:"mouseout",pointerenter:"pointerover",pointerleave:"pointerout"},function(a,b){n.event.special[a]={delegateType:b,bindType:b,handle:function(a){var c,d=this,e=a.relatedTarget,f=a.handleObj;return e&&(e===d||n.contains(d,e))||(a.type=f.origType,c=f.handler.apply(this,arguments),a.type=b),c}}}),n.fn.extend({on:function(a,b,c,d){return ja(this,a,b,c,d)},one:function(a,b,c,d){return ja(this,a,b,c,d,1)},off:function(a,b,c){var d,e;if(a&&a.preventDefault&&a.handleObj)return d=a.handleObj,n(a.delegateTarget).off(d.namespace?d.origType+"."+d.namespace:d.origType,d.selector,d.handler),this;if("object"==typeof a){for(e in a)this.off(e,b,a[e]);return this}return b!==!1&&"function"!=typeof b||(c=b,b=void 0),c===!1&&(c=ha),this.each(function(){n.event.remove(this,a,c,b)})}});var ka=/<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:-]+)[^>]*)\/>/gi,la=/<script|<style|<link/i,ma=/checked\s*(?:[^=]|=\s*.checked.)/i,na=/^true\/(.*)/,oa=/^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;function pa(a,b){return n.nodeName(a,"table")&&n.nodeName(11!==b.nodeType?b:b.firstChild,"tr")?a.getElementsByTagName("tbody")[0]||a.appendChild(a.ownerDocument.createElement("tbody")):a}function qa(a){return a.type=(null!==a.getAttribute("type"))+"/"+a.type,a}function ra(a){var b=na.exec(a.type);return b?a.type=b[1]:a.removeAttribute("type"),a}function sa(a,b){var c,d,e,f,g,h,i,j;if(1===b.nodeType){if(N.hasData(a)&&(f=N.access(a),g=N.set(b,f),j=f.events)){delete g.handle,g.events={};for(e in j)for(c=0,d=j[e].length;d>c;c++)n.event.add(b,e,j[e][c])}O.hasData(a)&&(h=O.access(a),i=n.extend({},h),O.set(b,i))}}function ta(a,b){var c=b.nodeName.toLowerCase();"input"===c&&X.test(a.type)?b.checked=a.checked:"input"!==c&&"textarea"!==c||(b.defaultValue=a.defaultValue)}function ua(a,b,c,d){b=f.apply([],b);var e,g,h,i,j,k,m=0,o=a.length,p=o-1,q=b[0],r=n.isFunction(q);if(r||o>1&&"string"==typeof q&&!l.checkClone&&ma.test(q))return a.each(function(e){var f=a.eq(e);r&&(b[0]=q.call(this,e,f.html())),ua(f,b,c,d)});if(o&&(e=ca(b,a[0].ownerDocument,!1,a,d),g=e.firstChild,1===e.childNodes.length&&(e=g),g||d)){for(h=n.map(_(e,"script"),qa),i=h.length;o>m;m++)j=e,m!==p&&(j=n.clone(j,!0,!0),i&&n.merge(h,_(j,"script"))),c.call(a[m],j,m);if(i)for(k=h[h.length-1].ownerDocument,n.map(h,ra),m=0;i>m;m++)j=h[m],Z.test(j.type||"")&&!N.access(j,"globalEval")&&n.contains(k,j)&&(j.src?n._evalUrl&&n._evalUrl(j.src):n.globalEval(j.textContent.replace(oa,"")))}return a}function va(a,b,c){for(var d,e=b?n.filter(b,a):a,f=0;null!=(d=e[f]);f++)c||1!==d.nodeType||n.cleanData(_(d)),d.parentNode&&(c&&n.contains(d.ownerDocument,d)&&aa(_(d,"script")),d.parentNode.removeChild(d));return a}n.extend({htmlPrefilter:function(a){return a.replace(ka,"<$1></$2>")},clone:function(a,b,c){var d,e,f,g,h=a.cloneNode(!0),i=n.contains(a.ownerDocument,a);if(!(l.noCloneChecked||1!==a.nodeType&&11!==a.nodeType||n.isXMLDoc(a)))for(g=_(h),f=_(a),d=0,e=f.length;e>d;d++)ta(f[d],g[d]);if(b)if(c)for(f=f||_(a),g=g||_(h),d=0,e=f.length;e>d;d++)sa(f[d],g[d]);else sa(a,h);return g=_(h,"script"),g.length>0&&aa(g,!i&&_(a,"script")),h},cleanData:function(a){for(var b,c,d,e=n.event.special,f=0;void 0!==(c=a[f]);f++)if(L(c)){if(b=c[N.expando]){if(b.events)for(d in b.events)e[d]?n.event.remove(c,d):n.removeEvent(c,d,b.handle);c[N.expando]=void 0}c[O.expando]&&(c[O.expando]=void 0)}}}),n.fn.extend({domManip:ua,detach:function(a){return va(this,a,!0)},remove:function(a){return va(this,a)},text:function(a){return K(this,function(a){return void 0===a?n.text(this):this.empty().each(function(){1!==this.nodeType&&11!==this.nodeType&&9!==this.nodeType||(this.textContent=a)})},null,a,arguments.length)},append:function(){return ua(this,arguments,function(a){if(1===this.nodeType||11===this.nodeType||9===this.nodeType){var b=pa(this,a);b.appendChild(a)}})},prepend:function(){return ua(this,arguments,function(a){if(1===this.nodeType||11===this.nodeType||9===this.nodeType){var b=pa(this,a);b.insertBefore(a,b.firstChild)}})},before:function(){return ua(this,arguments,function(a){this.parentNode&&this.parentNode.insertBefore(a,this)})},after:function(){return ua(this,arguments,function(a){this.parentNode&&this.parentNode.insertBefore(a,this.nextSibling)})},empty:function(){for(var a,b=0;null!=(a=this[b]);b++)1===a.nodeType&&(n.cleanData(_(a,!1)),a.textContent="");return this},clone:function(a,b){return a=null==a?!1:a,b=null==b?a:b,this.map(function(){return n.clone(this,a,b)})},html:function(a){return K(this,function(a){var b=this[0]||{},c=0,d=this.length;if(void 0===a&&1===b.nodeType)return b.innerHTML;if("string"==typeof a&&!la.test(a)&&!$[(Y.exec(a)||["",""])[1].toLowerCase()]){a=n.htmlPrefilter(a);try{for(;d>c;c++)b=this[c]||{},1===b.nodeType&&(n.cleanData(_(b,!1)),b.innerHTML=a);b=0}catch(e){}}b&&this.empty().append(a)},null,a,arguments.length)},replaceWith:function(){var a=[];return ua(this,arguments,function(b){var c=this.parentNode;n.inArray(this,a)<0&&(n.cleanData(_(this)),c&&c.replaceChild(b,this))},a)}}),n.each({appendTo:"append",prependTo:"prepend",insertBefore:"before",insertAfter:"after",replaceAll:"replaceWith"},function(a,b){n.fn[a]=function(a){for(var c,d=[],e=n(a),f=e.length-1,h=0;f>=h;h++)c=h===f?this:this.clone(!0),n(e[h])[b](c),g.apply(d,c.get());return this.pushStack(d)}});var wa,xa={HTML:"block",BODY:"block"};function ya(a,b){var c=n(b.createElement(a)).appendTo(b.body),d=n.css(c[0],"display");return c.detach(),d}function za(a){var b=d,c=xa[a];return c||(c=ya(a,b),"none"!==c&&c||(wa=(wa||n("<iframe frameborder='0' width='0' height='0'/>")).appendTo(b.documentElement),b=wa[0].contentDocument,b.write(),b.close(),c=ya(a,b),wa.detach()),xa[a]=c),c}var Aa=/^margin/,Ba=new RegExp("^("+S+")(?!px)[a-z%]+$","i"),Ca=function(b){var c=b.ownerDocument.defaultView;return c&&c.opener||(c=a),c.getComputedStyle(b)},Da=function(a,b,c,d){var e,f,g={};for(f in b)g[f]=a.style[f],a.style[f]=b[f];e=c.apply(a,d||[]);for(f in b)a.style[f]=g[f];return e},Ea=d.documentElement;!function(){var b,c,e,f,g=d.createElement("div"),h=d.createElement("div");if(h.style){h.style.backgroundClip="content-box",h.cloneNode(!0).style.backgroundClip="",l.clearCloneStyle="content-box"===h.style.backgroundClip,g.style.cssText="border:0;width:8px;height:0;top:0;left:-9999px;padding:0;margin-top:1px;position:absolute",g.appendChild(h);function i(){h.style.cssText="-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;position:relative;display:block;margin:auto;border:1px;padding:1px;top:1%;width:50%",h.innerHTML="",Ea.appendChild(g);var d=a.getComputedStyle(h);b="1%"!==d.top,f="2px"===d.marginLeft,c="4px"===d.width,h.style.marginRight="50%",e="4px"===d.marginRight,Ea.removeChild(g)}n.extend(l,{pixelPosition:function(){return i(),b},boxSizingReliable:function(){return null==c&&i(),c},pixelMarginRight:function(){return null==c&&i(),e},reliableMarginLeft:function(){return null==c&&i(),f},reliableMarginRight:function(){var b,c=h.appendChild(d.createElement("div"));return c.style.cssText=h.style.cssText="-webkit-box-sizing:content-box;box-sizing:content-box;display:block;margin:0;border:0;padding:0",c.style.marginRight=c.style.width="0",h.style.width="1px",Ea.appendChild(g),b=!parseFloat(a.getComputedStyle(c).marginRight),Ea.removeChild(g),h.removeChild(c),b}})}}();function Fa(a,b,c){var d,e,f,g,h=a.style;return c=c||Ca(a),g=c?c.getPropertyValue(b)||c[b]:void 0,""!==g&&void 0!==g||n.contains(a.ownerDocument,a)||(g=n.style(a,b)),c&&!l.pixelMarginRight()&&Ba.test(g)&&Aa.test(b)&&(d=h.width,e=h.minWidth,f=h.maxWidth,h.minWidth=h.maxWidth=h.width=g,g=c.width,h.width=d,h.minWidth=e,h.maxWidth=f),void 0!==g?g+"":g}function Ga(a,b){return{get:function(){return a()?void delete this.get:(this.get=b).apply(this,arguments)}}}var Ha=/^(none|table(?!-c[ea]).+)/,Ia={position:"absolute",visibility:"hidden",display:"block"},Ja={letterSpacing:"0",fontWeight:"400"},Ka=["Webkit","O","Moz","ms"],La=d.createElement("div").style;function Ma(a){if(a in La)return a;var b=a[0].toUpperCase()+a.slice(1),c=Ka.length;while(c--)if(a=Ka[c]+b,a in La)return a}function Na(a,b,c){var d=T.exec(b);return d?Math.max(0,d[2]-(c||0))+(d[3]||"px"):b}function Oa(a,b,c,d,e){for(var f=c===(d?"border":"content")?4:"width"===b?1:0,g=0;4>f;f+=2)"margin"===c&&(g+=n.css(a,c+U[f],!0,e)),d?("content"===c&&(g-=n.css(a,"padding"+U[f],!0,e)),"margin"!==c&&(g-=n.css(a,"border"+U[f]+"Width",!0,e))):(g+=n.css(a,"padding"+U[f],!0,e),"padding"!==c&&(g+=n.css(a,"border"+U[f]+"Width",!0,e)));return g}function Pa(a,b,c){var d=!0,e="width"===b?a.offsetWidth:a.offsetHeight,f=Ca(a),g="border-box"===n.css(a,"boxSizing",!1,f);if(0>=e||null==e){if(e=Fa(a,b,f),(0>e||null==e)&&(e=a.style[b]),Ba.test(e))return e;d=g&&(l.boxSizingReliable()||e===a.style[b]),e=parseFloat(e)||0}return e+Oa(a,b,c||(g?"border":"content"),d,f)+"px"}function Qa(a,b){for(var c,d,e,f=[],g=0,h=a.length;h>g;g++)d=a[g],d.style&&(f[g]=N.get(d,"olddisplay"),c=d.style.display,b?(f[g]||"none"!==c||(d.style.display=""),""===d.style.display&&V(d)&&(f[g]=N.access(d,"olddisplay",za(d.nodeName)))):(e=V(d),"none"===c&&e||N.set(d,"olddisplay",e?c:n.css(d,"display"))));for(g=0;h>g;g++)d=a[g],d.style&&(b&&"none"!==d.style.display&&""!==d.style.display||(d.style.display=b?f[g]||"":"none"));return a}n.extend({cssHooks:{opacity:{get:function(a,b){if(b){var c=Fa(a,"opacity");return""===c?"1":c}}}},cssNumber:{animationIterationCount:!0,columnCount:!0,fillOpacity:!0,flexGrow:!0,flexShrink:!0,fontWeight:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,widows:!0,zIndex:!0,zoom:!0},cssProps:{"float":"cssFloat"},style:function(a,b,c,d){if(a&&3!==a.nodeType&&8!==a.nodeType&&a.style){var e,f,g,h=n.camelCase(b),i=a.style;return b=n.cssProps[h]||(n.cssProps[h]=Ma(h)||h),g=n.cssHooks[b]||n.cssHooks[h],void 0===c?g&&"get"in g&&void 0!==(e=g.get(a,!1,d))?e:i[b]:(f=typeof c,"string"===f&&(e=T.exec(c))&&e[1]&&(c=W(a,b,e),f="number"),null!=c&&c===c&&("number"===f&&(c+=e&&e[3]||(n.cssNumber[h]?"":"px")),l.clearCloneStyle||""!==c||0!==b.indexOf("background")||(i[b]="inherit"),g&&"set"in g&&void 0===(c=g.set(a,c,d))||(i[b]=c)),void 0)}},css:function(a,b,c,d){var e,f,g,h=n.camelCase(b);return b=n.cssProps[h]||(n.cssProps[h]=Ma(h)||h),g=n.cssHooks[b]||n.cssHooks[h],g&&"get"in g&&(e=g.get(a,!0,c)),void 0===e&&(e=Fa(a,b,d)),"normal"===e&&b in Ja&&(e=Ja[b]),""===c||c?(f=parseFloat(e),c===!0||isFinite(f)?f||0:e):e}}),n.each(["height","width"],function(a,b){n.cssHooks[b]={get:function(a,c,d){return c?Ha.test(n.css(a,"display"))&&0===a.offsetWidth?Da(a,Ia,function(){return Pa(a,b,d)}):Pa(a,b,d):void 0},set:function(a,c,d){var e,f=d&&Ca(a),g=d&&Oa(a,b,d,"border-box"===n.css(a,"boxSizing",!1,f),f);return g&&(e=T.exec(c))&&"px"!==(e[3]||"px")&&(a.style[b]=c,c=n.css(a,b)),Na(a,c,g)}}}),n.cssHooks.marginLeft=Ga(l.reliableMarginLeft,function(a,b){return b?(parseFloat(Fa(a,"marginLeft"))||a.getBoundingClientRect().left-Da(a,{marginLeft:0},function(){return a.getBoundingClientRect().left}))+"px":void 0}),n.cssHooks.marginRight=Ga(l.reliableMarginRight,function(a,b){return b?Da(a,{display:"inline-block"},Fa,[a,"marginRight"]):void 0}),n.each({margin:"",padding:"",border:"Width"},function(a,b){n.cssHooks[a+b]={expand:function(c){for(var d=0,e={},f="string"==typeof c?c.split(" "):[c];4>d;d++)e[a+U[d]+b]=f[d]||f[d-2]||f[0];return e}},Aa.test(a)||(n.cssHooks[a+b].set=Na)}),n.fn.extend({css:function(a,b){return K(this,function(a,b,c){var d,e,f={},g=0;if(n.isArray(b)){for(d=Ca(a),e=b.length;e>g;g++)f[b[g]]=n.css(a,b[g],!1,d);return f}return void 0!==c?n.style(a,b,c):n.css(a,b)},a,b,arguments.length>1)},show:function(){return Qa(this,!0)},hide:function(){return Qa(this)},toggle:function(a){return"boolean"==typeof a?a?this.show():this.hide():this.each(function(){V(this)?n(this).show():n(this).hide()})}});function Ra(a,b,c,d,e){return new Ra.prototype.init(a,b,c,d,e)}n.Tween=Ra,Ra.prototype={constructor:Ra,init:function(a,b,c,d,e,f){this.elem=a,this.prop=c,this.easing=e||n.easing._default,this.options=b,this.start=this.now=this.cur(),this.end=d,this.unit=f||(n.cssNumber[c]?"":"px")},cur:function(){var a=Ra.propHooks[this.prop];return a&&a.get?a.get(this):Ra.propHooks._default.get(this)},run:function(a){var b,c=Ra.propHooks[this.prop];return this.options.duration?this.pos=b=n.easing[this.easing](a,this.options.duration*a,0,1,this.options.duration):this.pos=b=a,this.now=(this.end-this.start)*b+this.start,this.options.step&&this.options.step.call(this.elem,this.now,this),c&&c.set?c.set(this):Ra.propHooks._default.set(this),this}},Ra.prototype.init.prototype=Ra.prototype,Ra.propHooks={_default:{get:function(a){var b;return 1!==a.elem.nodeType||null!=a.elem[a.prop]&&null==a.elem.style[a.prop]?a.elem[a.prop]:(b=n.css(a.elem,a.prop,""),b&&"auto"!==b?b:0)},set:function(a){n.fx.step[a.prop]?n.fx.step[a.prop](a):1!==a.elem.nodeType||null==a.elem.style[n.cssProps[a.prop]]&&!n.cssHooks[a.prop]?a.elem[a.prop]=a.now:n.style(a.elem,a.prop,a.now+a.unit)}}},Ra.propHooks.scrollTop=Ra.propHooks.scrollLeft={set:function(a){a.elem.nodeType&&a.elem.parentNode&&(a.elem[a.prop]=a.now)}},n.easing={linear:function(a){return a},swing:function(a){return.5-Math.cos(a*Math.PI)/2},_default:"swing"},n.fx=Ra.prototype.init,n.fx.step={};var Sa,Ta,Ua=/^(?:toggle|show|hide)$/,Va=/queueHooks$/;function Wa(){return a.setTimeout(function(){Sa=void 0}),Sa=n.now()}function Xa(a,b){var c,d=0,e={height:a};for(b=b?1:0;4>d;d+=2-b)c=U[d],e["margin"+c]=e["padding"+c]=a;return b&&(e.opacity=e.width=a),e}function Ya(a,b,c){for(var d,e=(_a.tweeners[b]||[]).concat(_a.tweeners["*"]),f=0,g=e.length;g>f;f++)if(d=e[f].call(c,b,a))return d}function Za(a,b,c){var d,e,f,g,h,i,j,k,l=this,m={},o=a.style,p=a.nodeType&&V(a),q=N.get(a,"fxshow");c.queue||(h=n._queueHooks(a,"fx"),null==h.unqueued&&(h.unqueued=0,i=h.empty.fire,h.empty.fire=function(){h.unqueued||i()}),h.unqueued++,l.always(function(){l.always(function(){h.unqueued--,n.queue(a,"fx").length||h.empty.fire()})})),1===a.nodeType&&("height"in b||"width"in b)&&(c.overflow=[o.overflow,o.overflowX,o.overflowY],j=n.css(a,"display"),k="none"===j?N.get(a,"olddisplay")||za(a.nodeName):j,"inline"===k&&"none"===n.css(a,"float")&&(o.display="inline-block")),c.overflow&&(o.overflow="hidden",l.always(function(){o.overflow=c.overflow[0],o.overflowX=c.overflow[1],o.overflowY=c.overflow[2]}));for(d in b)if(e=b[d],Ua.exec(e)){if(delete b[d],f=f||"toggle"===e,e===(p?"hide":"show")){if("show"!==e||!q||void 0===q[d])continue;p=!0}m[d]=q&&q[d]||n.style(a,d)}else j=void 0;if(n.isEmptyObject(m))"inline"===("none"===j?za(a.nodeName):j)&&(o.display=j);else{q?"hidden"in q&&(p=q.hidden):q=N.access(a,"fxshow",{}),f&&(q.hidden=!p),p?n(a).show():l.done(function(){n(a).hide()}),l.done(function(){var b;N.remove(a,"fxshow");for(b in m)n.style(a,b,m[b])});for(d in m)g=Ya(p?q[d]:0,d,l),d in q||(q[d]=g.start,p&&(g.end=g.start,g.start="width"===d||"height"===d?1:0))}}function $a(a,b){var c,d,e,f,g;for(c in a)if(d=n.camelCase(c),e=b[d],f=a[c],n.isArray(f)&&(e=f[1],f=a[c]=f[0]),c!==d&&(a[d]=f,delete a[c]),g=n.cssHooks[d],g&&"expand"in g){f=g.expand(f),delete a[d];for(c in f)c in a||(a[c]=f[c],b[c]=e)}else b[d]=e}function _a(a,b,c){var d,e,f=0,g=_a.prefilters.length,h=n.Deferred().always(function(){delete i.elem}),i=function(){if(e)return!1;for(var b=Sa||Wa(),c=Math.max(0,j.startTime+j.duration-b),d=c/j.duration||0,f=1-d,g=0,i=j.tweens.length;i>g;g++)j.tweens[g].run(f);return h.notifyWith(a,[j,f,c]),1>f&&i?c:(h.resolveWith(a,[j]),!1)},j=h.promise({elem:a,props:n.extend({},b),opts:n.extend(!0,{specialEasing:{},easing:n.easing._default},c),originalProperties:b,originalOptions:c,startTime:Sa||Wa(),duration:c.duration,tweens:[],createTween:function(b,c){var d=n.Tween(a,j.opts,b,c,j.opts.specialEasing[b]||j.opts.easing);return j.tweens.push(d),d},stop:function(b){var c=0,d=b?j.tweens.length:0;if(e)return this;for(e=!0;d>c;c++)j.tweens[c].run(1);return b?(h.notifyWith(a,[j,1,0]),h.resolveWith(a,[j,b])):h.rejectWith(a,[j,b]),this}}),k=j.props;for($a(k,j.opts.specialEasing);g>f;f++)if(d=_a.prefilters[f].call(j,a,k,j.opts))return n.isFunction(d.stop)&&(n._queueHooks(j.elem,j.opts.queue).stop=n.proxy(d.stop,d)),d;return n.map(k,Ya,j),n.isFunction(j.opts.start)&&j.opts.start.call(a,j),n.fx.timer(n.extend(i,{elem:a,anim:j,queue:j.opts.queue})),j.progress(j.opts.progress).done(j.opts.done,j.opts.complete).fail(j.opts.fail).always(j.opts.always)}n.Animation=n.extend(_a,{tweeners:{"*":[function(a,b){var c=this.createTween(a,b);return W(c.elem,a,T.exec(b),c),c}]},tweener:function(a,b){n.isFunction(a)?(b=a,a=["*"]):a=a.match(G);for(var c,d=0,e=a.length;e>d;d++)c=a[d],_a.tweeners[c]=_a.tweeners[c]||[],_a.tweeners[c].unshift(b)},prefilters:[Za],prefilter:function(a,b){b?_a.prefilters.unshift(a):_a.prefilters.push(a)}}),n.speed=function(a,b,c){var d=a&&"object"==typeof a?n.extend({},a):{complete:c||!c&&b||n.isFunction(a)&&a,duration:a,easing:c&&b||b&&!n.isFunction(b)&&b};return d.duration=n.fx.off?0:"number"==typeof d.duration?d.duration:d.duration in n.fx.speeds?n.fx.speeds[d.duration]:n.fx.speeds._default,null!=d.queue&&d.queue!==!0||(d.queue="fx"),d.old=d.complete,d.complete=function(){n.isFunction(d.old)&&d.old.call(this),d.queue&&n.dequeue(this,d.queue)},d},n.fn.extend({fadeTo:function(a,b,c,d){return this.filter(V).css("opacity",0).show().end().animate({opacity:b},a,c,d)},animate:function(a,b,c,d){var e=n.isEmptyObject(a),f=n.speed(b,c,d),g=function(){var b=_a(this,n.extend({},a),f);(e||N.get(this,"finish"))&&b.stop(!0)};return g.finish=g,e||f.queue===!1?this.each(g):this.queue(f.queue,g)},stop:function(a,b,c){var d=function(a){var b=a.stop;delete a.stop,b(c)};return"string"!=typeof a&&(c=b,b=a,a=void 0),b&&a!==!1&&this.queue(a||"fx",[]),this.each(function(){var b=!0,e=null!=a&&a+"queueHooks",f=n.timers,g=N.get(this);if(e)g[e]&&g[e].stop&&d(g[e]);else for(e in g)g[e]&&g[e].stop&&Va.test(e)&&d(g[e]);for(e=f.length;e--;)f[e].elem!==this||null!=a&&f[e].queue!==a||(f[e].anim.stop(c),b=!1,f.splice(e,1));!b&&c||n.dequeue(this,a)})},finish:function(a){return a!==!1&&(a=a||"fx"),this.each(function(){var b,c=N.get(this),d=c[a+"queue"],e=c[a+"queueHooks"],f=n.timers,g=d?d.length:0;for(c.finish=!0,n.queue(this,a,[]),e&&e.stop&&e.stop.call(this,!0),b=f.length;b--;)f[b].elem===this&&f[b].queue===a&&(f[b].anim.stop(!0),f.splice(b,1));for(b=0;g>b;b++)d[b]&&d[b].finish&&d[b].finish.call(this);delete c.finish})}}),n.each(["toggle","show","hide"],function(a,b){var c=n.fn[b];n.fn[b]=function(a,d,e){return null==a||"boolean"==typeof a?c.apply(this,arguments):this.animate(Xa(b,!0),a,d,e)}}),n.each({slideDown:Xa("show"),slideUp:Xa("hide"),slideToggle:Xa("toggle"),fadeIn:{opacity:"show"},fadeOut:{opacity:"hide"},fadeToggle:{opacity:"toggle"}},function(a,b){n.fn[a]=function(a,c,d){return this.animate(b,a,c,d)}}),n.timers=[],n.fx.tick=function(){var a,b=0,c=n.timers;for(Sa=n.now();b<c.length;b++)a=c[b],a()||c[b]!==a||c.splice(b--,1);c.length||n.fx.stop(),Sa=void 0},n.fx.timer=function(a){n.timers.push(a),a()?n.fx.start():n.timers.pop()},n.fx.interval=13,n.fx.start=function(){Ta||(Ta=a.setInterval(n.fx.tick,n.fx.interval))},n.fx.stop=function(){a.clearInterval(Ta),Ta=null},n.fx.speeds={slow:600,fast:200,_default:400},n.fn.delay=function(b,c){return b=n.fx?n.fx.speeds[b]||b:b,c=c||"fx",this.queue(c,function(c,d){var e=a.setTimeout(c,b);d.stop=function(){a.clearTimeout(e)}})},function(){var a=d.createElement("input"),b=d.createElement("select"),c=b.appendChild(d.createElement("option"));a.type="checkbox",l.checkOn=""!==a.value,l.optSelected=c.selected,b.disabled=!0,l.optDisabled=!c.disabled,a=d.createElement("input"),a.value="t",a.type="radio",l.radioValue="t"===a.value}();var ab,bb=n.expr.attrHandle;n.fn.extend({attr:function(a,b){return K(this,n.attr,a,b,arguments.length>1)},removeAttr:function(a){return this.each(function(){n.removeAttr(this,a)})}}),n.extend({attr:function(a,b,c){var d,e,f=a.nodeType;if(3!==f&&8!==f&&2!==f)return"undefined"==typeof a.getAttribute?n.prop(a,b,c):(1===f&&n.isXMLDoc(a)||(b=b.toLowerCase(),e=n.attrHooks[b]||(n.expr.match.bool.test(b)?ab:void 0)),void 0!==c?null===c?void n.removeAttr(a,b):e&&"set"in e&&void 0!==(d=e.set(a,c,b))?d:(a.setAttribute(b,c+""),c):e&&"get"in e&&null!==(d=e.get(a,b))?d:(d=n.find.attr(a,b),null==d?void 0:d))},attrHooks:{type:{set:function(a,b){if(!l.radioValue&&"radio"===b&&n.nodeName(a,"input")){var c=a.value;return a.setAttribute("type",b),c&&(a.value=c),b}}}},removeAttr:function(a,b){var c,d,e=0,f=b&&b.match(G);if(f&&1===a.nodeType)while(c=f[e++])d=n.propFix[c]||c,n.expr.match.bool.test(c)&&(a[d]=!1),a.removeAttribute(c)}}),ab={set:function(a,b,c){return b===!1?n.removeAttr(a,c):a.setAttribute(c,c),c}},n.each(n.expr.match.bool.source.match(/\w+/g),function(a,b){var c=bb[b]||n.find.attr;bb[b]=function(a,b,d){var e,f;return d||(f=bb[b],bb[b]=e,e=null!=c(a,b,d)?b.toLowerCase():null,bb[b]=f),e}});var cb=/^(?:input|select|textarea|button)$/i,db=/^(?:a|area)$/i;n.fn.extend({prop:function(a,b){return K(this,n.prop,a,b,arguments.length>1)},removeProp:function(a){return this.each(function(){delete this[n.propFix[a]||a]})}}),n.extend({prop:function(a,b,c){var d,e,f=a.nodeType;if(3!==f&&8!==f&&2!==f)return 1===f&&n.isXMLDoc(a)||(b=n.propFix[b]||b,e=n.propHooks[b]),
void 0!==c?e&&"set"in e&&void 0!==(d=e.set(a,c,b))?d:a[b]=c:e&&"get"in e&&null!==(d=e.get(a,b))?d:a[b]},propHooks:{tabIndex:{get:function(a){var b=n.find.attr(a,"tabindex");return b?parseInt(b,10):cb.test(a.nodeName)||db.test(a.nodeName)&&a.href?0:-1}}},propFix:{"for":"htmlFor","class":"className"}}),l.optSelected||(n.propHooks.selected={get:function(a){var b=a.parentNode;return b&&b.parentNode&&b.parentNode.selectedIndex,null},set:function(a){var b=a.parentNode;b&&(b.selectedIndex,b.parentNode&&b.parentNode.selectedIndex)}}),n.each(["tabIndex","readOnly","maxLength","cellSpacing","cellPadding","rowSpan","colSpan","useMap","frameBorder","contentEditable"],function(){n.propFix[this.toLowerCase()]=this});var eb=/[\t\r\n\f]/g;function fb(a){return a.getAttribute&&a.getAttribute("class")||""}n.fn.extend({addClass:function(a){var b,c,d,e,f,g,h,i=0;if(n.isFunction(a))return this.each(function(b){n(this).addClass(a.call(this,b,fb(this)))});if("string"==typeof a&&a){b=a.match(G)||[];while(c=this[i++])if(e=fb(c),d=1===c.nodeType&&(" "+e+" ").replace(eb," ")){g=0;while(f=b[g++])d.indexOf(" "+f+" ")<0&&(d+=f+" ");h=n.trim(d),e!==h&&c.setAttribute("class",h)}}return this},removeClass:function(a){var b,c,d,e,f,g,h,i=0;if(n.isFunction(a))return this.each(function(b){n(this).removeClass(a.call(this,b,fb(this)))});if(!arguments.length)return this.attr("class","");if("string"==typeof a&&a){b=a.match(G)||[];while(c=this[i++])if(e=fb(c),d=1===c.nodeType&&(" "+e+" ").replace(eb," ")){g=0;while(f=b[g++])while(d.indexOf(" "+f+" ")>-1)d=d.replace(" "+f+" "," ");h=n.trim(d),e!==h&&c.setAttribute("class",h)}}return this},toggleClass:function(a,b){var c=typeof a;return"boolean"==typeof b&&"string"===c?b?this.addClass(a):this.removeClass(a):n.isFunction(a)?this.each(function(c){n(this).toggleClass(a.call(this,c,fb(this),b),b)}):this.each(function(){var b,d,e,f;if("string"===c){d=0,e=n(this),f=a.match(G)||[];while(b=f[d++])e.hasClass(b)?e.removeClass(b):e.addClass(b)}else void 0!==a&&"boolean"!==c||(b=fb(this),b&&N.set(this,"__className__",b),this.setAttribute&&this.setAttribute("class",b||a===!1?"":N.get(this,"__className__")||""))})},hasClass:function(a){var b,c,d=0;b=" "+a+" ";while(c=this[d++])if(1===c.nodeType&&(" "+fb(c)+" ").replace(eb," ").indexOf(b)>-1)return!0;return!1}});var gb=/\r/g,hb=/[\x20\t\r\n\f]+/g;n.fn.extend({val:function(a){var b,c,d,e=this[0];{if(arguments.length)return d=n.isFunction(a),this.each(function(c){var e;1===this.nodeType&&(e=d?a.call(this,c,n(this).val()):a,null==e?e="":"number"==typeof e?e+="":n.isArray(e)&&(e=n.map(e,function(a){return null==a?"":a+""})),b=n.valHooks[this.type]||n.valHooks[this.nodeName.toLowerCase()],b&&"set"in b&&void 0!==b.set(this,e,"value")||(this.value=e))});if(e)return b=n.valHooks[e.type]||n.valHooks[e.nodeName.toLowerCase()],b&&"get"in b&&void 0!==(c=b.get(e,"value"))?c:(c=e.value,"string"==typeof c?c.replace(gb,""):null==c?"":c)}}}),n.extend({valHooks:{option:{get:function(a){var b=n.find.attr(a,"value");return null!=b?b:n.trim(n.text(a)).replace(hb," ")}},select:{get:function(a){for(var b,c,d=a.options,e=a.selectedIndex,f="select-one"===a.type||0>e,g=f?null:[],h=f?e+1:d.length,i=0>e?h:f?e:0;h>i;i++)if(c=d[i],(c.selected||i===e)&&(l.optDisabled?!c.disabled:null===c.getAttribute("disabled"))&&(!c.parentNode.disabled||!n.nodeName(c.parentNode,"optgroup"))){if(b=n(c).val(),f)return b;g.push(b)}return g},set:function(a,b){var c,d,e=a.options,f=n.makeArray(b),g=e.length;while(g--)d=e[g],(d.selected=n.inArray(n.valHooks.option.get(d),f)>-1)&&(c=!0);return c||(a.selectedIndex=-1),f}}}}),n.each(["radio","checkbox"],function(){n.valHooks[this]={set:function(a,b){return n.isArray(b)?a.checked=n.inArray(n(a).val(),b)>-1:void 0}},l.checkOn||(n.valHooks[this].get=function(a){return null===a.getAttribute("value")?"on":a.value})});var ib=/^(?:focusinfocus|focusoutblur)$/;n.extend(n.event,{trigger:function(b,c,e,f){var g,h,i,j,l,m,o,p=[e||d],q=k.call(b,"type")?b.type:b,r=k.call(b,"namespace")?b.namespace.split("."):[];if(h=i=e=e||d,3!==e.nodeType&&8!==e.nodeType&&!ib.test(q+n.event.triggered)&&(q.indexOf(".")>-1&&(r=q.split("."),q=r.shift(),r.sort()),l=q.indexOf(":")<0&&"on"+q,b=b[n.expando]?b:new n.Event(q,"object"==typeof b&&b),b.isTrigger=f?2:3,b.namespace=r.join("."),b.rnamespace=b.namespace?new RegExp("(^|\\.)"+r.join("\\.(?:.*\\.|)")+"(\\.|$)"):null,b.result=void 0,b.target||(b.target=e),c=null==c?[b]:n.makeArray(c,[b]),o=n.event.special[q]||{},f||!o.trigger||o.trigger.apply(e,c)!==!1)){if(!f&&!o.noBubble&&!n.isWindow(e)){for(j=o.delegateType||q,ib.test(j+q)||(h=h.parentNode);h;h=h.parentNode)p.push(h),i=h;i===(e.ownerDocument||d)&&p.push(i.defaultView||i.parentWindow||a)}g=0;while((h=p[g++])&&!b.isPropagationStopped())b.type=g>1?j:o.bindType||q,m=(N.get(h,"events")||{})[b.type]&&N.get(h,"handle"),m&&m.apply(h,c),m=l&&h[l],m&&m.apply&&L(h)&&(b.result=m.apply(h,c),b.result===!1&&b.preventDefault());return b.type=q,f||b.isDefaultPrevented()||o._default&&o._default.apply(p.pop(),c)!==!1||!L(e)||l&&n.isFunction(e[q])&&!n.isWindow(e)&&(i=e[l],i&&(e[l]=null),n.event.triggered=q,e[q](),n.event.triggered=void 0,i&&(e[l]=i)),b.result}},simulate:function(a,b,c){var d=n.extend(new n.Event,c,{type:a,isSimulated:!0});n.event.trigger(d,null,b)}}),n.fn.extend({trigger:function(a,b){return this.each(function(){n.event.trigger(a,b,this)})},triggerHandler:function(a,b){var c=this[0];return c?n.event.trigger(a,b,c,!0):void 0}}),n.each("blur focus focusin focusout load resize scroll unload click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup error contextmenu".split(" "),function(a,b){n.fn[b]=function(a,c){return arguments.length>0?this.on(b,null,a,c):this.trigger(b)}}),n.fn.extend({hover:function(a,b){return this.mouseenter(a).mouseleave(b||a)}}),l.focusin="onfocusin"in a,l.focusin||n.each({focus:"focusin",blur:"focusout"},function(a,b){var c=function(a){n.event.simulate(b,a.target,n.event.fix(a))};n.event.special[b]={setup:function(){var d=this.ownerDocument||this,e=N.access(d,b);e||d.addEventListener(a,c,!0),N.access(d,b,(e||0)+1)},teardown:function(){var d=this.ownerDocument||this,e=N.access(d,b)-1;e?N.access(d,b,e):(d.removeEventListener(a,c,!0),N.remove(d,b))}}});var jb=a.location,kb=n.now(),lb=/\?/;n.parseJSON=function(a){return JSON.parse(a+"")},n.parseXML=function(b){var c;if(!b||"string"!=typeof b)return null;try{c=(new a.DOMParser).parseFromString(b,"text/xml")}catch(d){c=void 0}return c&&!c.getElementsByTagName("parsererror").length||n.error("Invalid XML: "+b),c};var mb=/#.*$/,nb=/([?&])_=[^&]*/,ob=/^(.*?):[ \t]*([^\r\n]*)$/gm,pb=/^(?:about|app|app-storage|.+-extension|file|res|widget):$/,qb=/^(?:GET|HEAD)$/,rb=/^\/\//,sb={},tb={},ub="*/".concat("*"),vb=d.createElement("a");vb.href=jb.href;function wb(a){return function(b,c){"string"!=typeof b&&(c=b,b="*");var d,e=0,f=b.toLowerCase().match(G)||[];if(n.isFunction(c))while(d=f[e++])"+"===d[0]?(d=d.slice(1)||"*",(a[d]=a[d]||[]).unshift(c)):(a[d]=a[d]||[]).push(c)}}function xb(a,b,c,d){var e={},f=a===tb;function g(h){var i;return e[h]=!0,n.each(a[h]||[],function(a,h){var j=h(b,c,d);return"string"!=typeof j||f||e[j]?f?!(i=j):void 0:(b.dataTypes.unshift(j),g(j),!1)}),i}return g(b.dataTypes[0])||!e["*"]&&g("*")}function yb(a,b){var c,d,e=n.ajaxSettings.flatOptions||{};for(c in b)void 0!==b[c]&&((e[c]?a:d||(d={}))[c]=b[c]);return d&&n.extend(!0,a,d),a}function zb(a,b,c){var d,e,f,g,h=a.contents,i=a.dataTypes;while("*"===i[0])i.shift(),void 0===d&&(d=a.mimeType||b.getResponseHeader("Content-Type"));if(d)for(e in h)if(h[e]&&h[e].test(d)){i.unshift(e);break}if(i[0]in c)f=i[0];else{for(e in c){if(!i[0]||a.converters[e+" "+i[0]]){f=e;break}g||(g=e)}f=f||g}return f?(f!==i[0]&&i.unshift(f),c[f]):void 0}function Ab(a,b,c,d){var e,f,g,h,i,j={},k=a.dataTypes.slice();if(k[1])for(g in a.converters)j[g.toLowerCase()]=a.converters[g];f=k.shift();while(f)if(a.responseFields[f]&&(c[a.responseFields[f]]=b),!i&&d&&a.dataFilter&&(b=a.dataFilter(b,a.dataType)),i=f,f=k.shift())if("*"===f)f=i;else if("*"!==i&&i!==f){if(g=j[i+" "+f]||j["* "+f],!g)for(e in j)if(h=e.split(" "),h[1]===f&&(g=j[i+" "+h[0]]||j["* "+h[0]])){g===!0?g=j[e]:j[e]!==!0&&(f=h[0],k.unshift(h[1]));break}if(g!==!0)if(g&&a["throws"])b=g(b);else try{b=g(b)}catch(l){return{state:"parsererror",error:g?l:"No conversion from "+i+" to "+f}}}return{state:"success",data:b}}n.extend({active:0,lastModified:{},etag:{},ajaxSettings:{url:jb.href,type:"GET",isLocal:pb.test(jb.protocol),global:!0,processData:!0,async:!0,contentType:"application/x-www-form-urlencoded; charset=UTF-8",accepts:{"*":ub,text:"text/plain",html:"text/html",xml:"application/xml, text/xml",json:"application/json, text/javascript"},contents:{xml:/\bxml\b/,html:/\bhtml/,json:/\bjson\b/},responseFields:{xml:"responseXML",text:"responseText",json:"responseJSON"},converters:{"* text":String,"text html":!0,"text json":n.parseJSON,"text xml":n.parseXML},flatOptions:{url:!0,context:!0}},ajaxSetup:function(a,b){return b?yb(yb(a,n.ajaxSettings),b):yb(n.ajaxSettings,a)},ajaxPrefilter:wb(sb),ajaxTransport:wb(tb),ajax:function(b,c){"object"==typeof b&&(c=b,b=void 0),c=c||{};var e,f,g,h,i,j,k,l,m=n.ajaxSetup({},c),o=m.context||m,p=m.context&&(o.nodeType||o.jquery)?n(o):n.event,q=n.Deferred(),r=n.Callbacks("once memory"),s=m.statusCode||{},t={},u={},v=0,w="canceled",x={readyState:0,getResponseHeader:function(a){var b;if(2===v){if(!h){h={};while(b=ob.exec(g))h[b[1].toLowerCase()]=b[2]}b=h[a.toLowerCase()]}return null==b?null:b},getAllResponseHeaders:function(){return 2===v?g:null},setRequestHeader:function(a,b){var c=a.toLowerCase();return v||(a=u[c]=u[c]||a,t[a]=b),this},overrideMimeType:function(a){return v||(m.mimeType=a),this},statusCode:function(a){var b;if(a)if(2>v)for(b in a)s[b]=[s[b],a[b]];else x.always(a[x.status]);return this},abort:function(a){var b=a||w;return e&&e.abort(b),z(0,b),this}};if(q.promise(x).complete=r.add,x.success=x.done,x.error=x.fail,m.url=((b||m.url||jb.href)+"").replace(mb,"").replace(rb,jb.protocol+"//"),m.type=c.method||c.type||m.method||m.type,m.dataTypes=n.trim(m.dataType||"*").toLowerCase().match(G)||[""],null==m.crossDomain){j=d.createElement("a");try{j.href=m.url,j.href=j.href,m.crossDomain=vb.protocol+"//"+vb.host!=j.protocol+"//"+j.host}catch(y){m.crossDomain=!0}}if(m.data&&m.processData&&"string"!=typeof m.data&&(m.data=n.param(m.data,m.traditional)),xb(sb,m,c,x),2===v)return x;k=n.event&&m.global,k&&0===n.active++&&n.event.trigger("ajaxStart"),m.type=m.type.toUpperCase(),m.hasContent=!qb.test(m.type),f=m.url,m.hasContent||(m.data&&(f=m.url+=(lb.test(f)?"&":"?")+m.data,delete m.data),m.cache===!1&&(m.url=nb.test(f)?f.replace(nb,"$1_="+kb++):f+(lb.test(f)?"&":"?")+"_="+kb++)),m.ifModified&&(n.lastModified[f]&&x.setRequestHeader("If-Modified-Since",n.lastModified[f]),n.etag[f]&&x.setRequestHeader("If-None-Match",n.etag[f])),(m.data&&m.hasContent&&m.contentType!==!1||c.contentType)&&x.setRequestHeader("Content-Type",m.contentType),x.setRequestHeader("Accept",m.dataTypes[0]&&m.accepts[m.dataTypes[0]]?m.accepts[m.dataTypes[0]]+("*"!==m.dataTypes[0]?", "+ub+"; q=0.01":""):m.accepts["*"]);for(l in m.headers)x.setRequestHeader(l,m.headers[l]);if(m.beforeSend&&(m.beforeSend.call(o,x,m)===!1||2===v))return x.abort();w="abort";for(l in{success:1,error:1,complete:1})x[l](m[l]);if(e=xb(tb,m,c,x)){if(x.readyState=1,k&&p.trigger("ajaxSend",[x,m]),2===v)return x;m.async&&m.timeout>0&&(i=a.setTimeout(function(){x.abort("timeout")},m.timeout));try{v=1,e.send(t,z)}catch(y){if(!(2>v))throw y;z(-1,y)}}else z(-1,"No Transport");function z(b,c,d,h){var j,l,t,u,w,y=c;2!==v&&(v=2,i&&a.clearTimeout(i),e=void 0,g=h||"",x.readyState=b>0?4:0,j=b>=200&&300>b||304===b,d&&(u=zb(m,x,d)),u=Ab(m,u,x,j),j?(m.ifModified&&(w=x.getResponseHeader("Last-Modified"),w&&(n.lastModified[f]=w),w=x.getResponseHeader("etag"),w&&(n.etag[f]=w)),204===b||"HEAD"===m.type?y="nocontent":304===b?y="notmodified":(y=u.state,l=u.data,t=u.error,j=!t)):(t=y,!b&&y||(y="error",0>b&&(b=0))),x.status=b,x.statusText=(c||y)+"",j?q.resolveWith(o,[l,y,x]):q.rejectWith(o,[x,y,t]),x.statusCode(s),s=void 0,k&&p.trigger(j?"ajaxSuccess":"ajaxError",[x,m,j?l:t]),r.fireWith(o,[x,y]),k&&(p.trigger("ajaxComplete",[x,m]),--n.active||n.event.trigger("ajaxStop")))}return x},getJSON:function(a,b,c){return n.get(a,b,c,"json")},getScript:function(a,b){return n.get(a,void 0,b,"script")}}),n.each(["get","post"],function(a,b){n[b]=function(a,c,d,e){return n.isFunction(c)&&(e=e||d,d=c,c=void 0),n.ajax(n.extend({url:a,type:b,dataType:e,data:c,success:d},n.isPlainObject(a)&&a))}}),n._evalUrl=function(a){return n.ajax({url:a,type:"GET",dataType:"script",async:!1,global:!1,"throws":!0})},n.fn.extend({wrapAll:function(a){var b;return n.isFunction(a)?this.each(function(b){n(this).wrapAll(a.call(this,b))}):(this[0]&&(b=n(a,this[0].ownerDocument).eq(0).clone(!0),this[0].parentNode&&b.insertBefore(this[0]),b.map(function(){var a=this;while(a.firstElementChild)a=a.firstElementChild;return a}).append(this)),this)},wrapInner:function(a){return n.isFunction(a)?this.each(function(b){n(this).wrapInner(a.call(this,b))}):this.each(function(){var b=n(this),c=b.contents();c.length?c.wrapAll(a):b.append(a)})},wrap:function(a){var b=n.isFunction(a);return this.each(function(c){n(this).wrapAll(b?a.call(this,c):a)})},unwrap:function(){return this.parent().each(function(){n.nodeName(this,"body")||n(this).replaceWith(this.childNodes)}).end()}}),n.expr.filters.hidden=function(a){return!n.expr.filters.visible(a)},n.expr.filters.visible=function(a){return a.offsetWidth>0||a.offsetHeight>0||a.getClientRects().length>0};var Bb=/%20/g,Cb=/\[\]$/,Db=/\r?\n/g,Eb=/^(?:submit|button|image|reset|file)$/i,Fb=/^(?:input|select|textarea|keygen)/i;function Gb(a,b,c,d){var e;if(n.isArray(b))n.each(b,function(b,e){c||Cb.test(a)?d(a,e):Gb(a+"["+("object"==typeof e&&null!=e?b:"")+"]",e,c,d)});else if(c||"object"!==n.type(b))d(a,b);else for(e in b)Gb(a+"["+e+"]",b[e],c,d)}n.param=function(a,b){var c,d=[],e=function(a,b){b=n.isFunction(b)?b():null==b?"":b,d[d.length]=encodeURIComponent(a)+"="+encodeURIComponent(b)};if(void 0===b&&(b=n.ajaxSettings&&n.ajaxSettings.traditional),n.isArray(a)||a.jquery&&!n.isPlainObject(a))n.each(a,function(){e(this.name,this.value)});else for(c in a)Gb(c,a[c],b,e);return d.join("&").replace(Bb,"+")},n.fn.extend({serialize:function(){return n.param(this.serializeArray())},serializeArray:function(){return this.map(function(){var a=n.prop(this,"elements");return a?n.makeArray(a):this}).filter(function(){var a=this.type;return this.name&&!n(this).is(":disabled")&&Fb.test(this.nodeName)&&!Eb.test(a)&&(this.checked||!X.test(a))}).map(function(a,b){var c=n(this).val();return null==c?null:n.isArray(c)?n.map(c,function(a){return{name:b.name,value:a.replace(Db,"\r\n")}}):{name:b.name,value:c.replace(Db,"\r\n")}}).get()}}),n.ajaxSettings.xhr=function(){try{return new a.XMLHttpRequest}catch(b){}};var Hb={0:200,1223:204},Ib=n.ajaxSettings.xhr();l.cors=!!Ib&&"withCredentials"in Ib,l.ajax=Ib=!!Ib,n.ajaxTransport(function(b){var c,d;return l.cors||Ib&&!b.crossDomain?{send:function(e,f){var g,h=b.xhr();if(h.open(b.type,b.url,b.async,b.username,b.password),b.xhrFields)for(g in b.xhrFields)h[g]=b.xhrFields[g];b.mimeType&&h.overrideMimeType&&h.overrideMimeType(b.mimeType),b.crossDomain||e["X-Requested-With"]||(e["X-Requested-With"]="XMLHttpRequest");for(g in e)h.setRequestHeader(g,e[g]);c=function(a){return function(){c&&(c=d=h.onload=h.onerror=h.onabort=h.onreadystatechange=null,"abort"===a?h.abort():"error"===a?"number"!=typeof h.status?f(0,"error"):f(h.status,h.statusText):f(Hb[h.status]||h.status,h.statusText,"text"!==(h.responseType||"text")||"string"!=typeof h.responseText?{binary:h.response}:{text:h.responseText},h.getAllResponseHeaders()))}},h.onload=c(),d=h.onerror=c("error"),void 0!==h.onabort?h.onabort=d:h.onreadystatechange=function(){4===h.readyState&&a.setTimeout(function(){c&&d()})},c=c("abort");try{h.send(b.hasContent&&b.data||null)}catch(i){if(c)throw i}},abort:function(){c&&c()}}:void 0}),n.ajaxSetup({accepts:{script:"text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"},contents:{script:/\b(?:java|ecma)script\b/},converters:{"text script":function(a){return n.globalEval(a),a}}}),n.ajaxPrefilter("script",function(a){void 0===a.cache&&(a.cache=!1),a.crossDomain&&(a.type="GET")}),n.ajaxTransport("script",function(a){if(a.crossDomain){var b,c;return{send:function(e,f){b=n("<script>").prop({charset:a.scriptCharset,src:a.url}).on("load error",c=function(a){b.remove(),c=null,a&&f("error"===a.type?404:200,a.type)}),d.head.appendChild(b[0])},abort:function(){c&&c()}}}});var Jb=[],Kb=/(=)\?(?=&|$)|\?\?/;n.ajaxSetup({jsonp:"callback",jsonpCallback:function(){var a=Jb.pop()||n.expando+"_"+kb++;return this[a]=!0,a}}),n.ajaxPrefilter("json jsonp",function(b,c,d){var e,f,g,h=b.jsonp!==!1&&(Kb.test(b.url)?"url":"string"==typeof b.data&&0===(b.contentType||"").indexOf("application/x-www-form-urlencoded")&&Kb.test(b.data)&&"data");return h||"jsonp"===b.dataTypes[0]?(e=b.jsonpCallback=n.isFunction(b.jsonpCallback)?b.jsonpCallback():b.jsonpCallback,h?b[h]=b[h].replace(Kb,"$1"+e):b.jsonp!==!1&&(b.url+=(lb.test(b.url)?"&":"?")+b.jsonp+"="+e),b.converters["script json"]=function(){return g||n.error(e+" was not called"),g[0]},b.dataTypes[0]="json",f=a[e],a[e]=function(){g=arguments},d.always(function(){void 0===f?n(a).removeProp(e):a[e]=f,b[e]&&(b.jsonpCallback=c.jsonpCallback,Jb.push(e)),g&&n.isFunction(f)&&f(g[0]),g=f=void 0}),"script"):void 0}),n.parseHTML=function(a,b,c){if(!a||"string"!=typeof a)return null;"boolean"==typeof b&&(c=b,b=!1),b=b||d;var e=x.exec(a),f=!c&&[];return e?[b.createElement(e[1])]:(e=ca([a],b,f),f&&f.length&&n(f).remove(),n.merge([],e.childNodes))};var Lb=n.fn.load;n.fn.load=function(a,b,c){if("string"!=typeof a&&Lb)return Lb.apply(this,arguments);var d,e,f,g=this,h=a.indexOf(" ");return h>-1&&(d=n.trim(a.slice(h)),a=a.slice(0,h)),n.isFunction(b)?(c=b,b=void 0):b&&"object"==typeof b&&(e="POST"),g.length>0&&n.ajax({url:a,type:e||"GET",dataType:"html",data:b}).done(function(a){f=arguments,g.html(d?n("<div>").append(n.parseHTML(a)).find(d):a)}).always(c&&function(a,b){g.each(function(){c.apply(this,f||[a.responseText,b,a])})}),this},n.each(["ajaxStart","ajaxStop","ajaxComplete","ajaxError","ajaxSuccess","ajaxSend"],function(a,b){n.fn[b]=function(a){return this.on(b,a)}}),n.expr.filters.animated=function(a){return n.grep(n.timers,function(b){return a===b.elem}).length};function Mb(a){return n.isWindow(a)?a:9===a.nodeType&&a.defaultView}n.offset={setOffset:function(a,b,c){var d,e,f,g,h,i,j,k=n.css(a,"position"),l=n(a),m={};"static"===k&&(a.style.position="relative"),h=l.offset(),f=n.css(a,"top"),i=n.css(a,"left"),j=("absolute"===k||"fixed"===k)&&(f+i).indexOf("auto")>-1,j?(d=l.position(),g=d.top,e=d.left):(g=parseFloat(f)||0,e=parseFloat(i)||0),n.isFunction(b)&&(b=b.call(a,c,n.extend({},h))),null!=b.top&&(m.top=b.top-h.top+g),null!=b.left&&(m.left=b.left-h.left+e),"using"in b?b.using.call(a,m):l.css(m)}},n.fn.extend({offset:function(a){if(arguments.length)return void 0===a?this:this.each(function(b){n.offset.setOffset(this,a,b)});var b,c,d=this[0],e={top:0,left:0},f=d&&d.ownerDocument;if(f)return b=f.documentElement,n.contains(b,d)?(e=d.getBoundingClientRect(),c=Mb(f),{top:e.top+c.pageYOffset-b.clientTop,left:e.left+c.pageXOffset-b.clientLeft}):e},position:function(){if(this[0]){var a,b,c=this[0],d={top:0,left:0};return"fixed"===n.css(c,"position")?b=c.getBoundingClientRect():(a=this.offsetParent(),b=this.offset(),n.nodeName(a[0],"html")||(d=a.offset()),d.top+=n.css(a[0],"borderTopWidth",!0),d.left+=n.css(a[0],"borderLeftWidth",!0)),{top:b.top-d.top-n.css(c,"marginTop",!0),left:b.left-d.left-n.css(c,"marginLeft",!0)}}},offsetParent:function(){return this.map(function(){var a=this.offsetParent;while(a&&"static"===n.css(a,"position"))a=a.offsetParent;return a||Ea})}}),n.each({scrollLeft:"pageXOffset",scrollTop:"pageYOffset"},function(a,b){var c="pageYOffset"===b;n.fn[a]=function(d){return K(this,function(a,d,e){var f=Mb(a);return void 0===e?f?f[b]:a[d]:void(f?f.scrollTo(c?f.pageXOffset:e,c?e:f.pageYOffset):a[d]=e)},a,d,arguments.length)}}),n.each(["top","left"],function(a,b){n.cssHooks[b]=Ga(l.pixelPosition,function(a,c){return c?(c=Fa(a,b),Ba.test(c)?n(a).position()[b]+"px":c):void 0})}),n.each({Height:"height",Width:"width"},function(a,b){n.each({padding:"inner"+a,content:b,"":"outer"+a},function(c,d){n.fn[d]=function(d,e){var f=arguments.length&&(c||"boolean"!=typeof d),g=c||(d===!0||e===!0?"margin":"border");return K(this,function(b,c,d){var e;return n.isWindow(b)?b.document.documentElement["client"+a]:9===b.nodeType?(e=b.documentElement,Math.max(b.body["scroll"+a],e["scroll"+a],b.body["offset"+a],e["offset"+a],e["client"+a])):void 0===d?n.css(b,c,g):n.style(b,c,d,g)},b,f?d:void 0,f,null)}})}),n.fn.extend({bind:function(a,b,c){return this.on(a,null,b,c)},unbind:function(a,b){return this.off(a,null,b)},delegate:function(a,b,c,d){return this.on(b,a,c,d)},undelegate:function(a,b,c){return 1===arguments.length?this.off(a,"**"):this.off(b,a||"**",c)},size:function(){return this.length}}),n.fn.andSelf=n.fn.addBack,"function"==typeof define&&define.amd&&define("jquery",[],function(){return n});var Nb=a.jQuery,Ob=a.$;return n.noConflict=function(b){return a.$===n&&(a.$=Ob),b&&a.jQuery===n&&(a.jQuery=Nb),n},b||(a.jQuery=a.$=n),n});

$.ajaxSetup({ async:true });




/*!
 * Tinycon - A small library for manipulating the Favicon
 * Copyright (c) 2015 Tom Moor
 * @license MIT Licensed
 */
!function(){var a={},b=null,c=null,d=null,e=null,f={},g=Math.ceil(window.devicePixelRatio)||1,h=16*g,i={width:7,height:9,font:10*g+"px arial",color:"#ffffff",background:"#F03D25",fallback:!0,crossOrigin:!0,abbreviate:!0},j=function(){var a=navigator.userAgent.toLowerCase();return function(b){return-1!==a.indexOf(b)}}(),k={ie:j("trident"),chrome:j("chrome"),webkit:j("chrome")||j("safari"),safari:j("safari")&&!j("chrome"),mozilla:j("mozilla")&&!j("chrome")&&!j("safari")},l=function(){for(var a=document.getElementsByTagName("link"),b=0,c=a.length;c>b;b++)if((a[b].getAttribute("rel")||"").match(/\bicon\b/i))return a[b];return!1},m=function(){for(var a=document.getElementsByTagName("link"),b=document.getElementsByTagName("head")[0],c=0,d=a.length;d>c;c++){var e="undefined"!=typeof a[c];e&&(a[c].getAttribute("rel")||"").match(/\bicon\b/i)&&b.removeChild(a[c])}},n=function(){if(!c||!b){var a=l();b=a?a.getAttribute("href"):"/favicon.ico",c||(c=b)}return b},o=function(){return e||(e=document.createElement("canvas"),e.width=h,e.height=h),e},p=function(a){if(a){m();var b=document.createElement("link");b.type="image/x-icon",b.rel="icon",b.href=a,document.getElementsByTagName("head")[0].appendChild(b)}},q=function(a,b){if(!o().getContext||k.ie||k.safari||"force"===f.fallback)return r(a);var c=o().getContext("2d"),b=b||"#000000",e=n();d=document.createElement("img"),d.onload=function(){c.clearRect(0,0,h,h),c.drawImage(d,0,0,d.width,d.height,0,0,h,h),(a+"").length>0&&s(c,a,b),t()},!e.match(/^data/)&&f.crossOrigin&&(d.crossOrigin="anonymous"),d.src=e},r=function(a){if(f.fallback){var b=document.title;"("===b[0]&&(b=b.slice(b.indexOf(" "))),(a+"").length>0?document.title="("+a+") "+b:document.title=b}},s=function(a,b,c){"number"==typeof b&&b>99&&f.abbreviate&&(b=u(b));var d=(b+"").length-1,e=f.width*g+6*g*d,i=f.height*g,j=h-i,l=h-e-g,m=16*g,n=16*g,o=2*g;a.font=(k.webkit?"bold ":"")+f.font,a.fillStyle=f.background,a.strokeStyle=f.background,a.lineWidth=g,a.beginPath(),a.moveTo(l+o,j),a.quadraticCurveTo(l,j,l,j+o),a.lineTo(l,m-o),a.quadraticCurveTo(l,m,l+o,m),a.lineTo(n-o,m),a.quadraticCurveTo(n,m,n,m-o),a.lineTo(n,j+o),a.quadraticCurveTo(n,j,n-o,j),a.closePath(),a.fill(),a.beginPath(),a.strokeStyle="rgba(0,0,0,0.3)",a.moveTo(l+o/2,m),a.lineTo(n-o/2,m),a.stroke(),a.fillStyle=f.color,a.textAlign="right",a.textBaseline="top",a.fillText(b,2===g?29:15,k.mozilla?7*g:6*g)},t=function(){o().getContext&&p(o().toDataURL())},u=function(a){for(var b=[["G",1e9],["M",1e6],["k",1e3]],c=0;c<b.length;++c)if(a>=b[c][1]){a=v(a/b[c][1])+b[c][0];break}return a},v=function(a,b){var c=new Number(a);return c.toFixed(b)};a.setOptions=function(a){f={},a.colour&&(a.color=a.colour);for(var b in i)f[b]=a.hasOwnProperty(b)?a[b]:i[b];return this},a.setImage=function(a){return b=a,t(),this},a.setBubble=function(a,b){return a=a||"",q(a,b),this},a.reset=function(){b=c,p(c)},a.setOptions(i),"function"==typeof define&&define.amd?define(a):"undefined"!=typeof module?module.exports=a:window.Tinycon=a}();

Tinycon.setOptions({
    width: 7,
    height: 9,
    color: '#ffffff',
    background: '#22a358',
    fallback: true
});

// Get Script Once
(function($) {
    $.getScriptOnce = function(url, successhandler) {
       if ($.getScriptOnce.loaded.indexOf(url) === -1) {
            $.getScriptOnce.loaded.push(url); 
            if (successhandler === undefined) {
                return $.getScript(url);
            } else {
                return $.getScript(url, function(script, textStatus, jqXHR) {
                    successhandler(script, textStatus, jqXHR);
                });
            }
       } else {
	       if(typeof successhandler == 'function') {
	       		successhandler();
	       }
           return false;
       }

    };

    $.getScriptOnce.loaded = [];

}(jQuery));

var ismobile = false;
if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) 
	    || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) ismobile = true;

function botCheck() {
var botPattern = "(googlebot\/|Googlebot-Mobile|Googlebot-Image|Google favicon|Mediapartners-Google|bingbot|slurp|java|wget|curl|Commons-HttpClient|Python-urllib|libwww|httpunit|nutch|phpcrawl|msnbot|jyxobot|FAST-WebCrawler|FAST Enterprise Crawler|biglotron|teoma|convera|seekbot|gigablast|exabot|ngbot|ia_archiver|GingerCrawler|webmon |httrack|webcrawler|grub.org|UsineNouvelleCrawler|antibot|netresearchserver|speedy|fluffy|bibnum.bnf|findlink|msrbot|panscient|yacybot|AISearchBot|IOI|ips-agent|tagoobot|MJ12bot|dotbot|woriobot|yanga|buzzbot|mlbot|yandexbot|purebot|Linguee Bot|Voyager|CyberPatrol|voilabot|baiduspider|citeseerxbot|spbot|twengabot|postrank|turnitinbot|scribdbot|page2rss|sitebot|linkdex|Adidxbot|blekkobot|ezooms|dotbot|Mail.RU_Bot|discobot|heritrix|findthatfile|europarchive.org|NerdByNature.Bot|sistrix crawler|ahrefsbot|Aboundex|domaincrawler|wbsearchbot|summify|ccbot|edisterbot|seznambot|ec2linkfinder|gslfbot|aihitbot|intelium_bot|facebookexternalhit|yeti|RetrevoPageAnalyzer|lb-spider|sogou|lssbot|careerbot|wotbox|wocbot|ichiro|DuckDuckBot|lssrocketcrawler|drupact|webcompanycrawler|acoonbot|openindexspider|gnam gnam spider|web-archive-net.com.bot|backlinkcrawler|coccoc|integromedb|content crawler spider|toplistbot|seokicks-robot|it2media-domain-crawler|ip-web-crawler.com|siteexplorer.info|elisabot|proximic|changedetection|blexbot|arabot|WeSEE:Search|niki-bot|CrystalSemanticsBot|rogerbot|360Spider|psbot|InterfaxScanBot|Lipperhey SEO Service|CC Metadata Scaper|g00g1e.net|GrapeshotCrawler|urlappendbot|brainobot|fr-crawler|binlar|SimpleCrawler|Livelapbot|Twitterbot|cXensebot|smtbot|bnf.fr_bot|A6-Indexer|ADmantX|Facebot|Twitterbot|OrangeBot|memorybot|AdvBot|MegaIndex|SemanticScholarBot|ltx71|nerdybot|xovibot|BUbiNG|Qwantify|archive.org_bot|Applebot|TweetmemeBot|crawler4j|findxbot|SemrushBot|yoozBot|lipperhey|y!j-asr|Domain Re-Animator Bot|AddThis)";
var re = new RegExp(botPattern, 'i');
var userAgent = navigator.userAgent;
if (re.test(userAgent)) {
return true;
}else{
return false;
}
}

/*!
 * smoothState.js is jQuery plugin that progressively enhances
 * page loads to behave more like a single-page application.
 *
 * @author  Miguel Ángel Pérez   reachme@miguel-perez.com
 * @see     http://smoothstate.com
 *
 */

(function (factory) {
  'use strict';

  if(typeof module === 'object' && typeof module.exports === 'object') {
    factory(require('jquery'), window, document);
  } else {
    factory(jQuery, window, document);
  }
}(function ( $, window, document, undefined ) {
  'use strict';

  /** Abort if browser does not support pushState */
  if(!window.history.pushState) {
    // setup a dummy fn, but don't intercept on link clicks
    $.fn.smoothState = function() { return this; };
    $.fn.smoothState.options = {};
    return;
  }

  /** Abort if smoothState is already present **/
  if($.fn.smoothState) { return; }

  var ismobile = false;
	if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) 
	    || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) ismobile = true;

  var
    /** Used later to scroll page to the top */
    $body = $('html, body'),

    /** Used in debug mode to console out useful warnings */
    consl = window.console,

    /** Plugin default options, will be exposed as $fn.smoothState.options */
    defaults = {

      /** If set to true, smoothState will log useful debug information instead of aborting */
      debug: false,

      /** jQuery selector to specify which anchors smoothState should bind to */
      anchors: 'a',

      /** Regex to specify which href smoothState should load. If empty, every href will be permitted. */
      hrefRegex: '',

      /** jQuery selector to specify which forms smoothState should bind to */
      forms: 'form',

      /** If set to true, smoothState will store form responses in the cache. */
      allowFormCaching: false,

      /** Minimum number of milliseconds between click/submit events. Events ignored beyond this rate are ignored. */
      repeatDelay: 500,

      /** A selector that defines what should be ignored by smoothState */
      blacklist: '.no-smoothState',

      /** If set to true, smoothState will prefetch a link's contents on hover */
      prefetch: false,

      /** The name of the event we will listen to from anchors if we're prefetching */
      prefetchOn: 'mouseover touchstart',

      /** jQuery selector to specify elements which should not be prefetched */
      prefetchBlacklist: '.no-prefetch',

      /** The response header field name defining the request's final URI. Useful for resolving redirections. */
      locationHeader: 'X-SmoothState-Location',

      /** The number of pages smoothState will try to store in memory */
      cacheLength: 0,

      /** Class that will be applied to the body while the page is loading */
      loadingClass: 'is-loading',

      /** Scroll to top after onStart and scroll to hash after onReady */
      scroll: true,

      /**
       * A function that can be used to alter the ajax request settings before it is called
       * @param  {Object} request - jQuery.ajax settings object that will be used to make the request
       * @return {Object}         Altered request object
       */
      alterRequest: function (request) {
        return request;
      },

      /**
       * A function that can be used to alter the state object before it is updated or added to the browsers history
       * @param  {Object} state - An object that will be assigned to history entry
       * @param  {string} title - The history entry's title. For reference only
       * @param  {string} url   - The history entry's URL. For reference only
       * @return {Object}         Altered state object
       */
      alterChangeState: function (state, title, url) {
        return state;
      },

      /** Run before a page load has been activated */
      onBefore: function ($currentTarget, $container) {},

      /** Run when a page load has been activated */
      onStart: {
        duration: 0,
        render: function ($container) {}
      },

      /** Run if the page request is still pending and onStart has finished animating */
      onProgress: {
        duration: 0,
        render: function ($container) {}
      },

      /** Run when requested content is ready to be injected into the page  */
      onReady: {
        duration: 0,
        render: function ($container, $newContent) {
          $container.html($newContent);
        }
      },

      /** Run when content has been injected and all animations are complete  */
      onAfter: function($container, $newContent) {}
    },

    /** Utility functions that are decoupled from smoothState */
    utility = {

      /**
       * Checks to see if the url is external
       * @param   {string}    url - url being evaluated
       * @see     http://stackoverflow.com/questions/6238351/fastest-way-to-detect-external-urls
       *
       */
      isExternal: function (url) {
        var match = url.match(/^([^:\/?#]+:)?(?:\/\/([^\/?#]*))?([^?#]+)?(\?[^#]*)?(#.*)?/);
        if (typeof match[1] === 'string' && match[1].length > 0 && match[1].toLowerCase() !== window.location.protocol) {
          return true;
        }
        if (typeof match[2] === 'string' &&
          match[2].length > 0 &&
          match[2].replace(new RegExp(':(' + {'http:': 80, 'https:': 443}[window.location.protocol] +
            ')?$'), '') !== window.location.host) {
          return true;
        }
        return false;
      },

      /**
       * Strips the hash from a url and returns the new href
       * @param   {string}    href - url being evaluated
       *
       */
      stripHash: function(href) {
        return href.replace(/#.*/, '');
      },

      /**
       * Checks to see if the url is an internal hash
       * @param   {string}    href - url being evaluated
       * @param   {string}    prev - previous url (optional)
       *
       */
      isHash: function (href, prev) {
        prev = prev || window.location.href;

        var hasHash = (href.indexOf('#') > -1) ? true : false,
            samePath = (utility.stripHash(href) === utility.stripHash(prev)) ? true : false;

        return (hasHash && samePath);
      },

      /**
       * Translates a url string into a $.ajax settings obj
       * @param  {Object|String} request url or settings obj
       * @return {Object}        settings object
       */
      translate: function(request) {
          var defaults = {
            dataType: 'html',
            type: 'GET'
          };
          if(typeof request === 'string') {
            request = $.extend({}, defaults, { url: request });
          } else {
            request = $.extend({}, defaults, request);
          }
          return request;
      },

      /**
       * Checks to see if we should be loading this URL
       * @param   {string}    url - url being evaluated
       * @param   {string}    blacklist - jquery selector
       *
       */
      shouldLoadAnchor: function ($anchor, blacklist, hrefRegex) {
        var href = $anchor.prop('href');
        // URL will only be loaded if it's not an external link, hash, or
        // blacklisted
        return (
            !utility.isExternal(href) &&
            !utility.isHash(href) &&
            !$anchor.is(blacklist) &&
            !$anchor.prop('target')) &&
            (
              typeof hrefRegex === undefined ||
              hrefRegex === '' ||
              $anchor.prop('href').search(hrefRegex) !== -1
            );
      },

      /**
       * Resets an object if it has too many properties
       *
       * This is used to clear the 'cache' object that stores
       * all of the html. This would prevent the client from
       * running out of memory and allow the user to hit the
       * server for a fresh copy of the content.
       *
       * @param   {object}    obj
       * @param   {number}    cap
       *
       */
      clearIfOverCapacity: function (cache, cap) {
        // Polyfill Object.keys if it doesn't exist
        if (!Object.keys) {
          Object.keys = function (obj) {
            var keys = [],
              k;
            for (k in obj) {
              if (Object.prototype.hasOwnProperty.call(obj, k)) {
                keys.push(k);
              }
            }
            return keys;
          };
        }

        if (Object.keys(cache).length > cap) {
          cache = {};
        }

        return cache;
      },

      /**
       * Stores a document fragment into an object
       * @param   {object}           object - object where it will be stored
       * @param   {string}           url - name of the entry
       * @param   {string|document}  doc - entire html
       * @param   {string}           id - the id of the fragment
       * @param   {object}           [state] - the history entry's object
       * @param   {string}           [destUrl] - the destination url
       * @return  {object}           updated object store
       */
      storePageIn: function (object, url, doc, id, state, destUrl) {
        var $html = $( '<html></html>' ).append( $(doc) );
        if (typeof state === 'undefined') {
          state = {};
        }
        if (typeof destUrl === 'undefined') {
          destUrl = url;
        }
        object[url] = { // Content is indexed by the url
          status: 'loaded',
          // Stores the title of the page, .first() prevents getting svg titles
          title: $html.find('title').first().text(),
          html: $html.find('#' + id), // Stores the contents of the page
          doc: doc, // Stores the whole page document
          state: state, // Stores the history entry for comparisons,
          destUrl: destUrl // URL, which will be pushed to history stack
        };
        return object;
      },

      /**
       * Triggers an 'allanimationend' event when all animations are complete
       * @param   {object}    $element - jQuery object that should trigger event
       * @param   {string}    resetOn - which other events to trigger allanimationend on
       *
       */
      triggerAllAnimationEndEvent: function ($element, resetOn) {

        resetOn = ' ' + resetOn || '';

        var animationCount = 0,
          animationstart = 'animationstart webkitAnimationStart oanimationstart MSAnimationStart',
          animationend = 'animationend webkitAnimationEnd oanimationend MSAnimationEnd',
          eventname = 'allanimationend',
          onAnimationStart = function (e) {
            if ($(e.delegateTarget).is($element)) {
              e.stopPropagation();
              animationCount++;
            }
          },
          onAnimationEnd = function (e) {
            if ($(e.delegateTarget).is($element)) {
              e.stopPropagation();
              animationCount--;
              if(animationCount === 0) {
                $element.trigger(eventname);
              }
            }
          };

        $element.on(animationstart, onAnimationStart);
        $element.on(animationend, onAnimationEnd);

        $element.on('allanimationend' + resetOn, function(){
          animationCount = 0;
          utility.redraw($element);
        });
      },

      /** Forces browser to redraw elements */
      redraw: function ($element) {
        $element.height();
      }
    },

    /** Handles the popstate event, like when the user hits 'back' */
    onPopState = function ( e ) {
	    if(e.state !== null) {			
			var url = window.location.href,
			$page = $('#' + e.state.id),
			page = $page.data('smoothState'),
			diffUrl = (page.href !== url && !utility.isHash(url, page.href)),
			diffState = (e.state !== page.cache[page.href].state);
			
			if(diffUrl || diffState) {
				if (diffState) {
					page.clear(page.href);
				}
				window.smoothTo(url);
			}
			
		}
    },

    /** Constructor function */
    Smoothstate = function ( element, options ) {
      var
        /** Container element smoothState is run on */
        $container = $(element),

        /** ID of the main container */
        elementId = $container.prop('id'),

        /** If a hash was clicked, we'll store it here so we
         *  can scroll to it once the new page has been fully
         *  loaded.
         */
        targetHash = null,

        /** Used to prevent fetching while we transition so
         *  that we don't mistakenly override a cache entry
         *  we need.
         */
        isTransitioning = false,

        /** Variable that stores pages after they are requested */
        cache = {},

        /** Variable that stores data for a history entry */
        state = {},

        /** Url of the content that is currently displayed */
        currentHref = window.location.href,

        /**
         * Clears a given page from the cache, if no url is provided
         * it will clear the entire cache.
         * @param  {String} url entry that is to be deleted.
         */
        clear = function(url) {
          url = url || false;
          if(url && cache.hasOwnProperty(url)) {
            delete cache[url];
          } else {
            cache = {};
          }
          $container.data('smoothState').cache = cache;
        },

        /**
         * Fetches the contents of a url and stores it in the 'cache' variable
         * @param  {String|Object}   request  - url or request settings object
         * @param  {Function}        callback - function that will run as soon as it finishes
         */
        fetch = function (request, callback) {
  
			// if(request.includes('javascript:void(0)')) {
			// 	return;
			// }
          // Sets a default in case a callback is not defined
          callback = callback || $.noop;

          // Allows us to accept a url string or object as the ajax settings
          var settings = utility.translate(request);

          // Check the length of the cache and clear it if needed
          cache = utility.clearIfOverCapacity(cache, options.cacheLength); 
if(settings.url.includes('javascript:void(0)')) {
				return;
			}
          // Don't prefetch if we have the content already or if it's a form
          if(cache.hasOwnProperty(settings.url) && typeof settings.data === 'undefined') {
            return;
          }

          // Let other parts of the code know we're working on getting the content
          cache[settings.url] = { status: 'fetching' };

          // Make the ajax request
          var ajaxRequest = $.ajax(settings);

          // Store contents in cache variable if successful
          ajaxRequest.done(function (html) {
            utility.storePageIn(cache, settings.url, html, elementId);
            $container.data('smoothState').cache = cache;
          });

          // Mark as error to be acted on later
          ajaxRequest.fail(function () {
            cache[settings.url].status = 'error';
          });

          if (options.locationHeader) {
            ajaxRequest.always(function(htmlOrXhr, status, errorOrXhr){
              // Resolve where the XHR is based on done() or fail() argument positions
              var xhr = (htmlOrXhr.statusCode ? htmlOrXhr : errorOrXhr),
                  redirectedLocation = xhr.getResponseHeader(options.locationHeader);

              if (redirectedLocation) {
                cache[settings.url].destUrl = redirectedLocation;
              }
            });
          }
          
          // Call fetch callback
          if(callback) {
            ajaxRequest.always(callback);
          }
        },

        repositionWindow = function(){
          // Scroll to a hash anchor on destination page
          if(targetHash) {
            var $targetHashEl = $(targetHash, $container);
            if($targetHashEl.length){
              var newPosition = $targetHashEl.offset().top;
              $body.scrollTop(newPosition);
            }
            targetHash = null;
          }
        },

        /** Updates the contents from cache[url] */
        updateContent = function (url) {
          // If the content has been requested and is done:
          var containerId = '#' + elementId,
              $newContent = cache[url] ? $(cache[url].html.html()) : null;

          if($newContent.length) {

            // Update the title
            document.title = cache[url].title;

            // Update current url
            $container.data('smoothState').href = url;

            // Remove loading class
            if(options.loadingClass) {
              $body.removeClass(options.loadingClass);
            }

            // Call the onReady callback and set delay
            options.onReady.render($container, $newContent);

            $container.one('ss.onReadyEnd', function(){

              // Allow prefetches to be made again
              isTransitioning = false;

              // Run callback
              options.onAfter($container, $newContent);

              if (options.scroll) {
                repositionWindow();
              }
              
              bindPrefetchHandlers($container);

            });

            window.setTimeout(function(){
              $container.trigger('ss.onReadyEnd');
            }, options.onReady.duration);

          } else if (!$newContent && options.debug && consl) {
            // Throw warning to help debug in debug mode
            consl.warn('No element with an id of ' + containerId + ' in response from ' + url + ' in ' + cache);
          } else {
            // No content availble to update with, aborting...
            window.location = url;
          }
        },

        /**
         * Loads the contents of a url into our container
         * @param   {string}    url
         * @param   {bool}      push - used to determine if we should
         *                      add a new item into the history object
         * @param   {bool}      cacheResponse - used to determine if
         *                      we should allow the cache to forget this
         *                      page after thid load completes.
         */
        load = function (request, push, cacheResponse) {

          var settings = utility.translate(request);
		  if(settings.url.includes('javascript:void(0)')) {
			return;
		}

          /** Makes these optional variables by setting defaults. */
          if (typeof push === 'undefined') {
            push = true;
          }
          if (typeof cacheResponse === 'undefined') {
            cacheResponse = true;
          }

          var
            /** Used to check if the onProgress function has been run */
            hasRunCallback = false,

            callbBackEnded = false,

            /** List of responses for the states of the page request */
            responses = {

              /** Page is ready, update the content */
              loaded: function () {
                var eventName = hasRunCallback ? 'ss.onProgressEnd' : 'ss.onStartEnd';

                if (!callbBackEnded || !hasRunCallback) {
                  $container.one(eventName, function(){
                    updateContent(settings.url);
                    if (!cacheResponse) {
                      clear(settings.url);
                    }
                  });
                }
                else if (callbBackEnded) {
                  updateContent(settings.url);
                }

                if (push) {
                  var destUrl = cache[settings.url].destUrl;

                  /** Prepare a history entry */
                  state = options.alterChangeState({ id: elementId }, cache[settings.url].title, destUrl);

                  /** Update the cache to include the history entry for future comparisons */
                  cache[settings.url].state = state;

                  /** Add history entry */
                  window.history.pushState(state, cache[settings.url].title, destUrl);
                }

                if (callbBackEnded && !cacheResponse) {
                  clear(settings.url);
                }
              },

              /** Loading, wait 10 ms and check again */
              fetching: function () {

                if (!hasRunCallback) {

                  hasRunCallback = true;

                  // Run the onProgress callback and set trigger
                  $container.one('ss.onStartEnd', function(){

                    // Add loading class
                    if (options.loadingClass) {
                      $body.addClass(options.loadingClass);
                    }

                    options.onProgress.render($container);

                    window.setTimeout(function (){
                      $container.trigger('ss.onProgressEnd');
                      callbBackEnded = true;
                    }, options.onProgress.duration);

                  });
                }

                window.setTimeout(function () {
                  // Might of been canceled, better check!
                  if (cache.hasOwnProperty(settings.url)){
                    responses[cache[settings.url].status]();
                  }
                }, 10);
              },

              /** Error, abort and redirect */
              error: function (){
                if(options.debug && consl) {
                  consl.log('There was an error loading: ' + settings.url);
                } else {
                  window.location = settings.url;
                }
              }
            };

          if (!cache.hasOwnProperty(settings.url)) {
            fetch(settings);
          }

          // Run the onStart callback and set trigger
          options.onStart.render($container);

          window.setTimeout(function(){
            if (options.scroll) {
              $body.scrollTop(0);
            }
            $container.trigger('ss.onStartEnd');
          }, options.onStart.duration);

          // Start checking for the status of content
          responses[cache[settings.url].status]();
        },

        /**
         * Binds to the hover event of a link, used for prefetching content
         * @param   {object}    event
         */
        hoverAnchor = function (event) {
          var request,
              $anchor = $(event.currentTarget);

          if (utility.shouldLoadAnchor($anchor, options.blacklist, options.hrefRegex) && !isTransitioning) {
            event.stopPropagation();
            request = utility.translate($anchor.prop('href'));
            request = options.alterRequest(request);
            fetch(request);
          }
        },

        /**
         * Binds to the click event of a link, used to show the content
         * @param   {object}    event
         */
        clickAnchor = function (event) {

          // Ctrl (or Cmd) + click must open a new tab
          var $anchor = $(event.currentTarget);
          if (!event.metaKey && !event.ctrlKey && utility.shouldLoadAnchor($anchor, options.blacklist, options.hrefRegex)) {

            // stopPropagation so that event doesn't fire on parent containers.
            event.stopPropagation();
            event.preventDefault();

            // Apply rate limiting.
            if (!isRateLimited()) {

              // Set the delay timeout until the next event is allowed.
              setRateLimitRepeatTime();

              var request = utility.translate($anchor.prop('href'));
              isTransitioning = true;
              targetHash = $anchor.prop('hash');

              // Allows modifications to the request
              request = options.alterRequest(request);

              options.onBefore($anchor, $container);

              load(request);
            }
          }
        },

        /**
         * Binds to form submissions
         * @param  {Event} event
         */
        submitForm = function (event) {
          var $form = $(event.currentTarget);

          if (!$form.is(options.blacklist)) {

            event.preventDefault();
            event.stopPropagation();

            // Apply rate limiting.
            if (!isRateLimited()) {

              // Set the delay timeout until the next event is allowed.
              setRateLimitRepeatTime();

              var request = {
                url: $form.prop('action'),
                data: $form.serialize(),
                type: $form.prop('method')
              };

              isTransitioning = true;
              request = options.alterRequest(request);

              if (request.type.toLowerCase() === 'get') {
                request.url = request.url + '?' + request.data;
              }

              // Call the onReady callback and set delay
              options.onBefore($form, $container);

              load(request, undefined, options.allowFormCaching);
            }
          }
        },

        /**
         * DigitalMachinist (Jeff Rose)
         * I figured to keep these together with this above functions since they're all related.
         * Feel free to move these somewhere more appropriate if you have such places.
         */
        rateLimitRepeatTime = 0,
        isRateLimited = function () {
          var isFirstClick = (options.repeatDelay === null);
          var isDelayOver = (parseInt(Date.now()) > rateLimitRepeatTime);
          return !(isFirstClick || isDelayOver);
        },
        setRateLimitRepeatTime = function () {
          rateLimitRepeatTime = parseInt(Date.now()) + parseInt(options.repeatDelay);
        },
        
        /**
         * Binds prefetch events
         * @param   {object}    event
         */
        bindPrefetchHandlers = function ($element) {
            		
          if (options.anchors && options.prefetch) {
            $element.find(options.anchors).not(options.prefetchBlacklist).on(options.prefetchOn, null, hoverAnchor);
          }
        },
		
        /**
         * Binds all events and inits functionality
         * @param   {object}    event
         */
        bindEventHandlers = function ($element) {

          if (options.anchors) {
            $element.on('click', options.anchors, clickAnchor);

            bindPrefetchHandlers($element);
          }

          if (options.forms) {
            $element.on('submit', options.forms, submitForm);
          }
        },

        /** Restart the container's css animations */
        restartCSSAnimations = function () {
          var classes = $container.prop('class');
          $container.removeClass(classes);
          utility.redraw($container);
          $container.addClass(classes);
        };

      /** Merge defaults and global options into current configuration */
      options = $.extend( {}, $.fn.smoothState.options, options );

      /** Sets a default state */
      if(window.history.state === null) {
        state = options.alterChangeState({ id: elementId }, document.title, currentHref);

        /** Update history entry */
        window.history.replaceState(state, document.title, currentHref);
      } else {
        state = {};
      }

      /** Stores the current page in cache variable */
      utility.storePageIn(cache, currentHref, document.documentElement.outerHTML, elementId, state);

      /** Bind all of the event handlers on the container, not anchors */
      utility.triggerAllAnimationEndEvent($container, 'ss.onStartEnd ss.onProgressEnd ss.onEndEnd');

      /** Bind all of the event handlers on the container, not anchors */
      bindEventHandlers($container);


      /** Public methods */
      return {
        href: currentHref,
        cache: cache,
        clear: clear,
        load: load,
        fetch: fetch,
        restartCSSAnimations: restartCSSAnimations
      };
    },

    /** Returns elements with smoothState attached to it */
    declaresmoothState = function ( options ) {
      return this.each(function () {
        var tagname = this.tagName.toLowerCase();
        // Checks to make sure the smoothState element has an id and isn't already bound
        if(this.id && tagname !== 'body' && tagname !== 'html' && !$.data(this, 'smoothState')) {
          // Makes public methods available via $('element').data('smoothState');
          $.data(this, 'smoothState', new Smoothstate(this, options));
        } else if (!this.id && consl) {
          // Throw warning if in debug mode
          consl.warn('Every smoothState container needs an id but the following one does not have one:', this);
        } else if ((tagname === 'body' || tagname === 'html') && consl) {
          // We dont support making th html or the body element the smoothstate container
          consl.warn('The smoothstate container cannot be the ' + this.tagName + ' tag');
        }
      });
    };

  /** Sets the popstate function */
  //if(!ismobile) {
  	window.onpopstate = onPopState;
  //}
  
  /** Makes utility functions public for unit tests */
  $.smoothStateUtility = utility;

  /** Defines the smoothState plugin */
  $.fn.smoothState = declaresmoothState;

  /* expose the default options */
  $.fn.smoothState.options = defaults;

}));

/**
 * Minified by jsDelivr using Terser v3.14.1.
 * Original file: /npm/js-cookie@2.2.0/src/js.cookie.js
 * 
 * Do NOT use SRI with dynamically generated files! More information: https://www.jsdelivr.com/using-sri-with-dynamic-files
 */
!function(e){var n=!1;if("function"==typeof define&&define.amd&&(define(e),n=!0),"object"==typeof exports&&(module.exports=e(),n=!0),!n){var o=window.Cookies,t=window.Cookies=e();t.noConflict=function(){return window.Cookies=o,t}}}(function(){function e(){for(var e=0,n={};e<arguments.length;e++){var o=arguments[e];for(var t in o)n[t]=o[t]}return n}return function n(o){function t(n,r,i){var c;if("undefined"!=typeof document){if(arguments.length>1){if("number"==typeof(i=e({path:"/"},t.defaults,i)).expires){var a=new Date;a.setMilliseconds(a.getMilliseconds()+864e5*i.expires),i.expires=a}i.expires=i.expires?i.expires.toUTCString():"";try{c=JSON.stringify(r),/^[\{\[]/.test(c)&&(r=c)}catch(e){}r=o.write?o.write(r,n):encodeURIComponent(String(r)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g,decodeURIComponent),n=(n=(n=encodeURIComponent(String(n))).replace(/%(23|24|26|2B|5E|60|7C)/g,decodeURIComponent)).replace(/[\(\)]/g,escape);var s="";for(var f in i)i[f]&&(s+="; "+f,!0!==i[f]&&(s+="="+i[f]));return document.cookie=n+"="+r+s}n||(c={});for(var p=document.cookie?document.cookie.split("; "):[],d=/(%[0-9A-Z]{2})+/g,u=0;u<p.length;u++){var l=p[u].split("="),C=l.slice(1).join("=");this.json||'"'!==C.charAt(0)||(C=C.slice(1,-1));try{var g=l[0].replace(d,decodeURIComponent);if(C=o.read?o.read(C,g):o(C,g)||C.replace(d,decodeURIComponent),this.json)try{C=JSON.parse(C)}catch(e){}if(n===g){c=C;break}n||(c[g]=C)}catch(e){}}return c}}return t.set=t,t.get=function(e){return t.call(t,e)},t.getJSON=function(){return t.apply({json:!0},[].slice.call(arguments))},t.defaults={},t.remove=function(n,o){t(n,"",e(o,{expires:-1}))},t.withConverter=n,t}(function(){})});
var Cookies2 = Cookies.noConflict();

function loadScript(url) {
    return new Promise(function(resolve, reject) {
        var script = document.createElement("script");
        script.onload = resolve;
        script.onerror = reject;
        script.src = url;
        document.getElementsByTagName("head")[0].appendChild(script);
    });
}

function loadMoment() {
    if (window.moment) {
        // already loaded and ready to go
        return Promise.resolve();
    } else {
        return loadScript("//www.smokecartel.com/cdn/shop/t/38/assets/moment.js?v=5191905148375666021733865577");
    }
}

function loadRemoteComponent(html) {
	var $html = $.parseHTML(html);		
	$.each($html, function(i, c) {
		if(c.nodeName == 'DIV') {
			var elemid = $(c).attr('id');
			if(elemid && $('#'+elemid).length > 0) {
				$('#'+elemid).html($(c).contents());
				//shuffleElements('#'+elemid)
			}
		}
	});
	if (typeof peekaboo === "object") {
		peekaboo.observe();
	}
}

var backlogtime = null;
var isdomestic = true;
var userloc = '';
var isopen = false;
	    
var ua = navigator.userAgent.toLowerCase();
var isAndroid = ua.indexOf("android") > -1;

function activateVideo(ismobile) {
	'use strict';
	$('#main,#main-checkout,#search-products').find('.demo-btn').unbind("click").click(function() {	
		if($(this).hasClass('active')) {
			$(this).removeClass('active');
			$(this).parent().find('span.image-holder').show();
			$(this).parent().find('span.video-holder').html('');
		}
		else {
			var giphy = $(this).attr('data-giphy');
			var target = $(this).parent().find('span.video-holder').show();
				$(this).addClass('active');
				$(this).parent().find('span.image-holder').hide();
				var poster = $(this).parent().find('span.img-container img.product').data('src');
			
			if (typeof giphy !== typeof undefined && giphy !== false) {
				target.html('<img src="https://media.giphy.com/media/'+giphy+'/giphy.gif" alt="" />');
			}
			else {
				var videoname = $(this).data('video');
				var ytid = $(this).data('yt');
				
				if(isAndroid && ytid && ytid.length > 0) {
					target.html('<iframe class="gridyt" type="text/html" src="https://www.youtube.com/embed/'+ytid+'?autoplay=1&autohide=1&modestbranding=1&controls=0&rel=0&loop=1&playlist='+ytid+'" style="border: none; width: 100%;" />');
				}
				else {
					$.get('http://warely.io/smokecartel/get-video.php?id='+videoname, function(giphyurl) {
						if(giphyurl != '') {
							target.html('<img src="'+giphyurl+'" alt="" />');
						}
					});
				}
				
				if(ismobile === true) {
					var video = $(this).parent().find('span.video-holder').eq(0).find('video')[0];
					if (video && isFunction(video.play())) { video.play(); } 
				}
			}
		}
	});
}

function activateSlider() {
	'use strict';	 
	$('#main, #main-checkout, #free-gift-popup, #menu').find('div.scroller:not(.loadSliderCollection)').each(function() {
		if($(this).is(":visible") && $(this).find('.slide').length < 3 && !$(this).hasClass('nolimit')) {
			$(this).prev('h2:first, h3:first').remove();
			$(this).remove();
		}
		else {			
			var targetwidth = Math.floor($(this).width() / 190) * 190;
			
			$(this).find('.scroller-btn').click(function() {
				var target = $(this).parent().find('.scroller-wrapper:first');
				target.stop();
				if($(this).hasClass('prev')) {
					target.animate( { scrollLeft: '-='+targetwidth }, 500);
				}
				else {
					// Next
					target.animate( { scrollLeft: '+='+targetwidth }, 500);
				}
				return false;
			});
			
			$(this).find('a').click(function(event) {		
				var $img = $(this).parentsUntil('.slide').find('img:first');
				var eTop = $img.offset().top - $(window).scrollTop();
				var eLeft = $img.offset().left - $(window).scrollLeft();
				
				$('#collection-to-product').html('<img src="'+$img.attr('src')+'" alt="" />');
				$('#collection-to-product').css({
					'width' : $img.width(),
					'height' : $img.height(),
					'top': eTop,
					'left': eLeft,
				}).stop(true, false).animate({
				    'width': '100%',
				    'height': '530px',
				    'top': $('#header-content').height() + 61 + 'px',
				    'left': '0',
				}, 600);
			});
		}
	});
	
	$('.slider-pill-nav:not(.custom-tabs) a').click(function(event) {
		if(!$(this).hasClass('active')) {
	 		event.preventDefault();
			
			var $scroller = $(this).parentsUntil('.grid').parent().find('.scroller');
			var col_handle = $(this).attr('href').split('/');
			var details = $(this).attr('data-details');
			col_handle = col_handle[col_handle.length - 1];		
			$(this).parent().find('.active').removeClass('active');
			$(this).addClass('active');
			
			$.get('/collections/'+col_handle+'?view=load-slider', function(html) {
				var $html = $.parseHTML(html);
				console.log('Scrolling left');
				$scroller.find('.scroller-wrapper').animate({
			    	scrollLeft: 0
			    }, 600);
			    
				$.each($html, function(j, c) {
					if(c.nodeName == 'DIV' && $(c).attr('id') == 'scroller-content') {
						$scroller.find('.scroller-wrapper').html('').prepend($(c).contents());
						activateSlider();
						activateVideo(ismobile);		
						activateCountdownMeters();
					}
				});		
				
				setTimeout(function() {
					callGTMSlider(html,details)
				},1000)
			});
		}
	});
}

function callGTMSlider(html,details){
	let htmlObject = new DOMParser().parseFromString(html, 'text/html');
	let productsScript = htmlObject.querySelectorAll('.new_slide_grid_item .event_script_slider');
	let items = [];
	productsScript.forEach((script) => {
		items.push(JSON.parse(script.innerHTML));
	}); 
	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push({ ecommerce: null });
	window.dataLayer.push({
		'event': 'view_item_list',
		'ecommerce': {
			item_list_id: details.split('|')[0],  
			item_list_name: details.split('|')[1], 
			'items': items
		}
	});	
}

function imgixProductUrl(url, remove, parameters) {
	'use strict';
	remove = remove || false;
	if(typeof url != null && url != null) {
		var filename = url.substring(url.lastIndexOf('/')+1);
		if(remove) { filename = filename.replace(remove, ''); }
		if(remove) { url = url.replace(remove, ''); }
		
		var parts = parameters.split('&');
		var finalparams = [];
		for(var i = 0; i < parts.length; i++) {
			var p = parts[i].split('=');
			if(p.length == 2 && p[0] != 'auto') {
				finalparams.push(p);
			}
		}
		
		if(finalparams.length == 1 && finalparams[0][0] == 'w') {
			if(finalparams[0][1] == 160) {
				return Shopify.resizeImage(url, 'medium');
			}
			else {
				return Shopify.resizeImage(url, finalparams[0][1]+'x');
			}
		}
		else {	
			return 'https://smokecartel.imgix.net/products/'+filename+parameters;
		}
	}
	else {
		return url;
	}
}

function renderScroller(i, e,sscroller) {
	'use strict';
	var rating = '';
	if(e.hasOwnProperty("rating")) { rating = '<p class="rating stars-container"><span class="stars"><span style="width: '+(e.rating * 16)+'px"></span></span> <span class="count">('+e.ratingcount+')</span></p>'; }
	var video = '';
	var ytvideo = '';
	if(e.hasOwnProperty("video") && e.video != undefined) { 
		if(e.hasOwnProperty('yt') && e.yt != undefined) { ytvideo = e.yt; } 
		video = '<span class="demo-btn" data-video="'+e.video+'" data-yt="'+ytvideo+'" title="Watch this pipe in action!"></span>'; 
	}
	var step = '';
	if(i < 6) {
		step = 'animated fadeInRight step'+i;
	}

	var pid = '';
	if(e.hasOwnProperty('pid')) { pid = "data-pid='"+e.pid+"'"; } else if(e.hasOwnProperty('id')) { pid = "data-pid='"+e.id+"'"; }
	
	// Reformat shopify prices
	if(e.hasOwnProperty('created_at')) {
		e.price = e.price / 100;
		e.compare_price = e.compare_at_price / 100;
	}
	
	var compareat = '';
	// if(e.hasOwnProperty('compare_price') && e.compare_price > e.price) {
	// 	compareat += '<p class="compare_price"><span>On Sale!</span> <s>$'+parseFloat(e.compare_price).toFixed(2)+'</s></p>';
	// }
	
	e.price += '';
	var price = parseFloat(e.price.replace(',', '')).toFixed(2).replace('.', '<span class="cents">.')+'</span>';
	
	var cid = '';
	if(Cookies2.get('smokecartel_customer_id') && Cookies2.get('smokecartel_customer_id') != '') {
		cid = 'data-cid="'+Cookies2.get('smokecartel_customer_id')+'"';
	}
	
	if(e.hasOwnProperty('product_title')) {
		e.title = e.product_title;
	}
	
	var img = '';
	if(e.hasOwnProperty('img')) {
		img = e.img;
	}
	else if(e.hasOwnProperty('featured_image')) {
		img = e.featured_image;
	}
	
	var product_url = '//www.smokecartel.com/products/'+e.handle;
	if(window.customer_is_wholesale || is_wholesale) {
		product_url = '//www.smokecartel.com/a/wholesale/'+e.handle;
	}
	
	var pricehtml = '<p class="price"><span class="dollar">$</span>'+price+'</p>'+compareat;
	if(window.customer_is_wholesale) {
		pricehtml = '';
	}
	
	if(e.img != '') {
		// console.log('renderScroller')
		sscroller.append('<div class="slide internal '+step+'"><div class="slide-container"><span href="#" class="noss noanimate like-btn" '+pid+' '+cid+'><i class="icon-heart"></i></span>'+video+'<a href="'+product_url+'" '+pid+'><span class="video-holder"></span><span class="img-container image-holder"><span class="img-protect"></span><img alt="'+e.title.replace(/['"]+/g, '')+'" width="160" height="240" class="lazyload product" data-src="'+imgixProductUrl(img, '_medium', '&w=160&auto=format')+'" src="//www.smokecartel.com/cdn/shop/t/38/assets/b.gif?v=111003715552405036781733865278" /></span></a>'+pricehtml+'<p class="title"><a href="'+product_url+'">'+e.title+'</a></p>'+rating+'</div></div>');
	}
}

function renderScroller_new(i, e, sscroller, source = 'rec') {
	try {
		var rating = '';
		if(e.reviews_average) { rating = '<p class="rating stars-container"><span class="stars"><span style="width: '+(e.reviews_average * 16)+'px"></span></span> <span class="count">('+e.reviews_count+')</span></p>'; }
		var video = '';
		if(e.video) { 
			video = '<span class="demo-btn" data-video="'+e.video+'" title="Watch this product in action!"></span>'; 
		}
		if(e.giphy) { 
			video = '<span class="demo-btn" data-giphy="'+e.giphy+'" title="Watch this product in action!"></span>'; 
		}
		if(e.hasOwnProperty('meta') && e.meta.hasOwnProperty('giphy') && e.meta.giphy) {
			video = '<span class="demo-btn" data-giphy="'+e.meta.giphy+'" title="Watch this product in action!"></span>'; 
		}
		var step = '';
		if(i < 6) {
			step = 'animated fadeIn step'+i;
		}
	
		var pid = '';
		if(e.product_id) { pid = "data-pid='"+e.product_id+"'"; }
		
		var price = parseFloat(e.price).toFixed(2).replace('.', '<span class="cents">.')+'</span>';
		var compareat = '';
		// if(e.compare_at_price && e.compare_at_price > e.price) {
		// 	compareat += '<p class="compare_price"><span>On Sale!</span> <s>$'+parseFloat(e.compare_at_price).toFixed(2)+'</s></p>';
		// }
		
		var cid = '';
		if(Cookies2.get('smokecartel_customer_id') && Cookies2.get('smokecartel_customer_id') != '') {
			cid = 'data-cid="'+Cookies2.get('smokecartel_customer_id')+'"';
		}
		
		var varianturl = '';
		if(e.variant_id) {
			varianturl = '?variant='+e.variant_id;
		}
		if(source == 'search' && e.search_type == 'variant') {
			varianturl = '?variant='+e.id;
		}
		
		var product_url = '//www.smokecartel.com/products/'+e.handle+varianturl;
		if(window.customer_is_wholesale || is_wholesale) {
			product_url = '//www.smokecartel.com/a/wholesale/'+e.handle;
		}
		
		var meta = '';
		if(e.hasOwnProperty('wholesale') && e.wholesale) {
			meta = '<p style="font-size: 11px; margin: 0 0 8px; color: #405DE6;">Business Pricing</p>';
		}
		
		if(e.image != '') {
			sscroller.append('<div class="slide internal '+step+'"><div class="slide-container"><span href="#" class="noss noanimate like-btn" '+pid+' '+cid+'><i class="icon-heart"></i></span>'+video+'<a href="'+product_url+'" '+pid+'><span class="video-holder"></span><span class="img-container image-holder"><span class="img-protect"></span><img alt="'+e.product_title.replace(/['"]+/g, '')+' - '+e.product_title.replace(/['"]+/g, '')+'" width="160" height="240"  class="lazyload product" data-src="'+Shopify.resizeImage(e.image, '160x240')+'" src="//www.smokecartel.com/cdn/shop/t/38/assets/scrollerblank.gif?v=44524134584678715471733865469" /></span></a><p class="price"><span class="dollar">$</span>'+price+'</p>'+compareat+'<p class="title"><a href="'+product_url+'">'+e.product_title+'</a></p>'+rating+meta+'</div></div>');
		}
	}
	catch(e) {
		
	}
}

function showLoading() {
	$('#main').hide();
	$('#loading').show();
}

var loopCollectionReviews = function() {	
	var lis = $("#category-reviews > .customer-review"),
    currentHighlight = 0;
    N = 9;//interval in seconds
    
    if(lis.length > 0) {
	    setInterval(function() {
	        currentHighlight = (currentHighlight + 1) % lis.length;
	        lis.removeClass('active').eq(currentHighlight).addClass('active');
	    }, N * 1000);
    }
    else {
	    $("#category-reviews").hide();
    }
}

function animateCollectionToProduct() {
	$('#products a.regular-grid-product').click(function(event) {		
		var $img = $(this).find('img');		
		var eTop = $img.offset().top - $(window).scrollTop();
		var eLeft = $img.offset().left - $(window).scrollLeft();
		
		$('#collection-to-product').html('<img src="'+$img.attr('src')+'" alt="" />');
		$('#collection-to-product').css({
			'width' : $img.width(),
			'height' : $img.height(),
			'top': eTop,
			'left': eLeft,
		}).stop(true, false).animate({
		    'width': '100%',
		    'height': '530px',
		    'top': $('#header-content').height() + 61 + 'px',
		    'left': '0',
		}, 600);
	});
}
var productphotowidth = 0;
function activateProductPhotos(start = 0) {
	var thumboptions = {
		spacing: 0,
		orientation: 'vertical',
		fitInViewport: false,
	};
	if(ismobile) {
		thumboptions = {
			spacing: 0,
		};
	}
	
	var royal_options = {
        keyboardNavEnabled: true,
        autoScaleSlider: true,
        autoScaleSliderWidth: 360,
        autoScaleSliderHeight: 540,
        numImagesToPreload: 0,
        imgWidth: 360,
        imgHeight: 540,
        imageAlignCenter: true,
        imageScaleMode: 'fit-if-smaller',
        controlNavigation: 'thumbnails',
        loop: true,
        startSlideId: start,
        transitionType: 'fade',
        fadeinLoadedSlide: false,
        controlsInside: false,
        slidesSpacing: 0,
        imageScalePadding: 0,
    	thumbs: thumboptions
    };
    if(ismobile) {
		royal_options.transitionType = 'move';
	}
		
	$('#ProductPhoto').royalSlider(royal_options);
    
    var slider = $('#ProductPhoto').data('royalSlider');
	var $product_top = $('#product-top');
	slider.ev.on('rsBeforeAnimStart', function(event) {
		if($(slider.currSlide.content[0]).hasClass('white-img')) {
			$product_top.addClass('white-top');
		}
		else {
			$product_top.removeClass('white-top');
		}
	});
	
	slider.updateSliderSize(true);
	
	$('.zoom-gallery-btn').click(function(event) {
		event.preventDefault();
		var $zbtn = $(this);
		
		if($('photoswipe-css').length == 0) {
			$('head').append('<link id="photoswipe-css" rel="stylesheet" type="text/css" href="//www.smokecartel.com/cdn/shop/t/38/assets/photoswipe.css?v=28026865234463994791733865428">');
		}
		if($('#photoswipe-elem').length == 0) {
			$('body').append('<div id="photoswipe-elem" class="pswp" tabindex="-1" role="dialog" aria-hidden="true"><div class="pswp__bg"></div><div class="pswp__scroll-wrap"><div class="pswp__container"> <div class="pswp__item"></div><div class="pswp__item"></div><div class="pswp__item"></div></div><div class="pswp__ui pswp__ui--hidden"> <div class="pswp__top-bar"> <div class="pswp__counter"></div><button class="pswp__button pswp__button--close" title="Close (Esc)"></button> <button class="pswp__button pswp__button--share" title="Share"></button> <button class="pswp__button pswp__button--fs" title="Toggle fullscreen"></button> <button class="pswp__button pswp__button--zoom" title="Zoom in/out"></button> <div class="pswp__preloader"> <div class="pswp__preloader__icn"> <div class="pswp__preloader__cut"> <div class="pswp__preloader__donut"></div></div></div></div></div><div class="pswp__share-modal pswp__share-modal--hidden pswp__single-tap"> <div class="pswp__share-tooltip"></div></div><button class="pswp__button pswp__button--arrow--left" title="Previous (arrow left)"> </button> <button class="pswp__button pswp__button--arrow--right" title="Next (arrow right)"> </button> <div class="pswp__caption"> <div class="pswp__caption__center"></div></div></div></div></div>');
		}
		$.getScriptOnce('//www.smokecartel.com/cdn/shop/t/38/assets/photoswipe.js?v=91432686901708715261733865429', function() {			
			console.log('Loaded Photoswipe');
			var pswpElement = document.getElementById('photoswipe-elem');
							
			var index = 0;
			var imgid = $zbtn.parent().find('.rsNavSelected:first .rsTmb[data-image-id]').attr('data-image-id');
			$.each(window.gallery_items, function(i, img) {
				if(img.hasOwnProperty('id') && img.id == imgid) {
					index = i;
				}
			});
	
			// Initializes and opens PhotoSwipe
			var gallery = new PhotoSwipe( pswpElement, PhotoSwipeUI_Default, window.gallery_items, {
			    index: index
			});
			gallery.init();
		});
	});
}

function loadInstagram() {
	var source = $('.product-instagram').data('source');
	$.getScriptOnce('//www.instagram.com/embed.js', function() {
		$.each(source, function(i, url) {
			console.log(url);
			$.getJSON('https://graph.facebook.com/v9.0/instagram_oembed?url='+url+'&access_token=878832968796627|675169bccf7e687ea4ea8b4426cedf3b', function(resp) {
				$('.product-instagram').append('<div class="post">'+resp.html+'<br /></div>');
				if((i+1) == source.length) {
					instgrm.Embeds.process();
				}
			});
		});
	});
}

function activateMeters() {
	$('#main').find('.meter:not(.countdown)').each(function() {
		if($(this).data('current')) {
			var percentage = ($(this).data('current') / $(this).data('max')) * 100;
			if(p < 3) { p = 3; }
			var p = percentage + "%";
			var barclass = 'outside';
			if(percentage > 40) {
				barclass = 'inside';
			}
			$(this).find('.bar').animate({ width: p }, 500).addClass(barclass);
		}
		else {
			// Animate basic bar
			var destination_percentage = $(this).find('.bar').attr('style').replace('width: ', '').replace('%;', '');
			var percentage_max = destination_percentage * 1.3;
			if(percentage_max > 100) {
				percentage_max = 100;
			}
			
			$(this).find('.bar').css('width', percentage_max+'%').animate({ width: destination_percentage+'%' }, 60000);
		}
	});
}

function activateCountdownMeters() {
	$('.meter.countdown').each(function() {
		var timetotal = $(this).attr('data-max');
		var timeleft = $(this).attr('data-current');
		var progressBarWidth = timeleft / timetotal * 100;		
		$(this).attr('data-current', timeleft - 5);
		$(this).find('.bar').css('width', progressBarWidth+'%');
	});
	
	setTimeout(function() {
        activateCountdownMeters();
    }, 5000);
}

function runCheck() {
	var param = '';
	
	Shopify.getCart(function(cart) {
		// Check to auto place aff
		var afftime = Math.round(new Date().getTime()/1000);
		
		if(!cart.attributes.hasOwnProperty("affiliate")) {
			//console.log('No affilate');
			// No affiliate tag yet
			
			if((window.location.hash && window.location.hash.indexOf('#ref=') !== -1) || window.location.href.indexOf('?ref=') !== -1 || window.location.href.indexOf('?aff=') !== -1) { 
				if(window.location.href.indexOf('?ref=') !== -1) {
					var wlparts = window.location.href.split('?ref=');
					param = '?ref='+wlparts[wlparts.length-1];
					var affid = wlparts[wlparts.length-1];
				}
				else if(window.location.href.indexOf('?aff=') !== -1) {
					var wlparts = window.location.href.split('?aff=');
					param = '?ref='+wlparts[wlparts.length-1];
					var affid = wlparts[wlparts.length-1];
				}
				else {
					param = '?'+window.location.hash.replace('#', ''); 
					var affid = window.location.hash.replace('#ref=', '');
				}
				
				//console.log('tagged affiliate');
				Shopify.updateCartAttributes({ 'affiliate' : affid, 'affiliate-visit' : afftime });
			}
			else {
				// Tagging as SMKC
				//console.log('tagged as smkc');
				Shopify.updateCartAttributes({ 'affiliate' : 'smkc' });
			}
		}
		else {
			// Existing affiliate tag - do not allow overwrite of smkc
			if(cart.attributes.affiliate != 'smkc') {
				// Affiliate is not default
				if((window.location.hash && window.location.hash.indexOf('#ref=') !== -1) || window.location.href.indexOf('?ref=') !== -1 || window.location.href.indexOf('?aff=') !== -1) { 
					if(window.location.href.indexOf('?ref=') !== -1) {
						var wlparts = window.location.href.split('?ref=');
						param = '?ref='+wlparts[wlparts.length-1];
						var affid = wlparts[wlparts.length-1];
					}
					else if(window.location.href.indexOf('?aff=') !== -1) {
						var wlparts = window.location.href.split('?aff=');
						param = '?ref='+wlparts[wlparts.length-1];
						var affid = wlparts[wlparts.length-1];
					}
					else {
						param = '?'+window.location.hash.replace('#', ''); 
						var affid = window.location.hash.replace('#ref=', '');
					}
					
					//console.log('retagged affiliate');
					Shopify.updateCartAttributes({ 'affiliate' : affid, 'affiliate-visit' : afftime });
				}				
			}
		}
	});
	
	if((window.location.hash && window.location.hash.indexOf('#ref=') !== -1) || window.location.href.indexOf('?ref=') !== -1 || window.location.href.indexOf('?aff=') !== -1) { 
		if(window.location.href.indexOf('?ref=') !== -1) {
			var wlparts = window.location.href.split('?ref=');
			param = '?ref='+wlparts[wlparts.length-1];
			var affid = wlparts[wlparts.length-1];
		}
		else if(window.location.href.indexOf('?aff=') !== -1) {
			var wlparts = window.location.href.split('?aff=');
			param = '?ref='+wlparts[wlparts.length-1];
			var affid = wlparts[wlparts.length-1];
		}
		else {
			param = '?'+window.location.hash.replace('#', ''); 
			var affid = window.location.hash.replace('#ref=', '');
		}
		var afftime = Math.round(new Date().getTime()/1000);
		//console.log('tagged affiliate');
		Shopify.updateCartAttributes({ 'affiliate' : affid, 'affiliate-visit' : afftime });
	}
	
	// $.getJSON('//api.smokecartel.com/check.php'+param, function(data) {
	// 	userloc = data;
	// 	window.userloc = userloc;
	// 	Cookies2.set('userdata', data.join(','), { expires: 7 });
	// });
}

function recordView(handle) {
	if(Cookies2.get('smokecartel_recently_viewed')) {
		var rvhandles = Cookies2.get('smokecartel_recently_viewed').split(' ');
		if(rvhandles.indexOf(handle) != -1) {
			rvhandles.splice(rvhandles.indexOf(handle), 1);
		}
		rvhandles.unshift(handle);
		rvhandles.splice(40);
		
		Cookies2.set('smokecartel_recently_viewed', rvhandles.join(' '), { expires: 30 });
	}
	else {
		Cookies2.set('smokecartel_recently_viewed', handle, { expires: 30 });
	}
}

/*============================================================================
  Shopify's jQuery API
==============================================================================*/
var CartCount = $('.CartCount');

function floatToString(e, t) {
    var n = e.toFixed(t).toString();
    return n.match(/^\.\d+/) ? "0" + n : n
}

function attributeToString(e) {
    return "string" != typeof e && (e += "", "undefined" === e && (e = "")), jQuery.trim(e)
}
"undefined" == typeof window.Shopify && (window.Shopify = {}), Shopify.money_format = "$", Shopify.onError = function(e, t) {
    var n = eval("(" + e.responseText + ")");
    n.message ? console.log(n.message + "(" + n.status + "): " + n.description) : console.log("Error : " + Shopify.fullMessagesFromErrors(n).join("; ") + ".")
}, Shopify.fullMessagesFromErrors = function(e) {
    var t = [];
    return jQuery.each(e, function(e, n) {
        jQuery.each(n, function(n, r) {
            t.push(e + " " + r)
        })
    }), t
}, Shopify.onCartUpdate = function(e) {
   console.log('cart updated');
   window.ShopifyCart = e;
   var itemcount = 0;
   var hasrechargeitem = false;
   var cartlineitems = [];
   for(var i = 0; i < e.items.length; i++) {
	   if(e.items[i].product_type != "Other" && e.items[i].product_type != 'Insurance' && e.items[i].product_type != 'Extend Service Contract') {
		   itemcount += e.items[i].quantity;
		   
		   cartlineitems.push({
			   'item_id' : e.items[i].product_id,
			   'unit_price' : (e.items[i].price / 100),
			   'quantity' : e.items[i].quantity,
		   });
	   }
	   
	   if(e.items[i].product_title.includes('Auto renew')) {
		   hasrechargeitem = true;
	   }
   }
   CartCount.html(itemcount);
   if(e.item_count <= 0) {
	   CartCount.hide();
    $('.newCartCount').html(itemcount).attr('style','background:transparent')
   } 
   else {
	   CartCount.show();
        $('.newCartCount').html(itemcount).attr('style','background:#000')
	   $('#mobile-checkout-btn, .regular-cart-btn').removeClass('animated bounce').addClass('animated bounce');
   }
  
   Tinycon.setBubble(itemcount);
   
   // Switch cart buttons for recharge
   if(hasrechargeitem) {
	   $('.regular-cart-btn').hide();
	   $('.recharge-cart-btn').show();
   }
   else {
	   $('.recharge-cart-btn').hide();
	   $('.regular-cart-btn').show();
   }
   $('.recharge-cart-btn, regular-cart-btn').removeClass('bounce').addClass('bounce');
   
   
   
   Shopify.updateCartAttributes({ 'cart_token' : e.token });
   
   if(e.item_count > 0) {
   		// Send Event to Warely
   		$.post("https://warely.io/shopify-app/log-event.php?client_id=2", { type: "cart-update", cart: e });
   }
   
}, Shopify.handleize = function (str) {
    return str.toLowerCase().replace(/[^\w\u00C0-\u024f]+/g, "-").replace(/^-+|-+$/g, "");
}, Shopify.resizeImage = function(image, size) {
	try {
		if(size == 'original')
		{
			return image.replace('http://', 'https://');
		}
		else
		{      
			var matches = image.match(/(.*\/[\w\-\_\.]+)\.(\w{2,4})/);
			var url =  matches[1] + '_' + size + '.' + matches[2];
			
			return url.replace('http://', 'https://');
		}    
	}
	catch(e) {
		return image.replace('http://', 'https://');
	}
}, Shopify.onCartShippingRatesUpdate = function(e, t) {
    var n = "";
    t.zip && (n += t.zip + ", "), t.province && (n += t.province + ", "), n += t.country, alert("There are " + e.length + " shipping rates available for " + n + ", starting at " + Shopify.formatMoney(e[0].price) + ".")
}, Shopify.onItemAdded = function(e) {
    console.log(e.title + " was added to your shopping cart.")
}, Shopify.onProduct = function(e) {
    //alert("Received everything we ever wanted to know about " + e.title)
}, Shopify.formatMoney = function(cents, format) {
    var value = '',
        placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
        formatString = (format || "$ {{amount}}");

    if (typeof cents == 'string') {
      cents = cents.replace('.','');
    }

    function defaultOption(opt, def) {
      return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal   = defaultOption(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number/100.0).toFixed(precision);

      var parts   = number.split('.'),
          dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
          cents   = parts[1] ? (decimal + parts[1]) : '';

      return dollars + cents;
    }

    switch(formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
}, Shopify.resizeImage = function(e, t) {
    try {
        if ("original" == t) return e;
        var n = e.match(/(.*\/[\w\-\_\.]+)\.(\w{2,4})/);
        return n[1] + "_" + t + "." + n[2]
    } catch (r) {
        return e
    }
}, Shopify.addItem = function(e, t, n) {
    var t = t || 1,
        r = {
            type: "POST",
            url: "/cart/add.js",
            async: false,
            data: "quantity=" + t + "&id=" + e,
            dataType: "json",
            success: function(e) {
                "function" == typeof n ? n(e) : Shopify.onItemAdded(e)
            },
            error: function(e, t) {
                Shopify.onError(e, t)
            }
        };
    jQuery.ajax(r)
}, Shopify.addItemFromForm = function(e, t) {
    var n = {
        type: "POST",
        url: "/cart/add.js",
        data: jQuery(e).serialize(),
        dataType: "json",
        success: function(e) {
            "function" == typeof t ? t(e) : Shopify.onItemAdded(e)
        },
        error: function(e, t) {
            Shopify.onError(e, t)
        }
    };
    jQuery.ajax(n)
}, Shopify.getCart = function(e) {
    jQuery.getJSON("/cart.js", function(t, n) {
	    window.ShopifyCart = t;
		Shopify.updateCartAttributes({ 'cart_token' : t.token });
		
		
	    
        "function" == typeof e ? e(t) : Shopify.onCartUpdate(t)
    })
}, Shopify.pollForCartShippingRatesForDestination = function(e, t, n) {
    n = n || Shopify.onError;
    var r = function() {
        jQuery.ajax("/cart/async_shipping_rates", {
            dataType: "json",
            success: function(n, i, o) {
                200 === o.status ? "function" == typeof t ? t(n.shipping_rates, e) : Shopify.onCartShippingRatesUpdate(n.shipping_rates, e) : setTimeout(r, 500)
            },
            error: n
        })
    };
    return r
}, Shopify.getCartShippingRatesForDestination = function(e, t, n) {
    n = n || Shopify.onError;
    var r = {
        type: "POST",
        url: "/cart/prepare_shipping_rates",
        data: Shopify.param({
            shipping_address: e
        }),
        success: Shopify.pollForCartShippingRatesForDestination(e, t, n),
        error: n
    };
    jQuery.ajax(r)
}, Shopify.getProduct = function(e, t) {
	if(e){ 
		jQuery.getJSON("/products/" + e + ".js", function(e, n) {
			"function" == typeof t ? t(e) : Shopify.onProduct(e)
		})
	}
}, Shopify.getProductFull = function(e, t) {
    jQuery.getJSON("/products/" + e + ".json", function(e, n) {
	    e = e.product;
        "function" == typeof t ? t(e) : Shopify.onProduct(e)
    })
}, Shopify.changeItem = function(e, t, n) {
    var r = {
        type: "POST",
        url: "/cart/change.js",
        data: "quantity=" + t + "&id=" + e,
        dataType: "json",
        success: function(e) {
            "function" == typeof n ? n(e) : Shopify.onCartUpdate(e)
        },
        error: function(e, t) {
            Shopify.onError(e, t)
        }
    };
    jQuery.ajax(r)
}, Shopify.removeItem = function(e, t) {
    var n = {
        type: "POST",
        url: "/cart/change.js",
        data: "quantity=0&id=" + e,
        dataType: "json",
        success: function(e) {
            "function" == typeof t ? t(e) : Shopify.onCartUpdate(e)
        },
        error: function(e, t) {
            Shopify.onError(e, t)
        }
    };
    jQuery.ajax(n)
}, Shopify.clear = function(e) {
    var t = {
        type: "POST",
        url: "/cart/clear.js",
        data: "",
        dataType: "json",
        success: function(t) {
            "function" == typeof e ? e(t) : Shopify.onCartUpdate(t)
        },
        error: function(e, t) {
            Shopify.onError(e, t)
        }
    };
    jQuery.ajax(t)
}, Shopify.updateCartFromForm = function(e, t) {
    var n = {
        type: "POST",
        url: "/cart/update.js",
        data: jQuery("#" + e).serialize(),
        dataType: "json",
        success: function(e) {
            "function" == typeof t ? t(e) : Shopify.onCartUpdate(e)
        },
        error: function(e, t) {
            Shopify.onError(e, t)
        }
    };
    jQuery.ajax(n)
}, Shopify.updateCartAttributes = function(e, t) {
    var n = "";
    jQuery.isArray(e) ? jQuery.each(e, function(e, t) {
        var r = attributeToString(t.key);
        "" !== r && (n += "attributes[" + r + "]=" + attributeToString(t.value) + "&")
    }) : "object" == typeof e && null !== e && jQuery.each(e, function(e, t) {
        n += "attributes[" + attributeToString(e) + "]=" + attributeToString(t) + "&"
    });
    var r = {
        type: "POST",
        url: "/cart/update.js",
        data: n,
        dataType: "json",
        success: function(e) {
            //"function" == typeof t ? t(e) : Shopify.onCartUpdate(e)
        },
        error: function(e, t) {
            Shopify.onError(e, t)
        }
    };
    jQuery.ajax(r)
}, Shopify.updateCartNote = function(e, t) {
    var n = {
        type: "POST",
        url: "/cart/update.js",
        data: "note=" + attributeToString(e),
        dataType: "json",
        success: function(e) {
            "function" == typeof t ? t(e) : Shopify.onCartUpdate(e)
        },
        error: function(e, t) {
            Shopify.onError(e, t)
        }
    };
    jQuery.ajax(n)
}, jQuery.fn.jquery >= "1.4" ? Shopify.param = jQuery.param : (Shopify.param = function(e) {
    var t = [],
        n = function(e, n) {
            n = jQuery.isFunction(n) ? n() : n, t[t.length] = encodeURIComponent(e) + "=" + encodeURIComponent(n)
        };
    if (jQuery.isArray(e) || e.jquery) jQuery.each(e, function() {
        n(this.name, this.value)
    });
    else
        for (var r in e) Shopify.buildParams(r, e[r], n);
    return t.join("&").replace(/%20/g, "+")
}, Shopify.buildParams = function(e, t, n) {
    jQuery.isArray(t) && t.length ? jQuery.each(t, function(t, r) {
        rbracket.test(e) ? n(e, r) : Shopify.buildParams(e + "[" + ("object" == typeof r || jQuery.isArray(r) ? t : "") + "]", r, n)
    }) : null != t && "object" == typeof t ? Shopify.isEmptyObject(t) ? n(e, "") : jQuery.each(t, function(t, r) {
        Shopify.buildParams(e + "[" + t + "]", r, n)
    }) : n(e, t)
}, Shopify.isEmptyObject = function(e) {
    for (var t in e) return !1;
    return !0
});

// Option Selector Custom
"undefined" == typeof window.Shopify && (window.Shopify = {}), Shopify.each = function(e, t) {
    for (var n = 0; n < e.length; n++) t(e[n], n)
}, Shopify.map = function(e, t) {
    for (var n = [], r = 0; r < e.length; r++) n.push(t(e[r], r));
    return n
}, Shopify.arrayIncludes = function(e, t) {
    for (var n = 0; n < e.length; n++)
        if (e[n] == t) return !0;
    return !1
}, Shopify.uniq = function(e) {
    for (var t = [], n = 0; n < e.length; n++) Shopify.arrayIncludes(t, e[n]) || t.push(e[n]);
    return t
}, Shopify.isDefined = function(e) {
    return "undefined" == typeof e ? !1 : !0
}, Shopify.getClass = function(e) {
    return Object.prototype.toString.call(e).slice(8, -1)
}, Shopify.extend = function(e, t) {
    function n() {}
    n.prototype = t.prototype, e.prototype = new n, e.prototype.constructor = e, e.baseConstructor = t, e.superClass = t.prototype
}, Shopify.locationSearch = function() {
    return window.location.search
}, Shopify.locationHash = function() {
    return window.location.hash
}, Shopify.replaceState = function(e) {
    window.history.replaceState({}, document.title, e)
}, Shopify.urlParam = function(e) {
    var t = RegExp("[?&]" + e + "=([^&#]*)").exec(Shopify.locationSearch());
    return t && decodeURIComponent(t[1].replace(/\+/g, " "))
}, Shopify.newState = function(e, t) {
    var n;
    return n = Shopify.urlParam(e) ? Shopify.locationSearch().replace(RegExp("(" + e + "=)[^&#]+"), "$1" + t) : "" === Shopify.locationSearch() ? "?" + e + "=" + t : Shopify.locationSearch() + "&" + e + "=" + t, n + Shopify.locationHash()
}, Shopify.setParam = function(e, t) {
    Shopify.replaceState(Shopify.newState(e, t))
}, Shopify.Product = function(e) {
    Shopify.isDefined(e) && this.update(e)
}, Shopify.Product.prototype.update = function(e) {
    for (property in e) this[property] = e[property]
}, Shopify.Product.prototype.optionNames = function() {
    return "Array" == Shopify.getClass(this.options) ? this.options : []
}, Shopify.Product.prototype.optionValues = function(e) {
    if (!Shopify.isDefined(this.variants)) return null;
    var t = Shopify.map(this.variants, function(t) {
        var n = "option" + (e + 1);
        return void 0 == t[n] ? null : t[n]
    });
    return null == t[0] ? null : Shopify.uniq(t)
}, Shopify.Product.prototype.getVariant = function(e) {
    var t = null;
    return e.length != this.options.length ? t : (Shopify.each(this.variants, function(n) {
        for (var r = !0, i = 0; i < e.length; i++) {
            var o = "option" + (i + 1);
            n[o] != e[i] && (r = !1)
        }
        return 1 == r ? void(t = n) : void 0
    }), t)
}, Shopify.Product.prototype.getVariantById = function(e) {
    for (var t = 0; t < this.variants.length; t++) {
        var n = this.variants[t];
        if (e == n.id) return n
    }
    return null
}, Shopify.OptionSelectors = function(e, t) {
    return this.selectorDivClass = "selector-wrapper", this.selectorClass = "single-option-selector", this.variantIdFieldIdSuffix = "-variant-id", this.variantIdField = null, this.historyState = null, this.selectors = [], this.domIdPrefix = e, this.product = new Shopify.Product(t.product), this.onVariantSelected = Shopify.isDefined(t.onVariantSelected) ? t.onVariantSelected : function() {}, this.replaceSelector(e), this.initDropdown(), t.enableHistoryState && (this.historyState = new Shopify.OptionSelectors.HistoryState(this)), !0
}, Shopify.OptionSelectors.prototype.initDropdown = function() {
    var e = {
            initialLoad: !0
        },
        t = this.selectVariantFromDropdown(e);
    if (!t) {
        var n = this;
        setTimeout(function() {
            n.selectVariantFromParams(e) || n.fireOnChangeForFirstDropdown.call(n, e)
        })
    }
}, Shopify.OptionSelectors.prototype.fireOnChangeForFirstDropdown = function(e) {
    this.selectors[0].element.onchange(e)
}, Shopify.OptionSelectors.prototype.selectVariantFromParamsOrDropdown = function(e) {
    var t = this.selectVariantFromParams(e);
    t || this.selectVariantFromDropdown(e)
}, Shopify.OptionSelectors.prototype.replaceSelector = function(e) {
    var t = document.getElementById(e),
        n = t.parentNode;
    Shopify.each(this.buildSelectors(), function(e) {
        n.insertBefore(e, t)
    }), t.style.display = "none", this.variantIdField = t
}, Shopify.OptionSelectors.prototype.selectVariantFromDropdown = function(e) {
    var t = document.getElementById(this.domIdPrefix).querySelector("[selected]");
    if (t || (t = document.getElementById(this.domIdPrefix).querySelector('[selected="selected"]')), !t) return !1;
    var n = t.value;
    return this.selectVariant(n, e)
}, Shopify.OptionSelectors.prototype.selectVariantFromParams = function(e) {
    var t = Shopify.urlParam("variant");
    return this.selectVariant(t, e)
}, Shopify.OptionSelectors.prototype.selectVariant = function(e, t) {
    var n = this.product.getVariantById(e);
    if (null == n) return !1;
    for (var r = 0; r < this.selectors.length; r++) {
        var i = this.selectors[r].element,
            o = i.getAttribute("data-option"),
            a = n[o];
        null != a && this.optionExistInSelect(i, a) && (i.value = a)
    }
    return "undefined" != typeof jQuery ? jQuery(this.selectors[0].element).trigger("change", t) : this.selectors[0].element.onchange(t), !0
}, Shopify.OptionSelectors.prototype.optionExistInSelect = function(e, t) {
    for (var n = 0; n < e.options.length; n++)
        if (e.options[n].value == t) return !0
}, Shopify.OptionSelectors.prototype.insertSelectors = function(e, t) {
    Shopify.isDefined(t) && this.setMessageElement(t), this.domIdPrefix = "product-" + this.product.id + "-variant-selector";
    var n = document.getElementById(e);
    Shopify.each(this.buildSelectors(), function(e) {
        n.appendChild(e)
    })
}, Shopify.OptionSelectors.prototype.buildSelectors = function() {
    for (var e = 0; e < this.product.optionNames().length; e++) {
        var t = new Shopify.SingleOptionSelector(this, e, this.product.optionNames()[e], this.product.optionValues(e));
        t.element.disabled = !1, this.selectors.push(t)
    }
    var n = this.selectorDivClass,
        r = this.product.optionNames(),
        i = Shopify.map(this.selectors, function(e) {
            var t = document.createElement("div");
            if (t.setAttribute("class", n), r.length > 1) {
                var i = document.createElement("label");
                i.htmlFor = e.element.id, i.innerHTML = e.name, t.appendChild(i)
            }
            return t.appendChild(e.element), t
        });
    return i
}, Shopify.OptionSelectors.prototype.selectedValues = function() {
    for (var e = [], t = 0; t < this.selectors.length; t++) {
        var n = this.selectors[t].element.value;
        e.push(n)
    }
    return e
}, Shopify.OptionSelectors.prototype.updateSelectors = function(e, t) {
    var n = this.selectedValues(),
        r = this.product.getVariant(n);
    r ? (this.variantIdField.disabled = !1, this.variantIdField.value = r.id) : this.variantIdField.disabled = !0, this.onVariantSelected(r, this, t), null != this.historyState && this.historyState.onVariantChange(r, this, t)
}, Shopify.OptionSelectorsFromDOM = function(e, t) {
    var n = t.optionNames || [],
        r = t.priceFieldExists || !0,
        i = t.delimiter || "/",
        o = this.createProductFromSelector(e, n, r, i);
    t.product = o, Shopify.OptionSelectorsFromDOM.baseConstructor.call(this, e, t)
}, Shopify.extend(Shopify.OptionSelectorsFromDOM, Shopify.OptionSelectors), Shopify.OptionSelectorsFromDOM.prototype.createProductFromSelector = function(e, t, n, r) {
    if (!Shopify.isDefined(n)) var n = !0;
    if (!Shopify.isDefined(r)) var r = "/";
    var i = document.getElementById(e),
        o = i.childNodes,
        a = (i.parentNode, t.length),
        s = [];
    Shopify.each(o, function(e, i) {
        if (1 == e.nodeType && "option" == e.tagName.toLowerCase()) {
            var o = e.innerHTML.split(new RegExp("\\s*\\" + r + "\\s*"));
            0 == t.length && (a = o.length - (n ? 1 : 0));
            var u = o.slice(0, a),
                l = n ? o[a] : "",
                c = (e.getAttribute("value"), {
                    available: e.disabled ? !1 : !0,
                    id: parseFloat(e.value),
                    price: l,
                    option1: u[0],
                    option2: u[1],
                    option3: u[2]
                });
            s.push(c)
        }
    });
    var u = {
        variants: s
    };
    if (0 == t.length) {
        u.options = [];
        for (var l = 0; a > l; l++) u.options[l] = "option " + (l + 1)
    } else u.options = t;
    return u
}, Shopify.SingleOptionSelector = function(e, t, n, r) {
    this.multiSelector = e, this.values = r, this.index = t, this.name = n, this.element = document.createElement("select");
    for (var i = 0; i < r.length; i++) {
        var o = document.createElement("option");
        o.value = r[i], o.innerHTML = r[i], this.element.appendChild(o)
    }
    return this.element.setAttribute("class", this.multiSelector.selectorClass), this.element.setAttribute("data-option", "option" + (t + 1)), this.element.id = e.domIdPrefix + "-option-" + t, this.element.onchange = function(n, r) {
        r = r || {}, e.updateSelectors(t, r)
    }, !0
}, Shopify.Image = {
    preload: function(e, t) {
        for (var n = 0; n < e.length; n++) {
            var r = e[n];
            this.loadImage(this.getSizedImageUrl(r, t))
        }
    },
    loadImage: function(e) {
        (new Image).src = e
    },
    switchImage: function(e, t, n) {
        if (e && t) {
            var r = this.imageSize(t.src),
                i = this.getSizedImageUrl(e.src, r);
            n ? n(i, e, t) : t.src = i
        }
    },
    imageSize: function(e) {
        var t = e.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);
        return null !== t ? t[1] : null
    },
    getSizedImageUrl: function(e, t) {
        if (null == t) return e;
        if ("master" == t) return this.removeProtocol(e);
        var n = e.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
        if (null != n) {
            var r = e.split(n[0]),
                i = n[0];
            return this.removeProtocol(r[0] + "_" + t + i)
        }
        return null
    },
    removeProtocol: function(e) {
        return e.replace(/http(s)?:/, "")
    }
}, Shopify.OptionSelectors.HistoryState = function(e) {
    this.browserSupports() && this.register(e)
}, Shopify.OptionSelectors.HistoryState.prototype.register = function(e) {
	/*
    window.addEventListener("popstate", function(t) {
        e.selectVariantFromParamsOrDropdown({
            popStateCall: !0
        })
    })
    */
}, Shopify.OptionSelectors.HistoryState.prototype.onVariantChange = function(e, t, n) {
    this.browserSupports() && (!e || n.initialLoad || n.popStateCall || Shopify.setParam("variant", e.id))
}, Shopify.OptionSelectors.HistoryState.prototype.browserSupports = function() {
    return window.history && window.history.replaceState
};

/* Jonathan Snook - MIT License - https://github.com/snookca/prepareTransition */
(function(a){a.fn.prepareTransition=function(){return this.each(function(){var b=a(this);b.one("TransitionEnd webkitTransitionEnd transitionend oTransitionEnd",function(){b.removeClass("is-transitioning")});var c=["transition-duration","-moz-transition-duration","-webkit-transition-duration","-o-transition-duration"];var d=0;a.each(c,function(a,c){d=parseFloat(b.css(c))||d});if(d!=0){b.addClass("is-transitioning");b[0].offsetWidth}})}})(jQuery);

/* firstImpression.js */
window.firstImpression=function(a,b){var c,d,e,f;c=function(a,b,c){var d,e,f;if(arguments.length>1&&String(b)!=="[object Object]"){c=c||{};if(b===null||b===undefined)c.expires=-1;return typeof c.expires=="number"&&(d=c.expires,f=c.expires=new Date,f.setTime(f.getTime()+d*24*60*60*1e3)),document.cookie=[encodeURIComponent(a),"=",encodeURIComponent(b),c.expires?"; expires="+c.expires.toUTCString():"",c.path?"; path="+c.path:"",c.domain?"; domain="+c.domain:"",c.secure?"; secure":""].join("")}return e=(new RegExp("(?:^|; )"+encodeURIComponent(a)+"=([^;]*)")).exec(document.cookie),e?decodeURIComponent(e[1]):null},a===undefined&&(a="_firstImpression"),b===undefined&&(b=730);if(a===null){c("_firstImpression",null);return}if(b===null){c(a,null);return}return d=function(){return c(a)},e=function(){c(a,!0,{expires:b})},f=function(){var a=d();return a||e(),!a},f()}

// Shuffling Function
function shuffleElements(id) {
	var shuffle_parent = $(id);
	var divs = shuffle_parent.children();
    while (divs.length) {
        shuffle_parent.append(divs.splice(Math.floor(Math.random() * divs.length), 1)[0]);
    }
}

// Timber functions
window.timber = window.timber || {};

timber.cacheSelectors = function () {
  timber.cache = {
    // General
    $html                    : $('html'),
    $body                    : $(document.body),

    // Navigation
    $navigation              : $('#AccessibleNav'),
    $mobileSubNavToggle      : $('.mobile-nav__toggle'),

    // Product Page
    $thumbImages             : $('#ProductThumbs').find('a.product-single__thumbnail'),
  };
};

timber.init = function () {
  timber.cacheSelectors();
  timber.accessibleNav();
  timber.drawersInit();
  timber.mobileNavToggle();
};

timber.accessibleNav = function () {
  var $nav = timber.cache.$navigation,
      $allLinks = $nav.find('a'),
      $topLevel = $nav.children('li').find('a'),
      $parents = $nav.find('.site-nav--has-dropdown'),
      $subMenuLinks = $nav.find('.site-nav__dropdown').find('a'),
      activeClass = 'nav-hover',
      focusClass = 'nav-focus';

  // Mouseenter
  $parents.on('mouseenter touchstart', function(evt) {
    var $el = $(this);

    if (!$el.hasClass(activeClass)) {
      evt.preventDefault();
    }

    showDropdown($el);
  });

  // Mouseout
  $parents.on('mouseleave', function() {
    hideDropdown($(this));
  });

  $subMenuLinks.on('touchstart', function(evt) {
    // Prevent touchstart on body from firing instead of link
    evt.stopImmediatePropagation();
  });

  $allLinks.focus(function() {
    handleFocus($(this));
  });

  $allLinks.blur(function() {
    removeFocus($topLevel);
  });

  // accessibleNav private methods
  function handleFocus ($el) {
    var $subMenu = $el.next('ul'),
        hasSubMenu = $subMenu.hasClass('sub-nav') ? true : false,
        isSubItem = $('.site-nav__dropdown').has($el).length,
        $newFocus = null;

    // Add focus class for top level items, or keep menu shown
    if (!isSubItem) {
      removeFocus($topLevel);
      addFocus($el);
    } else {
      $newFocus = $el.closest('.site-nav--has-dropdown').find('a');
      addFocus($newFocus);
    }
  }

  function showDropdown ($el) {
    $el.addClass(activeClass);

    setTimeout(function() {
      timber.cache.$body.on('touchstart', function() {
        hideDropdown($el);
      });
    }, 250);
  }

  function hideDropdown ($el) {
    $el.removeClass(activeClass);
    timber.cache.$body.off('touchstart');
  }

  function addFocus ($el) {
    $el.addClass(focusClass);
  }

  function removeFocus ($el) {
    $el.removeClass(focusClass);
  }
};

timber.drawersInit = function () {
	timber.LeftDrawer = new timber.Drawers('NavDrawer', 'left');
	
	var touchstartX = 0;
	var touchstartY = 0;
	var touchendX = 0;
	var touchendY = 0;
	
	var gesuredZone = document.getElementById('NavDrawer');
	if(typeof(gesuredZone) != 'undefined' && gesuredZone != null){
		gesuredZone.addEventListener('touchstart', function(event) {
		    touchstartX = event.changedTouches[0].screenX;
		    touchstartY = event.changedTouches[0].screenY;
		}, false);
		gesuredZone.addEventListener('touchend', function(event) {
		    touchendX = event.changedTouches[0].screenX;
		    touchendY = event.changedTouches[0].screenY;
		    if (touchendX < touchstartX && (touchstartX - touchendX) >= 100) {
		    	timber.LeftDrawer.close();
		    }
		}, false);
	}
	
	var drawertabs = $('#drawer-tabs')
	drawertabs_content = $('#drawer-tabs-content');
	
	drawertabs.find('li a').click(function(event) {
		event.preventDefault();
		if(!$(this).hasClass('active')) {
			var tabhref = $(this).attr('href');
			drawertabs.find('li.active').removeClass('active');
			$(this).parent().addClass('active');
			drawertabs_content.find('.tab-content.active').removeClass('active');
			$(tabhref).addClass('active');
		}
		
		return false;
	});
	
	drawertabs_content.find('a.mobile-nav-btn.noss').click(function(event) {
		event.preventDefault();
    var tabhref = $(this).attr('href');
    if ($(tabhref).hasClass('active')) {
      $(this).attr('style', '');
      $(tabhref).toggleClass('active');
      return false;
    }
		drawertabs_content.find('a.mobile-nav-btn.noss').each(function(i, e) {
  		$(e).attr('style', '');
		});
		drawertabs_content.find('.mobile-nav').each(function(i, e) {
  		$(e).removeClass('active');
		});
		$(tabhref).toggleClass('active');
		$(this).css({ 'background': 'black'});
		return false;
	});
};

timber.mobileNavToggle = function () {
  timber.cache.$mobileSubNavToggle.on('click', function() {
    $(this).parent().toggleClass('mobile-nav--expanded');
  });
};

timber.getHash = function () {
  return window.location.hash;
};

function activateCollectionFilter() { 
	console.log('filter called')
	// Filter Collection  
  
	// Price filter - existing change event
	$('body').on('change','.collection-price-filter input',function(e) {
		e.preventDefault();   
		handlePriceFilter(e.target);
	});

	// Price filter - new keyboard event
	$('body').on('keydown','.collection-price-filter label',function(e) {
		if (e.key === 'Enter') {
			e.preventDefault();
			let input = e.target.querySelector('input');
			if (input) {
				handlePriceFilter(input);
			}
		}
	});

	// General filters - existing change event
	$('body').on('change','.filter-new input',function(e) {
		e.preventDefault();  
		handleGeneralFilter(e.target);
	});
  
	// General filters - new keyboard event
	$('body').on('keydown','.filter-new label',function(e) {
		if (e.key === 'Enter') {
			e.preventDefault();
          const clickedElementName = e.target.nodeName;
          let input = ''
          if(clickedElementName == 'INPUT'){
            input = e.target;
          }else if(clickedElementName == 'LABEL'){
            input = e.target.querySelector('input');
          } 

			if (input) {
              input.checked = !input.checked
              handleGeneralFilter(input);
			}
		}
	}); 

	// Sort by - existing click event
	$('body').on('click','.sort-by span', function(e) {
		e.preventDefault(); 
		handleSortBy(this);
	});

	// Sort by - new keyboard event
	$('body').on('keydown','.sort-by span', function(e) {
		if (e.key === 'Enter' || e.key === ' ') {
			e.preventDefault();
			handleSortBy(this);
		}
	});

	// Extracted function for price filter logic
	function handlePriceFilter(target) {
		let collection_url = document.querySelector('#collectioUrl').textContent
		let updatedUrl = `${collection_url}?${target.value}`; 

		// other filters
		let params = '';
		$('.filter-new input:checked').each(function() {
			if (this.name && this.value) {
				params += `${this.name}=${this.value}&`;
			}
		});
		params = params.slice(0, -1);
		if(params != ''){
			updatedUrl += '&'+params
		}
		let sort_by = $('.sort-by span.active').attr('data-href')
		if(sort_by){
			updatedUrl += '&'+sort_by
		}
		// other filters end

		fetchAndUpdateContent(updatedUrl);
	}

	// Extracted function for general filter logic
	function handleGeneralFilter(target) {
		 
		let collection_url = document.querySelector('#collectioUrl').textContent
		let params = '';

        console.log(target)
		
		if(target.checked && target.name.includes('color')){
			target.parentElement.classList.add('active-color')
		}else{
			target.parentElement.classList.remove('active-color')
		}
		
		$('.filter-new input:checked').each(function() {
			if (this.name && this.value) {
				params += `${this.name}=${this.value}&`;
			}
		});
		params = params.slice(0, -1); 
		let updatedUrl = `${collection_url}?${params}`; 

		// other filters
		let price = $('.collection-price-filter input:checked').val()
		if(price){
			updatedUrl += '&'+price
		}
		let sort_by = $('.sort-by span.active').attr('data-href')
		if(sort_by){
			updatedUrl += '&'+sort_by
		}
		// other filters end

		fetchAndUpdateContent(updatedUrl);
		if(target.name == 'filter.p.vendor'){
			let h1 = document.querySelector('.section-header__title')
			if(h1.dataFilterActive == '' || h1.dataFilterActive == undefined){
				let canonical = document.querySelector('link[rel="canonical"]');

				h1.textContent = target.value +" "+ h1.dataset.title
				window.history.replaceState({}, '', collection_url + '?filter.p.vendor=' + target.value);
				document.title = target.value +' '+ document.title;
				canonical.setAttribute('href', collection_url + '?filter.p.vendor=' + target.value);
				h1.dataFilterActive = target.value
			}
		}
	}

	// Extracted function for sort by logic
	function handleSortBy(element) {
		let collection_url = document.querySelector('#collectioUrl').textContent
		let sort = $(element).attr('data-href'); 
		$(element).parents('ul.sort-by').find('span').removeClass('active')
		let updatedUrl = `${collection_url}?${sort}`;  

		// fetch other filter values
		let params = '';
		$('.filter-new input:checked').each(function() {
			if (this.name && this.value) {
				params += `${this.name}=${this.value}&`;
			}
		});
		params = params.slice(0, -1);
		if(params != ''){
			updatedUrl += '&'+params
		}
		let price = $('.collection-price-filter input:checked').val()
		if(price){
			updatedUrl += '&'+price
		}
		// fetch other end

		fetchAndUpdateContent(updatedUrl);
		$(element).addClass('active')
	}

	// Extracted function for fetch and update logic
	function fetchAndUpdateContent(updatedUrl) {
		fetch(updatedUrl)
		.then(response => response.text())
		.then(filtered => {
			let result = new DOMParser().parseFromString(filtered, 'text/html');
			checkFilterCount(result.querySelectorAll('.new-collection-container')[0])
			document.querySelector('.new-collection-container').innerHTML = result.querySelectorAll('.new-collection-container')[0].innerHTML;
		})
		.catch(error => {
			console.error('Error fetching data:', error);
		});
	}
		 

	if (typeof peekaboo === "object") {
		peekaboo.observe(); 
	} 
	  
	function checkFilterCount(html){ 
		let countGirdCard =  html.querySelectorAll('.grid__item.product').length
		html.querySelector('.js-counts').innerHTML = countGirdCard;
		html.querySelector('.filter-count').classList.remove('hide__count')
	}

}

function activePagination(){
	$('#pagination-container .pagination span').click(function(e) {
		e.preventDefault()
		console.log(e.target.href)
	})
}

/*============================================================================
  Drawer modules
  - Docs http://shopify.github.io/Timber/#drawers
==============================================================================*/
timber.Drawers = (function () {
  var Drawer = function (id, position, options) {
    var defaults = {
      close: '.js-drawer-close',
      open: '.js-drawer-open-' + position,
      openClass: 'js-drawer-open',
      dirOpenClass: 'js-drawer-open-' + position
    };

    this.$nodes = {
      parent: $('body, html'),
      page: $('#PageContainer'),
      moved: $('.is-moved-by-drawer')
    };

    this.config = $.extend(defaults, options);
    this.position = position;

    this.$drawer = $('#' + id);

    if (!this.$drawer.length) {
      return false;
    }

    this.drawerIsOpen = false;
    this.init();
  };

  Drawer.prototype.init = function () {
    $(this.config.open).on('click', $.proxy(this.open, this));
    this.$drawer.find(this.config.close).on('click', $.proxy(this.close, this));
  };

  Drawer.prototype.open = function (evt) {
    // Keep track if drawer was opened from a click, or called by another function
    var externalCall = false;

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Without this, the drawer opens, the click event bubbles up to $nodes.page
    // which closes the drawer.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.$activeSource = $(evt.currentTarget);
    }

    if (this.drawerIsOpen && !externalCall) {
      return this.close();
    }

    // Notify the drawer is going to open
    timber.cache.$body.trigger('beforeDrawerOpen.timber', this);

    // Add is-transitioning class to moved elements on open so drawer can have
    // transition for close animation
    this.$nodes.moved.addClass('is-transitioning');
    this.$drawer.prepareTransition();

    this.$nodes.parent.addClass(this.config.openClass + ' ' + this.config.dirOpenClass);
    this.drawerIsOpen = true;

    // Set focus on drawer
    this.trapFocus(this.$drawer, 'drawer_focus');

    // Run function when draw opens if set
    if (this.config.onDrawerOpen && typeof(this.config.onDrawerOpen) == 'function') {
      if (!externalCall) {
        this.config.onDrawerOpen();
      }
    }

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'true');
    }

    // Lock scrolling on mobile
    this.$nodes.page.on('touchmove.drawer', function () {
      return false;
    });

    this.$nodes.page.on('click.drawer', $.proxy(function () {
      this.close();
      return false;
    }, this));

    // Notify the drawer has opened
    timber.cache.$body.trigger('afterDrawerOpen.timber', this);
  };

  Drawer.prototype.close = function () {
    if (!this.drawerIsOpen) { // don't close a closed drawer
      return;
    }

    // Notify the drawer is going to close
    timber.cache.$body.trigger('beforeDrawerClose.timber', this);

    // deselect any focused form elements
    $(document.activeElement).trigger('blur');

    // Ensure closing transition is applied to moved elements, like the nav
    this.$nodes.moved.prepareTransition({ disableExisting: true });
    this.$drawer.prepareTransition({ disableExisting: true });

    this.$nodes.parent.removeClass(this.config.dirOpenClass + ' ' + this.config.openClass);

    this.drawerIsOpen = false;

    // Remove focus on drawer
    this.removeTrapFocus(this.$drawer, 'drawer_focus');

    this.$nodes.page.off('.drawer');

    // Notify the drawer is closed now
    timber.cache.$body.trigger('afterDrawerClose.timber', this);
  };

  Drawer.prototype.trapFocus = function ($container, eventNamespace) {
    var eventName = eventNamespace ? 'focusin.' + eventNamespace : 'focusin';

    $container.attr('tabindex', '-1');

    $container.focus();

    $(document).on(eventName, function (evt) {
      if ($container[0] !== evt.target && !$container.has(evt.target).length) {
        $container.focus();
      }
    });
  };

  Drawer.prototype.removeTrapFocus = function ($container, eventNamespace) {
    var eventName = eventNamespace ? 'focusin.' + eventNamespace : 'focusin';

    $container.removeAttr('tabindex');
    $(document).off(eventName);
  };

  return Drawer;
})();

var vis=function(){var i,n,e={hidden:"visibilitychange",webkitHidden:"webkitvisibilitychange",mozHidden:"mozvisibilitychange",msHidden:"msvisibilitychange"};for(i in e)if(i in document){n=e[i];break}return function(e){return e&&document.addEventListener(n,e),!document[i]}}();

function isFunction(functionToCheck) {
	var getType = {};
	return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}

function getToken(callback) {
	if(window.ShopifyCart) {
		callback(window.ShopifyCart.token);
	}
	else {
		Shopify.getCart(function(cart) {
			callback(cart.token);
		});
	}
}

var userlikes = [];
var gotuserlikes = false;

function likeClick(button) {
	console.log('Clicked Like Button');
	
	var pid = button.data('pid');
	var cid = '';
	var sid = getCurrentSessionId().split('_')[1]
	if(button.data('cid')) {
		cid = button.data('cid');
	} 
	
	var action = 'like';
	if(button.hasClass('active')) {
		action = 'unlike';
		button.removeClass('active');
	}
	else {
		button.addClass('active');
		
		if(!customer_id) {
			$('#liked-product-modal').show();
			$('.current-url').val(window.location.href);
		}
		
		$('#likes-notice').show().delay(5000).fadeOut(300);
		$('#mobile-header-like-btn, .header-icon-like-btn').removeClass('animated bounce').addClass('bounce animated');
	}
	
	$.get('//warely.io/apps/wishlist/add.php', { action : action, pid : pid, cid : cid, sid:sid}, function(likes) {
		userlikes = likes;
		gotuserlikes = true;
	});


	if(button.hasClass('like-product-btn-new')){
		$.get('//warely.io/apps/wishlist/add.php', { action : 'wishlist_product_count', pid : pid }, function(product_likes) {
			$('.likescount').html(product_likes.count)
		});
	}
	
	// Klaviyo Likes
	var _learnq = _learnq || [];
	_learnq.push(['track', 'Liked Product', {
		'customer_id' : cid,
		'product_id' : pid,
		'action' : action
	}]);
}

function getCurrentSessionId() {
  let sessionId = localStorage.getItem('sessionId');
  if (!sessionId) {
    sessionId = 'session_' + Date.now(); // Generate a simple unique ID
    localStorage.setItem('sessionId', sessionId);
  }
  return sessionId;
}

function activateLikes() { 
	$('body').on('click','.like-btn, .activate-like',function(event) {
		event.preventDefault();
		var $this = $(this);
		if($this.data('pid')) {
			likeClick($this);
		}
	});
}

function setLikes(likes) {
	$.each(likes, function(i, l) {
		$('.like-btn[data-pid="'+l+'"]').addClass('active');
		$('.like-product-btn-new[data-pid="'+l+'"]').addClass('active');
	});
}

function getLikes(cid, f) { 
	
		let newCID = null
	 
	let newSID = (localStorage.getItem('sessionId') && localStorage.getItem('sessionId').split('_')[1]) || null

	$.get('//warely.io/apps/wishlist/add.php', { action : 'get',  cid : newCID, sid:newSID}, function(likes) {
		// console.log('wishlist ids',likes) 
		userlikes = likes;
		setLikes(likes);
		gotuserlikes = true;
		
		if(likes.length > 0) {
			$('#mobile-header-like-btn, .header-icon-like-btn').addClass('has-likes');
		}
		
		if(f !== undefined && typeof f == "function") {
			f(likes);
		}
	});


	if(window.location.href.includes('/products/')){
		// console.log('/products url')
		$.get('//warely.io/apps/wishlist/add.php', { action : 'wishlist_product_count', pid : productjson.id }, function(product_likes) {
			$('.likescount').html(product_likes.count)
		});
	}
}

function guid() {
	return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
}

function s4() {
	return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
}

function continueWithNextIdp(notification) {
	if (notification.isNotDisplayed() || notification.isSkippedMoment()) {
		// try Next provider if One Tap is not displayed or skipped
		if(!botCheck()) { persistantLogin(window.ShopifyCart.token); }
	}
}

function persistantLogin(carttoken){
    if(typeof window.Warely.fingerprint !== "undefined") {
	    var is_incognito = getCookie('is_incognito');
	    if(typeof is_incognito === "undefined" || is_incognito == 'false') {
		    console.log('Validating fingerprint...');
	   		$.post('//warely.io/apps/multipass-login/?client=2', { prevalidate: true, fingerprint:window.Warely.fingerprint, cart_token:carttoken, returnto:window.location.href }, function(resp) {
				var resp = jQuery.parseJSON(resp);
				if(resp.success) {
					//console.log('Success... redirecting...');
					//window.location.href = resp.url;
				}
				else {
					ageGate(window.ShopifyCart);
				}
			});
		}
		else {
			ageGate(window.ShopifyCart);
		}
    }
    else{
        setTimeout(function() { persistantLogin(carttoken); }, 250);
    }
}

function ageGate(cart = null) {   
	if (botCheck()) {
		console.log('the user agent is a crawler!');
	}else{
		if( Cookies2.get('age-verify') != 'verified' && !customer_id) {
			// Show age verify
			// $('#age-verify').show(); 
			
			$('#age-verify .yes-age').click(function(event) {
				Cookies2.set('returnuponlogin', window.location.href, { expires: 2 });
				// Shopify.updateCartAttributes({ 'age-verify' : 'verified' });
				Cookies2.set('age-verify', 'verified', { expires: 7 });
				$('#age-verify').hide(); 
				const ageVerified = new Event("ageVerified");
				document.dispatchEvent(ageVerified);
			});
			 
	
			$('#age-verify .no-age').click(function(event) {  
				$('.not-eligible-age').show()  
			});
			 
		}
	}
	
}

function animateScroll() {
	$('a[href*="#"]:not([href="#"], .noanimate)').click(function() {
		if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
		  var target = $(this.hash);
		  target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
		  if (target.length) {
		    $('html, body').animate({
		      scrollTop: target.offset().top - 50
		    }, 1000);
		    return false;
		  }
		}
	});
}

/*
 * jQuery throttle / debounce - v1.1 - 3/7/2010
 * http://benalman.com/projects/jquery-throttle-debounce-plugin/
 * 
 * Copyright (c) 2010 "Cowboy" Ben Alman
 * Dual licensed under the MIT and GPL licenses.
 * http://benalman.com/about/license/
 */
(function(b,c){var $=b.jQuery||b.Cowboy||(b.Cowboy={}),a;$.throttle=a=function(e,f,j,i){var h,d=0;if(typeof f!=="boolean"){i=j;j=f;f=c}function g(){var o=this,m=+new Date()-d,n=arguments;function l(){d=+new Date();j.apply(o,n)}function k(){h=c}if(i&&!h){l()}h&&clearTimeout(h);if(i===c&&m>e){l()}else{if(f!==true){h=setTimeout(i?k:l,i===c?e-m:e)}}}if($.guid){g.guid=j.guid=j.guid||$.guid++}return g};$.debounce=function(d,e,f){return f===c?a(d,e,false):a(d,f,e!==false)}})(this);

Array.prototype.allValuesSame = function() { for(var i = 1; i < this.length; i++) { if(this[i] !== this[0]) return false; } return true; }

function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

function activateSearch() {	
	if(window.customer_is_wholesale || is_wholesale) {
		var $searchbar = $('.searchbar-input'),
		$searchform = $('form.search-form'),
		$searchclearbtn = $('.clear-search'),
		$mobilesearch = $('#mobile-search'),
		$searchautocomplete = $searchform.find('.autocomplete');
		
		var smoothState = $('#main').smoothState().data('smoothState');
		
		$searchbar.unbind().on("keyup paste", $.debounce(200, function() {		
			var val = $(this).val().trim();
			
			if(val.length >= 3) {			
				// Autocomplete
				$searchautocomplete.find('.products').hide();
				
				// Run autocomplete
				$.getJSON('//warely.io/apps/search/autocomplete.php', { q : val, site: 'smoke-cartel', wholesale: window.customer_is_wholesale }, function(resp) {
					$searchautocomplete.find('ul').html('');
					
					$.each(resp.queries, function(i, e) {
						var href = '/a/search/'+encodeURI(e.title.toLowerCase().trim());
						var extra = '';
						if(e.hasOwnProperty("link")) {
							href = e.link;
							extra = '<span class="tag pull-right">Category</span>';
						}
						$searchautocomplete.find('.queries ul').append('<li><a href="'+href+'">'+e.title.replace(val, '<strong>'+val+'</strong>')+extra+'</a></li>');
					});
					
					if(resp.products.length > 0) {
						$.each(resp.products, function(i, e) {
							var pricing = '<span class="price">$'+e.price+'</span>';
							if(e.compare_price != '' && e.compare_price > e.price) {
								// pricing += ' - <span class="red">On Sale!</span> Originally <s>$'+e.compare_price+'</s>';
							}
							var link_url = '/products/'+e.handle;
							if(e.hasOwnProperty('wholesale') && e.wholesale) {
								pricing += '<br /><small style="color:#405DE6;">Business Pricing</small>';
								link_url = '/a/wholesale/'+e.handle;
							}
							
							$searchautocomplete.find('.products ul').append('<li><a href="'+link_url+'"><span class="img"><img src="//www.smokecartel.com/cdn/shop/t/38/assets/b-square_140x200_crop_center.gif?v=123531691150174760991733865278" data-src="'+Shopify.resizeImage(e.image, '140x200_crop_center')+'" class="lazyload" alt="" /></span><span class="content"><span class="white">'+e.title.replace(val, '<strong>'+val+'</strong>')+'</span><br />'+pricing+'</span></a></li>');
						});
						$searchautocomplete.find('.products').show();
					}
					
					$searchautocomplete.find('a:not(.close)').click(function(event) {
						event.preventDefault();
						
						if(location.hostname === this.hostname || !this.hostname.length ) {
							nexturl = $(this).attr('href');
							$nexturllink.attr('href', nexturl);
							smoothState.fetch(nexturl);
							smoothState.load(nexturl);
							window.history.pushState("", "", nexturl);
							// $mobilesearch.addClass('mbl__searchHide');
							$searchclearbtn.hide();
							$searchautocomplete.hide();
						}
						else {
							window.open($(this).attr('href'), '_blank');
						}
						return false;
					});
					
					if($searchbar.is(":focus")) {				
						$searchautocomplete.show();
					}
				});
			}
			else {
				$searchclearbtn.hide();
				$searchautocomplete.hide();
			}	
		}));
		
		$searchbar.focus(function() {
			var val = $(this).val().trim();
			if(val != '') {
				$searchbar.trigger("keyup");
				$searchautocomplete.show();
			}
		});
		
		$searchbar.blur(function() {
			setTimeout(function() {
				$searchautocomplete.hide();
				// $mobilesearch.addClass('mbl__searchHide');
			}, 400);
		});
		
		$searchautocomplete.find('a.close').click(function(event) {
			event.preventDefault();
			
			$searchautocomplete.hide();
			// $mobilesearch.addClass('mbl__searchHide');
		});
		
		$searchform.submit(function(event) {
			event.preventDefault();
			
			var val = $(this).find('.searchbar-input').val().trim();
			
			if(val.toLowerCase().includes("cbd")) {
				window.location.replace('https://www.smokecartel.com/a/search/'+encodeURI(val.toLowerCase().trim()));
			}
			else {
				var nexturl = '/a/search/'+encodeURI(val.toLowerCase().trim());
				$nexturllink.attr('href', nexturl);
				smoothState.fetch(nexturl);
				smoothState.load(nexturl);
				window.history.pushState("", "", nexturl);
			}
			
			$searchbar.blur();
			$searchautocomplete.hide();
		});
	}
}

function shuffle(a){var j,x,i;for(i=a.length-1;i>0;i--){j=Math.floor(Math.random()*(i+1));x=a[i];a[i]=a[j];a[j]=x}
return a}

function renderFaucets(faucets) {
	var csidebar = $('#collection-filter, #collection-top-filter');
	for(var key in faucets) {
		if(key == 'colors') {
			for(var color in faucets.colors) { csidebar.find('#count_color_'+color).html('('+faucets.colors[color]+')'); }
		}
		else { csidebar.find('#count_'+key).html('('+faucets[key]+')'); }
		
		if(faucets[key] <= 0) {
			csidebar.find('#count_'+key).parent().hide();
		}
	}
	$('.collection-color-filter').find('span.pull-right:empty').parent().hide();	
	// activateCollectionFilter();
}

function activateProductAltView() {
	// See other variants
	$('.product').find('.slide-control').click(function(event) {
		event.preventDefault();
		var container = $(this).parent();
		var currentimg = container.find('img.active:not(.instagram-photo):first');
		var currentheight = currentimg.height();
		container.addClass('slid');
		
		if($(this).hasClass('left-control')) {
			var newimg = currentimg.prev('img:not(.instagram-photo)').css('height', currentheight+'px');
			if(newimg.length <= 0) {
				newimg = container.find('img:not(.instagram-photo):last');
			}
		}
		else if($(this).hasClass('right-control')) {
			var newimg = currentimg.next('img:not(.instagram-photo)').css('height', currentheight+'px');
			if(newimg.length <= 0) {
				newimg = container.find('img:not(.instagram-photo):first');
			}
		}
		currentimg.removeClass('active');
		newimg.addClass('active loaded');
		
		setTimeout(function (){ container.removeAttr('style'); }, 2000);
		return false;
	});
}

var waitForEl = function(selector, callback) {
	if (jQuery(selector).length) {
		callback();
	} else {
		setTimeout(function() {
			waitForEl(selector, callback);
		}, 1000);
	}
};

function loadLikesScroller(customer_id) {
	// getLikes(customer_id, function(likes) {
  	// 	if(likes.length > 0) {
	//   		pids = likes.slice(0, 24).join(' ');
	//   		$.getJSON('//api.smokecartel.com/like.php?retrieve='+pids, function(resp) {				
	// 			var $liked = $('#liked-scroller');
	// 			$liked.html('');
	// 			$.each(resp.products, function(i,p) {
	// 				renderScroller(i, p, $liked);
	// 			});
	// 			$('#liked-products .like-btn').addClass('active');
	// 		});
	// 		$('#liked-products').show();
	// 	}
	// });
}

function renderCartHistory(carts, cart) {
	var haseligiblecart = false;
	$('#cart-history-load').html('');
	$.each(carts, function(c_token, c) {
		if(c_token != cart.token) {
			// Previous cart
			var cartbody = '';
			var eligible_items = 0;
			$.each(c.items, function(key, item) {
				var ptitle = item.product_title;
				if(item.variant_title != 'Default Title' && item.variant_title != null) {
					ptitle += '<br /><small>'+item.variant_title+'</small>';
				}
				
				var found = false;
				$.each(cart.items, function(key2, item2) {
					if(item.variant_id == item2.variant_id) {
						found = true;
					}
				});
				
				var cactions = '<a href="#" class="add-item-to-cart" data-cart-token="'+c_token+'" data-id="'+item.id+'"><i class="icon-plus"></i> Add to Current Cart</a>';
				if(found) {
					cactions = '<span class="tag">Already in current cart</span>';
				}
				else {
					eligible_items++;
				}
				
				cartbody += '<tr><td class="text-center table--small-hide"><img src="//www.smokecartel.com/cdn/shop/t/38/assets/b.gif?v=111003715552405036781733865278" data-src="'+Shopify.resizeImage(item.image, '64x')+'" class="lazyload desktop" alt="" /></td><td><p class="mobile"><img src="//www.smokecartel.com/cdn/shop/t/38/assets/b.gif?v=111003715552405036781733865278" data-src="'+Shopify.resizeImage(item.image, '64x')+'" class="lazyload" alt="" /></p><p><a href="'+item.url+'">'+ptitle+'</small></a></p><p><span class="price h5">'+Shopify.formatMoney(item.price).replace('$', '<span class="dollar">$</span>').replace('.', '<span class="cents">.')+'</span></span></p></td><td>'+cactions+'</td></tr>';
			});		
			
			if(eligible_items > 0) {
				haseligiblecart = true;
				$('#cart-history-load').append('<div id="'+c_token+'" class="rounded muted-panel cart-history-item extend-mobile-nopadding"><h5>Cart with '+c.items.length+' Items</h5><div class="contents"><table class="table extend-mobile-nopadding"><thead><tr><th class="table--small-hide"></th><th>Item</th><th>Actions</th></tr></thead><tbody>'+cartbody+'</tbody></table><br /><p><a href="'+c.recover_url+'" class="btn"><i class="icon-basket"></i> Checkout with this Cart</a><br class="mobile" /><br class="mobile" /> <a href="#" class="merge-cart noss btn--muted" data-cart-token="'+c_token+'"><i class="icon-plus"></i> Merge with Current Cart</a></p></div></div><br />');
			}
		}
	});
	
	if(haseligiblecart) {
		$('#cart-history').show();
	
		// Activate buttons
		$('#cart-history-load .add-item-to-cart').click(function(event) {
			event.preventDefault();
			
			var cart_token = $(this).data('cart-token');
			var item_id = $(this).data('id');
			var $td = $(this).parent();
			
			// Locate item
			if(carts.hasOwnProperty(cart_token)) {
				$.each(carts[cart_token].items, function(i,e) {
					if(e.id == item_id) {					
						var item = {
							quantity: e.quantity,
							id: e.variant_id,
						}
						if(e.hasOwnProperty('properties')) {
							item.properties = e.properties;
						}
						
						$.ajax({
				    	    type: 'POST',
				    		url: '/cart/add.js',
				    		data: item,
				    		dataType: 'json',
				    		success: function(added_item) {
								$td.html('<span class="tag">Added to current cart</span>');
								$.get('/cart', function(html) {
									var carthtml = $(html);
									$('table.cart-table').html(carthtml.find('table.cart-table'));
									activateCartActions();
								});
								
								Shopify.getCart(function(newcart) {
									updateCartUI(newcart);
								});
				  			}
				    	});
				    	
					}
				});
			}
		});
		
		$('#cart-history-load .merge-cart').click(function(event) {
			event.preventDefault();
			var cart_token = $(this).data('cart-token');
			
			if(carts.hasOwnProperty(cart_token)) {
				var updates_obj = {};
				$.each(carts[cart_token].items, function(i,e) {
					updates_obj[e.variant_id] = e.quantity;
				});
			}
			
			$.ajax({
	    	    type: 'POST',
	    		url: '/cart/update.js',
	    		data: { 'updates': updates_obj },
	    		dataType: 'json',
	    		success: function(resp) {
		    		console.log(resp);
		    		console.log(updates_obj);
					
					document.location.href = '/cart';
	  			}
			});
			
		});
	}
	else {
		$('#cart-history-load').html('<p>Could not find any other open carts for this account.</p>');
	}
}

function loadProofAgo() {
	loadMoment().then(function() {
		$('span.load-ago[data-timestamp]').each(function(i, e) {
			var timestamp = $(this).data('timestamp')*1000;
			var ago = moment(timestamp).fromNow();
			$(this).html(ago);
			$(this).removeClass('load-ago');
		});
	});
}

function countDown(timestamp, element) {
  timestamp = timestamp != undefined ? timestamp : 0;
	loadMoment().then(function() {
	    var $clock = $(element);
	    
	    $clock.each(function() {		    
		    if(timestamp == 0 || $(this).attr('data-timestamp')) {
			    timestamp = $(this).attr('data-timestamp');
		    }
		    
		    var eventTime = timestamp,
	        currentTime = moment().unix(),
	        diffTime = eventTime - currentTime,
	        duration = moment.duration(diffTime * 1000, 'milliseconds');
	
		    if (diffTime > 0) {
			    var $d = $('<span class="days"></span>').appendTo($(this)),
			        $h = $('<span class="hours"></span>').appendTo($(this)),
			        $m = $('<span class="minutes"></span>').appendTo($(this)),
			        $s = $('<span class="seconds"></span>').appendTo($(this));
			    setInterval(function() {
			        duration = moment.duration(duration.asMilliseconds() - 1000, "milliseconds");
			        var a = moment.duration(duration).days(),
			            b = moment.duration(duration).hours(),
			            c = moment.duration(duration).minutes(),
			            d = moment.duration(duration).seconds();
					
					if(a > 0) {
						$d.text(a + " Days, ");
					}
					if(b > 0) {
						$h.text(b + " Hours, ");
					}
					$m.text(c + " Minutes, ");
					$s.text(d + " Seconds");
					
			    }, 1000)
			}
		    
	    });
    });
}

var last_recently_view = null;
var getRecentlyViewed = function() {
	// Get Recently Viewed
	if(Cookies2.get('smokecartel_recently_viewed') && last_recently_view != Cookies2.get('smokecartel_recently_viewed') && $('#footer-recently-viewed').length > 0) {
		var handles = Cookies2.get('smokecartel_recently_viewed');
		handles = handles.split(' ');
		
		if(handles.length > 0) {
			$('#footer-recently-viewed').show();
			$('#footer-recommendations, #footer-fallback-slider').hide();
			$sscroller = $('#footer-recently-viewed-load');
			$sscroller.html('');
			
			for(var i = 0; i < 12; i++) {
				if(i <= handles.length) {
					// Get Data
					
					if(handles[i] != 'elite-member-gift' && handles[i] != '' && handles[i] != 'undefined' && handles[i] != 'elite-yearly-membership') { 
						fetch('/products/'+handles[i]+'?section_id=fetch-product-grid-item').then(response => {
							return response.text();
						}).then(data => {
							let dataDOM = data ? new DOMParser().parseFromString(data, 'text/html') : '';
							let dataGrid = dataDOM.querySelector('.grid__item.product');
							if(dataGrid && dataGrid.innerHTML != '') { 
								let slideContainer = `<div class="slide internal fetch--slider-item"><div class="slide-container">${dataGrid.innerHTML}</div></div>`
								$sscroller.append(slideContainer);
								$sscroller.on("click", '.smoothto:not([href*="#"], [target="_blank"], .noss)', function(event) {
									event.preventDefault();
								})
							}
						})


					}
				}
			}
			
			
			last_recently_view = Cookies2.get('smokecartel_recently_viewed');
			recentlyViewdNew()
		}
		else {
			// No recently viewed items yet
			// Try to get recommendations
			$.getJSON("//warely.io/apps/recommendations/beta.php?cart_token="+window.ShopifyCart.token+"&limit=20&scenario=footer_reccs&type=items-to-user", function(products) {
			    if(products.length >= 7) {
					var scrollertarget = $('#footer-recommendations-load');
					scrollertarget.html('');
					$.each(products, function(i, e) {
						renderScroller_new(i, e, scrollertarget); 
					});
										
					$('#footer-recommendations').show();
					$('#footer-recently-viewed, #footer-fallback-slider').hide();
					activateSlider();
					activateVideo(ismobile);
				}
				else {
					// Not enough recommendations
					// Fallback to staff picks
					$('#footer-fallback-slider').show();
					$('#footer-recently-viewed, #footer-recommendations').hide();
				}
			});
		}
	}
	else if(typeof Cookies2.get('smokecartel_recently_viewed') == 'undefined') {
		// No recently viewed items yet
		$.getJSON("//warely.io/apps/recommendations/beta.php?cart_token="+window.ShopifyCart.token+"&limit=20&scenario=footer_reccs&type=items-to-user", function(products) {
		    if(products.length >= 7) {
				var scrollertarget = $('#footer-recommendations-load');
				scrollertarget.html('');
				$.each(products, function(i, e) {
					renderScroller_new(i, e, scrollertarget); 
				});
									
				$('#footer-recommendations').show();
				$('#footer-recently-viewed, #footer-fallback-slider').hide();
				activateSlider();
				activateVideo(ismobile);
			}
			else {
				// Not enough recommendations
				// Fallback to staff picks
				$('#footer-fallback-slider').show();
				$('#footer-recently-viewed, #footer-recommendations').hide();
			}
		});
	}
}

function recentlyViewdNew(){
	// Get DOM elements using jQuery (adjusted for your structure)
	const $scrollerWrapper = $('#footer-recently-viewed-load');
	const $prevBtn = $('#footer-recently-viewed .scroller-btn.prev');
	const $nextBtn = $('#footer-recently-viewed .scroller-btn.next');

	// Configuration
	const slideDistance = 200; // pixels to slide
	let currentPosition = 0;

	// Get total scrollable width
	function getMaxScroll() {
		return $scrollerWrapper[0].scrollWidth - $scrollerWrapper[0].clientWidth;
	}

	// Update button states based on current position
	function updateButtonStates() {
		const maxScroll = getMaxScroll();
		
		// Disable prev button if at the beginning
		$prevBtn.prop('disabled', currentPosition <= 0);
		
		// Disable next button if at the end
		$nextBtn.prop('disabled', currentPosition >= maxScroll);
		
		// Add/remove disabled class for styling
		$prevBtn.toggleClass('disabled', currentPosition <= 0);
		$nextBtn.toggleClass('disabled', currentPosition >= maxScroll);
	}

	// Smooth scroll function
	function smoothScroll(targetPosition) {
		$scrollerWrapper.animate({
			scrollLeft: targetPosition
		}, 300); // 300ms animation duration
	}

	// Handle next button click
	function handleNext() {
		const maxScroll = getMaxScroll();
		currentPosition = Math.min(currentPosition + slideDistance, maxScroll);
		smoothScroll(currentPosition);
		updateButtonStates();
	}

	// Handle previous button click
	function handlePrev() {
		currentPosition = Math.max(currentPosition - slideDistance, 0);
		smoothScroll(currentPosition);
		updateButtonStates();
	}

	// Event listeners using jQuery
	$nextBtn.on('click', handleNext);
	$prevBtn.on('click', handlePrev);

	// Handle manual scrolling (optional - keeps buttons in sync)
	$scrollerWrapper.on('scroll', function() {
		currentPosition = $scrollerWrapper.scrollLeft();
		updateButtonStates();
	});

	// Initialize button states after products are loaded
	function initializeSlider() {
		updateButtonStates();
	}

	// Handle window resize (recalculate max scroll)
	$(window).on('resize', function() {
		currentPosition = Math.min(currentPosition, getMaxScroll());
		updateButtonStates();
	});
}

var Base64={_keyStr:"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",encode:function(e){var t="";var n,r,i,s,o,u,a;var f=0;e=Base64._utf8_encode(e);while(f<e.length){n=e.charCodeAt(f++);r=e.charCodeAt(f++);i=e.charCodeAt(f++);s=n>>2;o=(n&3)<<4|r>>4;u=(r&15)<<2|i>>6;a=i&63;if(isNaN(r)){u=a=64}else if(isNaN(i)){a=64}t=t+this._keyStr.charAt(s)+this._keyStr.charAt(o)+this._keyStr.charAt(u)+this._keyStr.charAt(a)}return t},decode:function(e){var t="";var n,r,i;var s,o,u,a;var f=0;e=e.replace(/[^A-Za-z0-9+/=]/g,"");while(f<e.length){s=this._keyStr.indexOf(e.charAt(f++));o=this._keyStr.indexOf(e.charAt(f++));u=this._keyStr.indexOf(e.charAt(f++));a=this._keyStr.indexOf(e.charAt(f++));n=s<<2|o>>4;r=(o&15)<<4|u>>2;i=(u&3)<<6|a;t=t+String.fromCharCode(n);if(u!=64){t=t+String.fromCharCode(r)}if(a!=64){t=t+String.fromCharCode(i)}}t=Base64._utf8_decode(t);return t},_utf8_encode:function(e){e=e.replace(/rn/g,"n");var t="";for(var n=0;n<e.length;n++){var r=e.charCodeAt(n);if(r<128){t+=String.fromCharCode(r)}else if(r>127&&r<2048){t+=String.fromCharCode(r>>6|192);t+=String.fromCharCode(r&63|128)}else{t+=String.fromCharCode(r>>12|224);t+=String.fromCharCode(r>>6&63|128);t+=String.fromCharCode(r&63|128)}}return t},_utf8_decode:function(e){var t="";var n=0;var r=c1=c2=0;while(n<e.length){r=e.charCodeAt(n);if(r<128){t+=String.fromCharCode(r);n++}else if(r>191&&r<224){c2=e.charCodeAt(n+1);t+=String.fromCharCode((r&31)<<6|c2&63);n+=2}else{c2=e.charCodeAt(n+1);c3=e.charCodeAt(n+2);t+=String.fromCharCode((r&15)<<12|(c2&63)<<6|c3&63);n+=3}}return t}}

// DialogTriggerJS
// Copyright (c) 2016-2017 Shahzad Malik
// MIT License
//
// Triggers a callback to pop up a dialog (or do anything else) with the specified trigger options.
//
// "trigger" can be one of the following:
//    'exitIntent': Call 'callback' when a user intends to exit (such as moving cursor off page or coming back to the top)
//    'target': Call 'callback' when a user reaches a particular target element (set 'target' to the name of the element, such as '#mytarget')
//    'scrollDown': Call 'callback' when a user scrolls down by a certain percent from when the object is instantiated (set 'percentDown' to the percentage 0-100)
//    'scrollUp': Call 'callback' when a user scrolls up by a certain percent from when the object is instantiated (set 'percentUp' to the percentage 0-100)
//    'timeout': Call 'callback' after a certain number of milliseconds have elapsed (set 'timeout' to the desired milliseconds)
//
// Examples:
// Setting up individual triggers:
//    var dt = new DialogTrigger(triggerNagPopup, { trigger: 'timeout', timeout: 5000 });
//    var dt = new DialogTrigger(triggerNagPopup, { trigger: 'target', target: '#all' });
//    var dt = new DialogTrigger(triggerNagPopup, { trigger: 'scrollDown', percentDown: 50 });
//    var dt = new DialogTrigger(triggerNagPopup, { trigger: 'exitIntent' });
//
// Triggers can also be chained for a sequence of behaviors (such as scroll down by 50%, then exit):
//    var dtPercent = new DialogTrigger(function() {
//       var dtExit = new DialogTrigger(triggerNagPopup, { trigger: 'exitIntent' });
//    }, { trigger: 'scrollDown', percentDown: 50 });
function DialogTrigger(callback, options) {
	// Becomes this.options
	var defaults = {
		trigger	: 'timeout',
		target	: '',
		timeout	: 0,
		percentDown : 50, // Used for 'percent' to define a down scroll threshold of significance (based on page height)
		percentUp : 10, // Used for 'percent' to define a threshold of upward scroll after down threshold is reached
		scrollInterval: 1000 // Frequency (in ms) to check for scroll changes (to avoid bogging the UI)
	}
	
	this.complete = false; // Let's us know if the popup has been triggered
	
	this.callback = callback;
	this.timer = null;
	this.interval = null;
	
	this.options = jQuery.extend(defaults, options);
	
	this.init = function() {
		if(this.options.trigger == 'exitIntent' || this.options.trigger == 'exit_intent') {
			var parentThis = this;
			
			jQuery(document).on('mouseleave', function(e) {
				//console.log(e.clientX + ',' + e.clientY); // IE returns negative values on all sides
				
				if(!parentThis.complete && e.clientY < 0) { // Check if the cursor went above the top of the browser window
					parentThis.callback();
					parentThis.complete = true;
					jQuery(document).off('mouseleave');
				}
			});

		} else if(this.options.trigger == 'target') {
			if(this.options.target !== '') {
				// Make sure the target exists
				if(jQuery(this.options.target).length == 0) {
					this.complete = true;
				} else {
					var targetScroll = jQuery(this.options.target).offset().top;
					
					var parentThis = this;
					
					// Only check the scroll position every few seconds, to avoid bogging the UI
					this.interval = setInterval(function() {
						if(jQuery(window).scrollTop() >= targetScroll) {
							clearInterval(parentThis.interval);
							parentThis.interval = null;
							
							if(!parentThis.complete) {
								parentThis.callback();
								parentThis.complete = true;
							}
						}
					}, this.options.scrollInterval);
				}
			}
			
		} else if(this.options.trigger == 'scrollDown') {
			// Let the user scroll down by some significant amount
			var scrollStart = jQuery(window).scrollTop();
			var pageHeight = jQuery(document).height();
			
			var parentThis = this;
			
			if(pageHeight > 0) {
				// Only check the scroll position every few seconds, to avoid bogging the UI
				this.interval = setInterval(function() {
					var scrollAmount = jQuery(window).scrollTop() - scrollStart;
					if(scrollAmount < 0) {
						scrollAmount = 0;
						scrollStart = jQuery(window).scrollTop();
					}
					var downScrollPercent = parseFloat(scrollAmount) / parseFloat(pageHeight);
					
					if(downScrollPercent > parseFloat(parentThis.options.percentDown) / 100) {
						clearInterval(parentThis.interval);
						parentThis.interval = null;
						
						if(!parentThis.complete) {
							parentThis.callback();
							parentThis.complete = true;
						}
					}
					
				}, this.options.scrollInterval);
			}
			
		} else if(this.options.trigger == 'scrollUp') {
			// Let the user scroll down by some significant amount
			var scrollStart = jQuery(window).scrollTop();
			var pageHeight = jQuery(document).height();
			
			var parentThis = this;
			
			if(pageHeight > 0) {
				// Only check the scroll position every few seconds, to avoid bogging the UI
				this.interval = setInterval(function() {
					var scrollAmount = scrollStart - jQuery(window).scrollTop();
					if(scrollAmount < 0) {
						scrollAmount = 0;
						scrollStart = jQuery(window).scrollTop();
					}
					var upScrollPercent = parseFloat(scrollAmount) / parseFloat(pageHeight);
					
					if(upScrollPercent > parseFloat(parentThis.options.percentUp) / 100) {
						clearInterval(parentThis.interval);
						parentThis.interval = null;
						
						if(!parentThis.complete) {
							parentThis.callback();
							parentThis.complete = true;
						}
					}
					
				}, this.options.scrollInterval);
			}
			
		} else if(this.options.trigger == 'timeout') {
			this.timer = setTimeout(this.callback, this.options.timeout);
		}
		
    };
	
	this.cancel = function() {
		if(this.timer !== null) {
			clearTimeout(this.timer);
			this.timer = null;
		}
		
		if(this.interval !== null) {
			clearInterval(this.interval);
			this.interval = null;
		}
		
		this.complete = true;
	}

    this.init();
}

function triggerExitIntent() {
	if(Cookies2.get('exit-intent-shown') == null || typeof Cookies2.get('exit-intent-shown') == 'undefined' || Cookies2.get('exit-intent-shown') < 2) {
		// Show 
		if(Cookies2.get('exit-intent-shown') == null || typeof Cookies2.get('exit-intent-shown') == 'undefined') {
			var count = Cookies2.get('exit-intent-shown')+0;
		}
		else {
			var count = 0;
		}
		
		$('#exit-intent').show();
		
		count++;
		Cookies2.set('exit-intent-shown', count, { expires: 1 });
	}
}

function checkOtherCarts(email, carttoken) {
	if(!document.location.href.includes('https://www.smokecartel.com/cart')) {					
		$.getJSON('//warely.io/apps/multipass-login/get-carts.php?client=2&email='+email+'&check=1&token='+carttoken, function(resp) {
			if(resp.success) {
				$('#other-cart-modal').find('.btn').html('See Your '+resp.count+' Other Carts');
				$('#other-cart-modal').show();
			}
		});
	}
}

window['renderWarelyReactions'] = function(icons) {
	var $elm = $('.warely-reaction[data-id="'+window.wreaction_id+'"]');
	var idata = Object.keys(icons);
	
	if(idata.length > 0) {
		$elm.find('.warely-reactions-current').html('');
		$.each(icons, function(icon, icondata) {
			var active = '';
			if(icondata.history.includes(window.wreaction_user)) {
				active = 'active';
			}
			
			$elm.find('.warely-reactions-current').append('<button data-icon="'+icon+'" class="'+icon+' animated fadeInUp tooltip relative top '+active+'" title="'+icondata.tooltip+'">'+icon+' <span class="count">'+icondata.count+'</span></button>');
		});
		
		$elm.find('.warely-reactions-current button').click(function(event) {
			event.preventDefault();
			if(!window.wreaction_user && typeof window.Warely.fingerprint != "undefined") { window.wreaction_user = window.Warely.fingerprint; } 
			if($(this).hasClass('active')) {
				if(ismobile) {
					if($elm.find('.warely-reactions-current').find('.mobile-explain').length <= 0) {
						$elm.find('.warely-reactions-current').append('<p class="mobile mobile-explain">'+$(this).attr('title')+'</p>');
					}
					else {
						// Unreact
						$.post('//warely.io/apps/reactions/?client_id=2&id='+window.wreaction_id+'&user='+window.wreaction_user+'&action=unreact&icon='+$(this).data('icon'), function(resp) {
							window['loadWarelyReactions']();
						});
					}
				}
				else {
					// Unreact
					$.post('//warely.io/apps/reactions/?client_id=2&id='+window.wreaction_id+'&user='+window.wreaction_user+'&action=unreact&icon='+$(this).data('icon'), function(resp) {
						window['loadWarelyReactions']();
					});
				}
			}
			else {
				// React to an existing reaction
				$.post('//warely.io/apps/reactions/?client_id=2&id='+window.wreaction_id+'&user='+window.wreaction_user+'&action=addreact&icon='+$(this).data('icon'), function(resp) {
					window['loadWarelyReactions']();
				});
			}
		});
	}
}

window['loadWarelyReactions'] = function() {
	if(!window.wreaction_user && typeof window.Warely.fingerprint != "undefined") { window.wreaction_user = window.Warely.fingerprint; }
	$.getJSON('//warely.io/apps/reactions/?client_id=2&action=fetch&id='+window.wreaction_id+'&user='+window.wreaction_user, function(resp) {
		window['renderWarelyReactions'](resp.icons);
	});
}

function activateReaction() {
	$('.warely-reaction-toggle').click(function(event) {
		event.preventDefault();
		var $reaction_parent = $(this).parent().parent();
		$reaction_parent.find('.actions').hide();
		$reaction_parent.find('.loading-text').fadeIn(200);
		$.getScriptOnce('//www.smokecartel.com/cdn/shop/t/38/assets/reaction-picker.js?v=88767803492305373031733865577', function() {	
			if(!window.wreaction_user && typeof window.Warely.fingerprint != "undefined") { window.wreaction_user = window.Warely.fingerprint; }
			$reaction_parent.find('.emoji-picker-container').show();
		});
	});
}

window['loadSliderCollection'] = function() {
	$('.loadSliderCollection').each(function(i, e) {
		var col_handle = $(this).attr('data-collection');
		var details = $(this).attr('data-details'); 
		$.get('/collections/'+col_handle+'?view=load-slider', function(html) {
			var $html = $.parseHTML(html);
			$.each($html, function(j, c) {
				if(c.nodeName == 'DIV' && $(c).attr('id') == 'scroller-content') {
					$(e).find('.scroller-wrapper').prepend($(c).contents());
					$(e).removeClass('loadSliderCollection');
					activateSlider();
					activateVideo(ismobile);		
					activateCountdownMeters();
				}
			});	
			
			setTimeout(function() {
				callGTMSlider(html,details)
			},1000)
		});
	});
}

function sendPostRequest(e,t){var n=Object.keys(e).map(function(t){return encodeURIComponent(t)+"="+encodeURIComponent(e[t])}).join("&"),o=new XMLHttpRequest;o.open("POST",t,!0),o.setRequestHeader("Content-Type","application/x-www-form-urlencoded"),o.send(n)}function setCookie(e,t,n){var o="";if(n){var s=new Date;s.setTime(s.getTime()+24*n*60*60*1e3),o="; expires="+s.toUTCString()}document.cookie=e+"="+(t||"")+o+"; path=/"}function getCookie(e){for(var t=e+"=",n=document.cookie.split(";"),o=0;o<n.length;o++){for(var s=n[o];" "==s.charAt(0);)s=s.substring(1,s.length);if(0==s.indexOf(t))return s.substring(t.length,s.length)}return null}function sendPostJSON(e,t){request=new XMLHttpRequest,request.open("POST",t,!0),request.setRequestHeader("Content-type","application/json"),request.send(e)}

function logWarelyData() {
	if(window.Warely.fingerprint != 'n/a') {
		Shopify.getCart(function(cart) {
	    	window.Warely.screen_height = window.screen.availHeight;
	    	window.Warely.screen_width = window.screen.availWidth;
	    	window.ShopifyCart = cart;
	
			if(cart.hasOwnProperty('attributes') && window.Warely.hasOwnProperty('fingerprint')) { 
				if(!cart.attributes.hasOwnProperty('warely_fingerprint') || cart.attributes.warely_fingerprint != window.Warely.fingerprint) {
					// Reset Fingerprint
					sendPostJSON(JSON.stringify({ attributes : { warely_fingerprint: window.Warely.fingerprint } }), '/cart/update.js');
				}
			}
	    	
			sendPostRequest(window.Warely, "https://warely.io/shopify-app/log.php?client_id=2&session_id="+cart.token);
			sendPostJSON(JSON.stringify(window.ShopifyCart), "https://warely.io/shopify-app/log-cart.php?client_id=2");
		});
	}
}

var Warely_GLOBAL = function(e) {
	return {
		init: function() {
			if(typeof window.Warely !== "undefined") {
				// Check if has fingerprint				
				if(Cookies2.get('warely-fingerprint')) {
					// Has Fingerprint
					window.Warely.fingerprint = Cookies2.get('warely-fingerprint');
					logWarelyData();
				}
				else if(window.Warely.hasOwnProperty('fingerprint')) {
					logWarelyData();
				}
				else if(window.hasOwnProperty('ShopifyCart') && window.ShopifyCart.hasOwnProperty('attributes') && window.ShopifyCart.attributes.hasOwnProperty('warely_fingerprint')) {
					window.Warely.fingerprint = window.ShopifyCart.attributes.warely_fingerprint;
					Cookies2.set('warely-fingerprint', window.ShopifyCart.attributes.warely_fingerprint, { expires: 7 });
					logWarelyData();
				}
				else if(customer_id) {
					logWarelyData();
				}
				else {
					// Get Fingerprint	
					var s = document.createElement('script');
			        s.type = 'text/javascript';
			        s.async = true;
			        s.src = 'https://fpcdn.io/v3/hQQIv0iE2boqo7LCT0C6/iife.min.js';
			        s.onload = function() {
				        FingerprintJS.load({ token: 'hQQIv0iE2boqo7LCT0C6' }).then(fp => fp.get({extendedResult: true})).then(data => {
						    setCookie('warely-fingerprint', data.visitorId, 1);
							window.Warely.fingerprint = data.visitorId;
							window.WarelyFP = data;
							if(data.hasOwnProperty('incognito')) {
								setCookie('is_incognito', data.incognito, 1);
							}
							
							try {
								window.userloc = [];
								window.userloc.push(data.ipLocation.country.name);
								if(data.ipLocation.hasOwnProperty('city') && data.ipLocation.city.hasOwnProperty('name') && typeof data.ipLocation.city.name != 'undefined') { window.userloc.push(data.ipLocation.city.name); } else { window.userloc.push('City'); }
								window.userloc.push(data.ipLocation.subdivisions[0].name);
								setCookie('userdata', window.userloc.join(','), 1);
							}
							catch(e) { console.log(e); }
							
							logWarelyData();
					    }).catch(function(err){
							console.log(err);
						});
			        };
			        var x = document.getElementsByTagName('script')[0];
			        x.parentNode.insertBefore(s, x);					
				}
				
		    }		    
	    }
    }
}(window || {});

function checkSession() {
	if($('#no-session-check').length <= 0) {
		$.get('//www.smokecartel.com/?view=session', function(resp) {
			// console.log('Checking session: '+resp);
			
			if((window.customer_id && resp != window.customer_id) || (!window.customer_id && resp != 'not_logged_in')) {
				// Logged out, refresh
				location.reload();
			}
		});
	}
}


function checkLocation(){


	// if (!sessionStorage.getItem('pageRefreshed')) { 
	//     sessionStorage.setItem('pageRefreshed', 'true');
	//     location.reload();
	// } else { 
	//     sessionStorage.removeItem('pageRefreshed');
	// }
	//   ;(()=>{
	//   document.querySelectorAll('footer .quicklinks a').forEach((a)=>{ 
	// 	  a.addEventListener('click',function(e){
	// 		e.preventDefault(); 
	// 		window.location.href = a.getAttribute('href')
	// 	  })
	// 	})
	// 	})()
	
	//   if (localStorage.getItem('ipinfo_country')) { 
	// 	checkCountry(localStorage.getItem('ipinfo_country')) 
	//   } else { 
	// 	//   fetch('https://ipinfo.io/json?token=fe81980d04a54c')
	// 	if (navigator.userAgent.match(/bot|spider/i)) { 
	// 	 } else { 
	// 		if ("geolocation" in navigator) {
	// 			navigator.geolocation.getCurrentPosition(
	// 			  (position) => {
	// 				const lat = position.coords.latitude;
	// 				const lng = position.coords.longitude; 
			   
	// 				const url = `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lng}`;
			   
	// 				fetch(url, {
	// 				  headers: {
	// 					'User-Agent': 'YourAppName/1.0 (your.email@example.com)' // optional but recommended
	// 				  }
	// 				})
	// 				  .then((res) => res.json())
	// 				  .then((data) => {
	// 					const country = data.address?.country || "Unknown"; 
	// 					if(country == 'United States'){
	// 						localStorage.setItem('ipinfo_country','US')
	// 						localStorage.setItem('ipinfo_proviance',data.address?.state)
	// 						checkCountry('US') 
	// 					}else{
	// 						localStorage.setItem('ipinfo_country', 'null')
	// 						checkCountry('null')
	// 					}
	// 				  })
	// 				  .catch((error) => {
	// 					console.error("Error fetching country from Nominatim:", error);
	// 				  });
	// 			  },
	// 			  (error) => {
	// 				console.error("Error getting user location:", error);
	// 			  }
	// 			);
	// 		} else {
	// 			console.error("Geolocation is not supported by this browser.");
	// 			fetch("https://ipapi.co/json/?key=tg4TvAFG0CuaYJsYstd86jxoxNwTWNVIhAbHBwXt1Hgg4ZLzVx")
	// 			.then(res => res.json())
	// 			.then(data => { 
	// 				localStorage.setItem('ipinfo_country', data.country)
	// 				checkCountry(data.country) 
	// 			})
	// 		}
			 
			
	// 	}
	//   }
	
	  function checkCountry(country){ 
		// if(country == 'US'){
		//   document.querySelector('.shipping-claim').innerHTML = 'Free Shipping for orders over $50'  
		//   document.querySelector('.new_shipping_est')?.classList.add('active');  
		//   if(window.location.href.includes('products')){
			 
																																			   
		//   }
		// }else{
		//   document.querySelector('.shipping-claim').innerHTML = 'Free Shipping for orders over $50'  
		//   document.querySelector('#shipping-est')?.setAttribute('style','display:none !important')
		// }
	  }
																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																																								  
	}


function productCal(){
  // if(window.location.href.includes('products')){
    // let var_id =  document.querySelector('#shipping-est')?.getAttribute('data-id')
    // fetch(`https://warely.io/apps/marketplace/estimate-shipping.php?variant_id=${var_id}`)
    // .then(response => response.json())
    // .then(data => {
    //   console.log(data)
    // }) 

  // var shipping_est_options = {
  //     "deadline": {
  //         hour: window.deadlinehour,
  //         minute: 0
  //     }
  // };  
  // let var_id =  document.querySelector('#shipping-est')?.getAttribute('data-id')
  // $.getJSON("//warely.io/apps/marketplace/estimate-shipping.php?variant_id="+var_id, function(resp) {
  //     $('#shipping-supplier-message').html($('#shipping-supplier-message').attr('data-default'));
  //     if(resp.success) {
  //         if(resp.hasOwnProperty('leadtime')) {
  //             shipping_est_options.leadtime = resp.leadtime;
  //         }
          
  //         if(resp.hasOwnProperty('backlog')) {
  //             shipping_est_options.backlog_days = resp.backlog;
  //             if(resp.backlog > 0) {
  //                 $('#shipping-supplier-message').html('Fulfilled by <strong>'+resp.supplier+'</strong> - This vendor is experiencing shipping delays.');
  //             }
  //         }
  //     }
  //     console.log(shipping_est_options)
  //     waitForUD(shipping_est_options);
  // });



    
  //   console.log('product')
  // }
}

// Shipping Time
// function waitForUD(shipconfig){
// 	if($('#projectedtime').length <= 0) {
// 	    if(window.userloc !== "" && typeof shipconfig !== 'undefined' && typeof loadMoment == 'function') { loadMoment().then(function() { $('#shipping-time').shipTime(shipconfig); }); }
// 	    else { setTimeout(function(){ waitForUD(shipconfig); },200); }
//     }
// }


function newJSBUY(){ 
	document.querySelectorAll('.new-js-buy').length > 0 && document.querySelectorAll('.new-js-buy').forEach((jsbuy)=>{
		console.log(jsbuy.getAttribute('data-product-url'))
		fetch(jsbuy.getAttribute('data-product-url')+'/?section_id=new-js-buy').then((res)=>res.text()).then((data)=>{
			jsbuy.innerHTML = data
		})
	})
}

function newSSOPopup(){
	// console.log('clicked')
	const loginBtn = document.querySelectorAll(".SSO_popup_login");  // simple login
	const registerBtn = document.querySelectorAll(".SSO_popup_register");  // cc register
	const eliteJoinBtn = document.querySelectorAll(".SSO_popup_elite_join"); // elite register
	const eliteUpgradeBtn = document.querySelectorAll(".SSO_popup_elite_upgrade"); // cc to elite memeber


	const popup = document.getElementById('new_popup-modal2');
	const close_popup = document.querySelector('#new_popup-modal2 .close_popup');
	const overlay = document.getElementById('new_popup-overlay2');


	const mainLoginForm = document.querySelector('.main_login_form')
	const mainSignupForm = document.querySelector('.main_signup_form') 
	const mainSignupEliteForm = document.querySelector('.main_elite_signup_form') 
	const mainEliteUpgradeForm = document.querySelector('.main_elite_upgrade_form') 


	// keyboard accesscibility
	let emailInputLogin = popup.querySelector('.main_login_form input[type="email"]');
	let emailInputSignup = popup.querySelector('.main_signup_form input[type="email"]');
	let emailInputEliteSignup = popup.querySelector('.main_elite_signup_form input[type="email"]');
	let agreeInputEliteUpgrade = popup.querySelector('.main_elite_upgrade_form input[type="checkbox"]');

	

	if (!localStorage.getItem('popupClosed') ) { 
		setTimeout(() => { 
			if(localStorage.getItem('popupClosed') != 'true' && popup.getAttribute('data-customer') == 'false' ){
				openPopup2('signup_form') 
			} 
		}, 15000); 
	}

	const closePopup2 = function (firstTime = false) {
		popup.style.display = 'none';
		overlay.style.display = 'none';  

		if(firstTime) localStorage.setItem('popupClosed', 'true')
	};


	
	openPopup2 = function (form) {
		if(form == 'login_form'){
			document.querySelectorAll('.new_forms').forEach(f=>f.classList.add('new_hidden'))
			mainLoginForm.classList.remove('new_hidden')
		}else if(form == 'signup_form'){
			document.querySelectorAll('.new_forms').forEach(f=>f.classList.add('new_hidden'))
			mainSignupForm.classList.remove('new_hidden')
		}else if( form == 'signup_elite_form'){
			document.querySelectorAll('.new_forms').forEach(f=>f.classList.add('new_hidden'))
			mainSignupEliteForm.classList.remove('new_hidden')
		}else if( form == 'signup_upgrade_form'){
			document.querySelectorAll('.new_forms').forEach(f=>f.classList.add('new_hidden'))
			mainEliteUpgradeForm.classList.remove('new_hidden')
		}

		popup.style.display = 'block';
		overlay.style.display = 'block';  
	}; 


	overlay.addEventListener('click',function(){
		if (!localStorage.getItem('popupClosed') || localStorage.getItem('popupClosed') != 'true'){
			closePopup2(true)
		}else{
			closePopup2()
		}
	})
	close_popup.addEventListener('click',function(){
		if (!localStorage.getItem('popupClosed') || localStorage.getItem('popupClosed') != 'true'){ 
			closePopup2(true)
		}else{
			closePopup2()
		}
	})



	loginBtn.forEach((btn) => {
		btn.addEventListener("click", () => {
			openPopup2('login_form')
			emailInputLogin.focus();
		});
	});

	registerBtn.forEach((btn) => {
		btn.addEventListener("click", () => {
			openPopup2('signup_form')
			emailInputSignup.focus();
		});
	});

	eliteJoinBtn.forEach((btn) => {
		btn.addEventListener("click", () => {
			openPopup2('signup_elite_form')
			emailInputEliteSignup.focus();
		});
	});

	eliteUpgradeBtn.forEach((btn) => {
		btn.addEventListener("click", () => {
			openPopup2('signup_upgrade_form')
			agreeInputEliteUpgrade.focus();
		});
	});

	// const EVENT_ACTIONS = {
	// 	CLOSE_WINDOW: "CLOSE_WINDOW",
	// 	REDIRECT_SUCCESS: "REDIRECT_SUCCESS",
	// 	ELITE_REGISTER_SUCCESS: "ELITE_REGISTER_SUCCESS",
	// 	ELITE_UPGRADE: "ELITE_UPGRADE",
	//   };
	  
	//   const loginBtn = document.querySelectorAll(".SSO_popup_login");  // simple login
	//   const registerBtn = document.querySelectorAll(".SSO_popup_register");  // cc register
	//   const eliteJoinBtn = document.querySelectorAll(".SSO_popup_elite_join"); // elite register
	//   const eliteUpgradeBtn = document.querySelectorAll(".SSO_popup_elite_upgrade"); // cc to elite memeber
	  
	//   loginBtn.forEach((btn) => {
	// 	btn.addEventListener("click", () => {
	// 	  openSSOPopup("login");
	// 	});
	//   });
	  
	//   registerBtn.forEach((btn) => {
	// 	btn.addEventListener("click", () => {
	// 	  openSSOPopup("signup");
	// 	});
	//   });
	  
	//   eliteJoinBtn.forEach((btn) => {
	// 	btn.addEventListener("click", () => {
	// 	  openSSOPopup("elite/join");
	// 	});
	//   });
	  
	//   eliteUpgradeBtn.forEach((btn) => {
	// 	btn.addEventListener("click", () => {
	// 	  openSSOPopup("elite/upgrade");
	// 	});
	//   });
	  
	//   const SSU_URL = "https://sso.cabanaclubusa.com";
	//   function getCLient() {
	// 	return "iK3RgcrTBFA%2BlrzN0o0VYQ%3D%3D%3AJIo%2F3aaA6Y5YG9P7RX%2BhIjqOghYNKrm2SmN7W%2BZ4C%2B9EyDxDs01BqgRhfK52cbta";
	//   }
	  
	//   async function addEliteProductToCart() {
	// 	const id = "44844199018677";
	  
	// 	const get_cart = await getCart();
	// 	const matched_item = get_cart.items.find((item) => item.variant_id == id);
	  
	// 	if (matched_item) {
	// 	  const updates = { [id]: 1 };
	  
	// 	  try {
	// 		const response = await fetch(
	// 		  window.Shopify.routes.root + "cart/update.js",
	// 		  {
	// 			method: "POST",
	// 			headers: {
	// 			  "Content-Type": "application/json",
	// 			},
	// 			body: JSON.stringify({ updates }),
	// 		  }
	// 		);
	  
	// 		if (!response.ok) throw new Error("Failed to remove item from cart");
	  
	// 		const data = await response.json();
	// 		console.log("Item removed from cart:", data);
	// 		alert("Elite Membership Product is already in the cart");
	// 		window.location.href = "/cart";
	// 	  } catch (error) {
	// 		console.error("Error removing item from cart:", error);
	// 	  }
	// 	} else {
	// 	  const formData = {
	// 		items: [
	// 		  {
	// 			id: +id, // Ensure `id` is a number
	// 			quantity: 1,
	// 			properties: { _type: "hide" },
	// 		  },
	// 		],
	// 	  };
	  
	// 	  try {
	// 		const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
	// 		  method: "POST",
	// 		  headers: {
	// 			"Content-Type": "application/json",
	// 		  },
	// 		  body: JSON.stringify(formData),
	// 		});
	  
	// 		if (!response.ok) throw new Error("Failed to add item to cart");
	  
	// 		const data = await response.json();
	// 		window.location.href = "/cart";
	// 	  } catch (error) {
	// 		console.error("Error adding item to cart:", error);
	// 		e.target.textContent = "Error, try again";
	// 	  }
	// 	}
	//   }
	  
	//   function openSSOPopup(path) {


    //     const currentUrl = window.location.href; 
    //     const safeBase64Url = btoa(currentUrl);
        
	// 	const client = getCLient();
	// 	// Calculate dimensions based on screen size
	// 	const width = Math.min(window.innerWidth * 0.9, 600); // Max width 600px for desktop
	// 	const height = Math.min(window.innerHeight * 0.9, 700); // Max height 700px for desktop
	  
	// 	// Center the popup on the screen
	// 	const left = (window.innerWidth - width) / 2;
	// 	const top = (window.innerHeight - height) / 2;
	  
	// 	const popup = window.open(
	// 	  `${SSU_URL}/popup/${path}?client=${client}&return_to=${safeBase64Url}&parentOrigin=${encodeURIComponent(window.location.origin)}`, // Replace with your SSO URL
	// 	  "SSO_Login",
	// 	  `width=${width},height=${height},top=${top},left=${left},resizable=yes,scrollbars=yes`
	// 	);
	  
	// 	window.addEventListener("message", async function (event) {
	// 	  const eventData = event.data;
	// 	  const { action, data } = eventData;
	  
	// 	  if (eventData) {
	// 		switch (action) {
	// 		  case EVENT_ACTIONS.CLOSE_WINDOW:
	// 			popup.close();
	// 			break;
	  
	// 		  case EVENT_ACTIONS.REDIRECT_SUCCESS:
	// 			popup.close();
	// 			window.location.replace(data.redirect_link);
	// 			break;
	  
	// 		  case EVENT_ACTIONS.ELITE_REGISTER_SUCCESS:
	// 			await addEliteProductToCart();
	// 			popup.close();
	// 			window.location.replace(data.redirect_link);
	// 			break;
	  
	// 		  case EVENT_ACTIONS.ELITE_UPGRADE:
	// 			await addEliteProductToCart();
	// 			popup.close();
	// 			break;
	  
	// 		  default:
	// 			// console.log("Invalid Action type", action);
	// 			break;
	// 		}
	// 	  }
	// 	});
	//   }
	  
}

                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                    
  
$(function() {	
	!function(e){var n=!1;if("function"==typeof define&&define.amd&&(define(e),n=!0),"object"==typeof exports&&(module.exports=e(),n=!0),!n){var o=window.Cookies,t=window.Cookies=e();t.noConflict=function(){return window.Cookies=o,t}}}(function(){function e(){for(var e=0,n={};e<arguments.length;e++){var o=arguments[e];for(var t in o)n[t]=o[t]}return n}return function n(o){function t(n,r,i){var c;if("undefined"!=typeof document){if(arguments.length>1){if("number"==typeof(i=e({path:"/"},t.defaults,i)).expires){var a=new Date;a.setMilliseconds(a.getMilliseconds()+864e5*i.expires),i.expires=a}i.expires=i.expires?i.expires.toUTCString():"";try{c=JSON.stringify(r),/^[\{\[]/.test(c)&&(r=c)}catch(e){}r=o.write?o.write(r,n):encodeURIComponent(String(r)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g,decodeURIComponent),n=(n=(n=encodeURIComponent(String(n))).replace(/%(23|24|26|2B|5E|60|7C)/g,decodeURIComponent)).replace(/[\(\)]/g,escape);var s="";for(var f in i)i[f]&&(s+="; "+f,!0!==i[f]&&(s+="="+i[f]));return document.cookie=n+"="+r+s}n||(c={});for(var p=document.cookie?document.cookie.split("; "):[],d=/(%[0-9A-Z]{2})+/g,u=0;u<p.length;u++){var l=p[u].split("="),C=l.slice(1).join("=");this.json||'"'!==C.charAt(0)||(C=C.slice(1,-1));try{var g=l[0].replace(d,decodeURIComponent);if(C=o.read?o.read(C,g):o(C,g)||C.replace(d,decodeURIComponent),this.json)try{C=JSON.parse(C)}catch(e){}if(n===g){c=C;break}n||(c[g]=C)}catch(e){}}return c}}return t.set=t,t.get=function(e){return t.call(t,e)},t.getJSON=function(){return t.apply({json:!0},[].slice.call(arguments))},t.defaults={},t.remove=function(n,o){t(n,"",e(o,{expires:-1}))},t.withConverter=n,t}(function(){})});
	var Cookies2 = Cookies.noConflict();
	Cookies2.set('tab_focus', 'on', { expires: 1 });



 

	$('body').on('click','.popup',function(event) {		 
		if(event.target.getAttribute('id') == 'exit-intent'){
			event.target.innerHTML = ''
			event.target.className = ''
		}
	});
	$('body').on('click','#exit-intent .icon-cancel',function(event) {	 
		document.querySelector('#exit-intent').innerHTML = ''
		document.querySelector('#exit-intent').className = ''
	});


  
	if(!botCheck()) {
		Warely_GLOBAL.init();
		// setTimeout(newSSOPopup, 4000);
		newSSOPopup()
		newJSBUY()
		setInterval(checkSession, 60000);
		// setTimeout(checkLocation, 1000); 
		// setTimeout(ageGate, 1000);
		setInterval(productCal, 6000);

		// let old_url = window.location.href
		// setTimeout(function() {
		// 	window.dataLayer = window.dataLayer || [];
		// 	window.dataLayer.push({
		// 		event: "page_viewed", 
		// 		page_location: window.location.href, // 👉 Correct URL
		// 		page_title: document.title,
		// 		page_referrer:old_url
		// 	});
		// },200)
		
		$(window).focus(function() {
			checkSession();
			// checkLocation();
            productCal();
			newSSOPopup() 
			newJSBUY()
		});

      
	}
	
	// Check for preset info
	if(Cookies2.get('userdata') == null || typeof Cookies2.get('userdata') == 'undefined') {
		runCheck();
	}
	else {
		window.userloc = Cookies2.get('userdata').split(',');
	}
	
	var backlogtime = 0;
	var isopen = true;
	
	var $main = $("#main");
	var sstimer = 0;	
	var sstimeout = 5000;
	if(ismobile) {
		sstimeout = 8000;
	}
	
	var loaded_animation = false;
	
	$('#nexturl').attr('href', window.location.href);
	
	if(typeof no_smoothstate === "undefined") {
	$nexturllink = $('#nexturl'),
	$search = $(''),
	$searchbar = $('.searchbar-input'),
	mobilesearch = $(''),
	smoothfailcount = 0,
	$main = $('#main');
	var options = {
	prefetch: true,
	cacheLength: 2,
	forms: 'form.smoothstate',
	locationHeader: 'X-SmoothState-Location',
	blacklist: '.noss, .new-review-form, .stamped-fa, .ais-Pagination-link,.membership_link,.logout_skip',
	allowFormCaching: false,
	debug: false,
	loadingClass: 'is-loading',
	onBefore: function($currentTarget, $container) {
	    //console.log('onBefore');
	    nexturl = $currentTarget.attr('href');
	    $nexturllink.attr('href', nexturl);
	    $search.fadeOut(200);
	    $main.show();
	    $searchbar.val('');
	    
	    if(!loaded_animation && !ismobile && !botCheck()) {
	    	$('head').append('<link id="animation-css" rel="stylesheet" type="text/css" href="//www.smokecartel.com/cdn/shop/t/38/assets/animation.scss.css?v=30228545679582285931733865577">');
	    	loaded_animation = true;
	    }
	},
	onStart: {
	  duration: 200, // Duration of our animation
	  render: function ($container) {
	    //console.log('onStart');
	    // Add your CSS animation reversing class
	    $container.addClass('fadeOut animated');
	   	  
	    sstimer = setTimeout(function() {
			smoothfailcount++;
			// console.log('Failed timeout: '+smoothfailcount);
			window.location.href = nexturl;

		}, sstimeout);
		
	    // Restart your animation
	    smoothState.restartCSSAnimations();

	  }
	},
	onReady: {
	  duration: 0,
	  render: function ($container, $newContent) {
	    //console.log('onReady');
	    clearTimeout(sstimer);
	    
	    // Remove your CSS animation reversing class
	    $container.removeClass('fadeOut animated');			        
	    $container.html($newContent);
	    $('body').attr('class', $container.find('.wrapper.main-content:first').data('template'));
	    	    
	    if(typeof(pageInit) != "undefined" && isFunction(pageInit)) { 
		    try {
		        pageInit();
		    }
		    catch (e) {
			   console.log(e);
			}
		}
 
		if(typeof(wishListInit) != "undefined" && isFunction(wishListInit)) { 
		    try {
		        wishListInit();
		    }
		    catch (e) {
			   console.log(e);
			}
		}
		animateScroll();
		
		$('.popup').click(function(event) {		
			if(event.target == this) {
				$(this).fadeOut(600);
			}
			console.log(event.target.getAttribute('id'))
		});
		
		if (typeof peekaboo === "object") {
			peekaboo.observe();
		}
				
		if (typeof addthis === "object" && $('.addthis_inline_share_toolbox').length > 0) {
			try {
				addthis.layers.refresh();
			}
			catch(e) { }
		}
				


		
		

 
		if(typeof(newSSOPopup) != "undefined" && isFunction(newSSOPopup)) { 
		    try {
		        newSSOPopup();
				let old_url = window.location.href
				setTimeout(function() {
					window.dataLayer = window.dataLayer || [];
					window.dataLayer.push({
						event: "page_viewed", 
						page_location: window.location.href, // 👉 Correct URL
						page_title: document.title,
						page_referrer:old_url
					});
				},200)
				
		    }
		    catch (e) {
			   console.log(e);
			}
		}


		if(typeof(newJSBUY) != "undefined" && isFunction(newJSBUY)) { 
		    try {
		        newJSBUY();  
		    }
		    catch (e) {
			   console.log(e);
			}
		}


	  }
	},
	onAfter: function($container, $newContent) {
		window.scrollTo(0,0);		
		original_title = document.title;
		
		if(window.ga) {
	        window.ga('send', 'pageview', undefined !== window.location.pathname ? window.location.pathname : nexturl);
	    }
		
      	if(window.Warely_GLOBAL && !botCheck()) {
      		window.Warely_GLOBAL.init();
        }
        
        if(typeof(pageAfter) != "undefined" && isFunction(pageAfter)) { 
		    try {
		        pageAfter();
		    }
		    catch (e) {
			   console.log(e);
			}
		}
	}
	},
	smoothState = $('#main').smoothState(options).data('smoothState');
	window.smoothState = smoothState;
	}
	
	function initJS() {
		// Initialize Timber's JS on docready
		$(timber.init);
		
		var $overtake = $('#overtake');
		var nexturl = window.location.href;
		
		function smoothTo(href) {
			if(href.includes('http') && !(href.includes('www.smokecartel.com/') || href.includes('//smokecartel.com/')) ) {
				window.location.href = href; 
			}
			else { 
				if(typeof closeDesktopMenu != "undefined" && isFunction(closeDesktopMenu)) { 
				    try { closeDesktopMenu(); } catch (e) { console.log(e); }
				}
				
				try {
					timber.LeftDrawer.close(); 
				} catch (e) { console.log(e); }
				
				nexturl = href;
			    $nexturllink.attr('href', nexturl);
				smoothState.fetch(nexturl);
				smoothState.load(nexturl);
				$search.fadeOut(200);
				$main.show();
				$searchbar.val('');
				// mobilesearch.addClass('mbl__searchHide');
				$('#mobile-search, form.search-form .autocomplete').hide();
			}
		}
		window.smoothTo = smoothTo;
		
		// Mobile Nav Drawer
		$('#toggle-search').click(function(event) {
			event.preventDefault();
			
			if(typeof closeDesktopMenu != "undefined" && isFunction(closeDesktopMenu)) { 
			    try { closeDesktopMenu(); } catch (e) { console.log(e); }
			}
          	
          	try {
				timber.LeftDrawer.close(); 
			} catch (e) { console.log(e); }
          
			$('#mobile-search-btn').trigger('click');
			return false;
		});
	
		// Modal Buttons
		$main.on("click", ".modal-product-view", function(event) {
			event.preventDefault();
			if($(this).attr('href')) {
				var vid = '';
				if($(this).data('vid')) {
					vid = $(this).data('vid'); 
				}
				loadProductModal($(this).attr('href'), vid, $(this));
			}
		});
		
		// Map Like Button
		$main.on("click", ".like-btn,.like-product-btn-new", function(event) {
			event.preventDefault();
			var $this = $(this);
			if($this.data('pid')) {
				likeClick($this);
			}
		});
		
		$main.on("click", '.smoothto:not([href*="#"], [target="_blank"], .noss, .stamped-fa)', function(event) {
			event.preventDefault();
			
			if (event.shiftKey || event.ctrlKey || event.metaKey) {
		    	window.open($(this).attr('href'), '_blank');
		    } else {
				smoothTo($(this).attr('href'));
			}
			return false;
		});
		
		// Enable Menu Clicks
		$('header.site-header a:not([href*="#"], .noss, .stamped-fa), footer.site-footer a:not([href*="#"], .noss), #mobile-header a:not([href*="#"], .noss), #NavDrawer a:not([href*="#"], .noss)').click(function(event) {
			event.preventDefault();
			
			if (event.shiftKey || event.ctrlKey || event.metaKey) {
		    	window.open($(this).attr('href'), '_blank');
		    } else {
				smoothTo($(this).attr('href'));
			}
		});
		
		// Animate Scroll
		animateScroll();
		
		// Check hashes
		if(window.location.hash) {
	    	var hash = window.location.hash.substring(1); //Puts hash in variable, and removes the # character		
			if(hash == 'addedtolikes') {
				$.get('//api.smokecartel.com/like.php?action=reassign&cid='+customer_id, function() {
					getLikes(customer_id);
				});
				$("#liked-product-modal .content-inner .notcustomer").hide();
				$("#liked-product-modal .content-inner .customer").show();
				
				$("#liked-product-modal").show();
			}
			else if(hash == 'savedcart') {
				$('#saved-cart-modal').show();
			}
			else if(hash == 'thanks' || hash == 'ex-thanks') {
				$('#subscribe-thanks-modal').show();
			}
			else if(hash.includes('multipass=') && customer_id !== false) {
				var hashcid = hash.replace('multipass=', '')+0;
				if(hashcid != '') {
					// Check multipass hash
					// Check if landed from klayvio email
					$.post('//warely.io/apps/multipass-login/cid.php?client=2', { cid: hashcid }, function(resp) {
						var resp = jQuery.parseJSON(resp);
						if(resp.success) {
							window.location.replace(resp.url);
						}
					});
				}
			}
	  	}
	  		  	
	  	if(customer_id) {
		  	// Hide subscribe for customers
		  	// $('#email-subscribe').hide();
	  	}
	  	else if(window.location.href.includes('multipass_klaviyo=')) {
		  	// Not a customer
			// Check if landed from klayvio email
			$.getJSON('//warely.io/apps/multipass-login/klaviyo.php?client=2', function(resp) {
				if(resp.success) {
					window.location.replace(resp.url);
				}
			});
	  	}
		
		$('#checkout-direct, .showLoading').click(function() {
			showLoading();
		});
		
		$('body').on('click', 'a.chat-btn', function(event) {
			event.preventDefault();
			
			smoothTo('https://www.smokecartel.com/pages/contact-us');
		});
		 

		$('body').on('click', 'a[data-hash]', function (event) {
			if (event.shiftKey || event.ctrlKey || event.metaKey) {
		    	window.open(Base64.decode($(this).data("hash")), '_blank');
		    } else {
				smoothTo(Base64.decode($(this).data("hash")));
			}
		});
		
		$('body').on('contextmenu', 'a[data-hash]', function () {
		    $(this).attr('href', Base64.decode($(this).data("hash")));
		});
		
		// Desktop only
		if(!ismobile) {
			$.getScriptOnce('//www.smokecartel.com/cdn/shop/t/38/assets/desktop.js?v=134569915263097677311733865577', function() {
				initDesktop();
			});
		}
		
		$(window).scrollTop(0);
	}
	
	//var components_html = '//www.smokecartel.com/cdn/shop/t/38/assets/components.html?v=111603181540343972631733865318';
	var components_html = "https://www.smokecartel.com/pages/components";
	if(is_wholesale || window.customer_is_wholesale) { components_html = 'https://www.smokecartel.com/pages/wholesale-components'; }
	$.get(components_html, function(html) {
		var $html = $.parseHTML(html);
		$.each($html, function(i, c) {
			var elemid = $(c).attr('id');
			if(elemid && $('#'+elemid).length > 0) {
				$('#'+elemid).replaceWith($(c).contents());
			}
		});
		initJS();
		activateSearch();

        /*
		if(!customer_id) {
			var dtExit = new DialogTrigger(triggerExitIntent, { trigger: 'exitIntent' });			
			var dtPercentDown = new DialogTrigger(function() {
				var dtPercentUp = new DialogTrigger(triggerExitIntent, { trigger: 'scrollUp', percentUp: 10 });
			}, { trigger: 'scrollDown', percentDown: 40 });
		}
        */
		
		if (typeof peekaboo === "object") {
			peekaboo.observe();
		}
		$(window).scrollTop(0);
	});
  
	


  
    // function wishListInit(){
	// 	console.log('wishlist init') 
	// 	
	// 		let newCID = null
	// 	 
	// 	let newSID = (localStorage.getItem('sessionId') && localStorage.getItem('sessionId').split('_')[1]) || null

	// 	$.get('//warely.io/apps/wishlist/add.php', { action : 'get',  cid : newCID, sid:newSID}, function(data) {
	// 		console.log('wishlist ids',data)
	// 	});
	// }

	// wishListInit()
  

	function newCustomEvents(){
		
	}


	$('body').on('click','a.noss.new_close',function(e){
		e.preventDefault()
		$(this).parents().find('#liked-product-modal').hide()
	})
  
});



    
const getCart = async () => {
  const resp = await fetch(window.Shopify.routes.root + "cart.js", {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });
  const data = resp.json();
  return data;
};



// Load GA
(function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
(i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
})(window,document,'script','https://www.google-analytics.com/analytics.js','ga');